module.exports = [
        {
            "id": "11",
            "text": "Agriculture, foresterie, pêche et chasse",
            "keywords": "agricole agriculture animaux bois chasse connexes culture foresterie habitat l'élevage l'offre naturel pêche poissons prise recherche récolte services soutien vétérinaires",
            "children": [
                {
                    "id": "111",
                    "text": "Cultures agricoles",
                    "keywords": "agricole agricoles améliorés biologiques brut céréales céréalières classes climatiques conditions consacrent considération considérés constituée constituent cultivé culture cultures d'arbres définition d'intrant employer établissement facteurs famille fermes figurent fixation foresterie grimpantes intrants l'exception main-d'oeuvre marché matériel méthodes mis mixte modifiés nationale oléagineuses pépinières peuvent plantations plantes point première prêt pris prix processus production produit produits qualité quantité question rangé rapportent règle représente requis retrouvent rubrique scian semences serres terme terres traditionnelles utiliser vente vergers",
                    "children": [
                        {
                            "id": "1111",
                            "text": "Culture de plantes oléagineuses et de céréales",
                            "keywords": "céréales culture oléagineuses plantes production rangés semences",
                            "children": [
                                {
                                    "id": "111110",
                                    "text": "Culture du soja",
                                    "keywords": "culture soja"
                                },
                                {
                                    "id": "111120",
                                    "text": "Culture de plantes oléagineuses (sauf le soja)",
                                    "keywords": "culture fibreuses graines oléagineuses plantes produisent soja"
                                },
                                {
                                    "id": "111130",
                                    "text": "Culture de pois et de haricots secs",
                                    "keywords": "culture haricots lentilles pois secs"
                                },
                                {
                                    "id": "111140",
                                    "text": "Culture du blé",
                                    "keywords": "blé culture"
                                },
                                {
                                    "id": "111150",
                                    "text": "Culture du maïs",
                                    "keywords": "culture maïs"
                                },
                                {
                                    "id": "111160",
                                    "text": "Culture du riz",
                                    "keywords": "culture riz sauvage"
                                },
                                {
                                    "id": "111190",
                                    "text": "Autres cultures céréalières",
                                    "keywords": "céréales céréalières culture cultures fermes figurent mixte oléagineuses plantes"
                                }
                            ]
                        },
                        {
                            "id": "1112",
                            "text": "Culture de légumes et de melons",
                            "keywords": "culture légumes melons potagères production repiquer semences",
                            "children": [
                                {
                                    "id": "111211",
                                    "text": "Culture de pommes de terre",
                                    "keywords": "culture ignames pommes semence terre"
                                },
                                {
                                    "id": "111219",
                                    "text": "Autres cultures de légumes et de melons (sauf de pommes de terre)",
                                    "keywords": "culture cultures figurent légumes melons pommes potagères production repiquer semence semences terre"
                                }
                            ]
                        },
                        {
                            "id": "1113",
                            "text": "Culture de fruits et de noix",
                            "keywords": "culture fruits noix",
                            "children": [
                                {
                                    "id": "111320",
                                    "text": "Culture d'agrumes (sauf les oranges)",
                                    "keywords": "agrumes culture d'agrumes oranges"
                                },
                                {
                                    "id": "111330",
                                    "text": "Culture de noix et de fruits (sauf les agrumes)",
                                    "keywords": "agrumes culture fruits noix"
                                },
                                {
                                    "id": "111310",
                                    "text": "Culture d'oranges",
                                    "keywords": "culture d'oranges oranges"
                                }
                            ]
                        },
                        {
                            "id": "1114",
                            "text": "Culture en serre et en pépinière, et floriculture",
                            "keywords": "abri atteignent châssis coton cultivées culture divers floriculture froid lattis lorsqu'elles maturité pépinière plantes protégée retirées serre stades",
                            "children": [
                                {
                                    "id": "111411",
                                    "text": "Culture de champignons",
                                    "keywords": "champignons culture protégée"
                                },
                                {
                                    "id": "111412",
                                    "text": "Culture de cannabis sous abri",
                                    "keywords": "cannabis en culture hydroponique sous abri"
                                },
                                {
                                    "id": "111419",
                                    "text": "Autres cultures vivrières en serre",
                                    "keywords": "abri culture cultures figurent serre vivrière vivrières"
                                },
                                {
                                    "id": "111422",
                                    "text": "Floriculture",
                                    "keywords": "champ culture floriculture matériel plein produits propagation protégée"
                                },
                                {
                                    "id": "111421",
                                    "text": "Culture en pépinière et arboriculture",
                                    "keywords": "abri ans arboriculture champ courte croissance culture cycle d'arbres destinées dix ligneuses normalement pâte pépinière plantes plein production produits replanter rotation"
                                }
                            ]
                        },
                        {
                            "id": "1119",
                            "text": "Autres cultures agricoles",
                            "keywords": "agricoles arachides betterave canne coton culture cultures d'érable épices figurent foin gazon herbes houblon l'agave l'eau menthe mixtes produits récolte semences sucre tabac",
                            "children": [
                                {
                                    "id": "111910",
                                    "text": "Culture du tabac",
                                    "keywords": "culture tabac"
                                },
                                {
                                    "id": "111920",
                                    "text": "Culture du coton",
                                    "keywords": "coton culture"
                                },
                                {
                                    "id": "111930",
                                    "text": "Culture de la canne à sucre",
                                    "keywords": "canne culture sucre"
                                },
                                {
                                    "id": "111940",
                                    "text": "Culture du foin",
                                    "keywords": "culture foin graminées mélanges"
                                },
                                {
                                    "id": "111993",
                                    "text": "Culture mixte de fruits et de légumes",
                                    "keywords": "culture fruits légumes mixte"
                                },
                                {
                                    "id": "111994",
                                    "text": "Production de sirop d'érable et d'autres produits de l'érable",
                                    "keywords": "d'autres d'érable fabriquer l'érable l'érable production produits recueillir sève sirop usine"
                                },
                                {
                                    "id": "111995",
                                    "text": "Culture de cannabis en plein champ",
                                    "keywords": "culture de cannabis plein champ, culture des graines et semences de cannabis"
                                },
                                {
                                    "id": "111999",
                                    "text": "Toutes les autres cultures agricoles diverses",
                                    "keywords": "agricole agricoles culture cultures diverses figurent fruits légumes mixte produits"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "112",
                    "text": "Élevage et aquaculture",
                    "keywords": "animale animaux bâtiments classes considération considérés constituée définition d'élevage d'engraissement d'intrant d'origine élevage établissement facteurs famille fermes figurent l'élevage l'engraissement main-d'oeuvre matériel mixte nationale parcs pâturages pris production produit produits qualité quantité question ranchs rangé rapportent représente requis rubrique scian spécialisés types",
                    "children": [
                        {
                            "id": "1121",
                            "text": "Élevage de bovins",
                            "keywords": "bovins élevage l'élevage l'engraissement traite",
                            "children": [
                                {
                                    "id": "112110",
                                    "text": "Élevage de bovins de boucherie, y compris l'exploitation de parcs d'engraissement",
                                    "keywords": "boucherie bovins d'engraissement élevage laitier l'élevage l'engraissement l'exploitation parcs renouvellement troupeau vue"
                                },
                                {
                                    "id": "112120",
                                    "text": "Élevage de bovins laitiers et production laitière",
                                    "keywords": "bovins élevage laitière laitiers production traite"
                                }
                            ]
                        },
                        {
                            "id": "112210",
                            "text": "Élevage de porcs",
                            "keywords": "élevage l'élevage porcs"
                        },
                        {
                            "id": "1123",
                            "text": "Élevage de volailles et production d'oeufs",
                            "keywords": "d'abattage d'oeufs élevage l'accouvage l'élevage pondeuses production reproduction volaille volailles",
                            "children": [
                                {
                                    "id": "112310",
                                    "text": "Production d'oeufs de poules",
                                    "keywords": "d'incubation d'oeufs l'élevage oeufs poules production vue"
                                },
                                {
                                    "id": "112320",
                                    "text": "Élevage de poulets à griller et d'autres volailles d'abattage",
                                    "keywords": "d'abattage destinés élevage griller l'abattage l'élevage poulets volailles"
                                },
                                {
                                    "id": "112330",
                                    "text": "Élevage de dindons",
                                    "keywords": "dindons élevage l'élevage"
                                },
                                {
                                    "id": "112340",
                                    "text": "Couvoirs",
                                    "keywords": "couvoirs l'accouvage volailles"
                                },
                                {
                                    "id": "112391",
                                    "text": "Élevage de volailles combiné à la production d'oeufs",
                                    "keywords": "activité combiné d'oeufs d'oeufs élevage l'abattage l'élevage lorsqu'aucune mixte prédomine production volailles"
                                },
                                {
                                    "id": "112399",
                                    "text": "Élevage de toutes autres volailles",
                                    "keywords": "autruches cailles canards élevage émeus faisans figurent l'élevage oies volailles"
                                }
                            ]
                        },
                        {
                            "id": "1124",
                            "text": "Élevage de moutons et de chèvres",
                            "keywords": "agneaux chèvres élevage l'alimentation l'élevage l'engraissement moutons",
                            "children": [
                                {
                                    "id": "112420",
                                    "text": "Élevage de chèvres",
                                    "keywords": "chèvres élevage l'élevage"
                                },
                                {
                                    "id": "112410",
                                    "text": "Élevage de moutons",
                                    "keywords": "agneaux d'agneaux élevage l'alimentation l'élevage l'engraissement moutons"
                                }
                            ]
                        },
                        {
                            "id": "112510",
                            "text": "Aquaculture",
                            "keywords": "activité appelée aquaculture aquaponique aquatiques artificiels avoir bassins culture d'animaux d'eau d'intervention donnée elle entreprises forme lieu l'objet naturels plans plantes processus production rehausser tant"
                        },
                        {
                            "id": "1129",
                            "text": "Autres types d'élevage",
                            "keywords": "abeilles animal animale animaux chats chevaux chevreuils chiens classes compagnie comprise d'animaux d'apiculture d'élevage d'origine équidés fabrication familiers figurent fourrure grillons laboratoire lamas lapins l'élevage lorsqu'aucun maison miel mixte oiseaux prédomine produits rangés types vers",
                            "children": [
                                {
                                    "id": "112920",
                                    "text": "Élevage de chevaux et d'autres équidés",
                                    "keywords": "chevaux d'ânes élevage équidés l'élevage mules"
                                },
                                {
                                    "id": "112910",
                                    "text": "Apiculture",
                                    "keywords": "apiculture d'abeilles d'apiculture l'élevage miel récolte travaux"
                                },
                                {
                                    "id": "112930",
                                    "text": "Élevage d'animaux à fourrure et de lapins",
                                    "keywords": "d'animaux élevage fourrure lapins l'élevage"
                                },
                                {
                                    "id": "112991",
                                    "text": "Élevage mixte d'animaux",
                                    "keywords": "animal classes d'animaux élevage l'élevage mixte prédomine qu'aucun rangés"
                                },
                                {
                                    "id": "112999",
                                    "text": "Tous les autres types d'élevage divers",
                                    "keywords": "d'animaux d'élevage divers figurent l'élevage types"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "113",
                    "text": "Foresterie et exploitation forestière",
                    "keywords": "agricoles aiguilles ans avant bois branche caractérisé caractérisées classes climatiques comprise conditions conséquent convenables court croissance culture cultures cycle d'activité d'arbres davantage dépend dernières d'essences destiné différentes disponibles distingue diverses dix durée échelle effectuée espagnole espèces essences étapes exploitation foresterie forestière forestières forestiers forêts gomme horticole importante inférieure intervention laquelle l'écorce long longue lorsqu'elle l'utilisation matériel maturation mousse naturelles nécessite nécessitent noël pendant pépinières période petite plan procédés production produits propre rangée récolte reforestation régionales retrouve sapin s'apparentent s'appuient semis spécialisé spécialisées spécialisent terres très",
                    "children": [
                        {
                            "id": "113110",
                            "text": "Exploitation de terres à bois",
                            "keywords": "bois debout exploitation l'exploitation terres vente vue"
                        },
                        {
                            "id": "113210",
                            "text": "Pépinières forestières et récolte de produits forestiers",
                            "keywords": "appel arbres culture distincts faisant fins forestières forestiers pépinières procédés production produits récolte reforestation"
                        },
                        {
                            "id": "1133",
                            "text": "Exploitation forestière",
                            "keywords": "bois brut compte copeaux coupe d'oeuvre équarri exploitation fendu forestière forêt première production propre rond transformation transport",
                            "children": [
                                {
                                    "id": "113311",
                                    "text": "Exploitation forestière (sauf à forfait)",
                                    "keywords": "bois brut copeaux coupe d'oeuvre équarri exploitation fendu forestière forêt forfait première production rond transformation transport"
                                },
                                {
                                    "id": "113312",
                                    "text": "Exploitation forestière à forfait",
                                    "keywords": "bois brut contractuelles copeaux coupe d'ententes d'oeuvre équarri exploitation fendu forestière forêt forfait première production rémunération rond transformation transport vertu"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "114",
                    "text": "Pêche, chasse et piégeage",
                    "keywords": "adaptés adéquat animaux bateaux capture chasse compte configuration conservation continue contraintes d'activité disponibilité économique équipement exigences existent gamme généralement habitat imposées large l'habitat maintien naturel naturelles nécessite nécessitent pêche piégeage plan poisson poissons prise procédés production raison rangés recours ressources sauvages similitudes spécialisés taille tenu transport tributaires",
                    "children": [
                        {
                            "id": "1141",
                            "text": "Pêche",
                            "keywords": "animaux aquatiques capture commerciales crustacés fins habitat mollusques naturel pêche poissons prise",
                            "children": [
                                {
                                    "id": "114113",
                                    "text": "Pêche en eau salée",
                                    "keywords": "capture crustacés eau mer mollusques moyens pêche piégeage poisson prise produits récolte salée types"
                                },
                                {
                                    "id": "114114",
                                    "text": "Pêche en eau douce",
                                    "keywords": "capture crustacés d'eau douce eaux intérieures mollusques pêche poissons prise produits récolte"
                                }
                            ]
                        },
                        {
                            "id": "1142",
                            "text": "Chasse et piégeage",
                            "keywords": "chasse commerciales commerciaux fins gestion gibier l'exploitation parcs piégeage",
                            "children": [
                                {
                                    "id": "114210",
                                    "text": "Chasse et piégeage",
                                    "keywords": "chasse commerciales commerciaux fins gestion gibier l'exploitation parcs piégeage"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "115",
                    "text": "Activités de soutien à l'agriculture et à la foresterie",
                    "keywords": "agricole essentiels foresterie forestière l'agriculture offrir production services soutien",
                    "children": [
                        {
                            "id": "115110",
                            "text": "Activités de soutien aux cultures agricoles",
                            "keywords": "agricoles cultures offrir services soutien"
                        },
                        {
                            "id": "115210",
                            "text": "Activités de soutien à l'élevage",
                            "keywords": "animaux l'élevage maison offrir services soutien"
                        },
                        {
                            "id": "115310",
                            "text": "Activités de soutien à la foresterie",
                            "keywords": "bois foresterie offrir particuliers récolte services soutien"
                        }
                    ]
                }
            ]
        },
        {
            "id": "21",
            "text": "Extraction minière, exploitation en carrière, et extraction de pétrole et de gaz",
            "keywords": "biens brut cadre carrière carrières charbon concassage concentration contractuelles criblage d'ententes d'origine englober exploitation extraction façon flottation gaz généralement l'aménagement large lavage l'exploitation l'exploration l'extraction liquides livrent mine minerai minerais minérale minérales minière miniers naturel naturelle pétrole préparations puits rémunération s'agir sens similaires solides substances terme utilisé vertu",
            "children": [
                {
                    "id": "2111",
                    "text": "Extraction de pétrole et de gaz",
                    "keywords": "agents bitumineux brut champs charbon collecte complétion dégravement d'émulsion d'hydrocarbures effectués expédition exploité extraction forage gaz gazéification gazière gisement gisements jusqu'au l'équipement l'exploitation l'exploration l'extraction liquéfaction liquides matériel mine mise moment pétrole pétrolière préparation procédés production puits pyrolyse réseau rupture sables schiste séparateurs service",
                    "children": [
                        {
                            "id": "211110",
                            "text": "Extraction de pétrole et de gaz (à l’exception des sables bitumineux)",
                            "keywords": "exploitation batterie réservoir base contractuelle industrie pétrolière gazière forage achèvement équipement puits mise service séparateurs agents rupture émulsion matériel dégravement réseau collecte pétrole brut autres activités préparation gaz naturel expédition gisement exploité production extraction gisements schiste hydrocarbures liquides procédés gazéification liquéfaction pyrolyse charbon mine bitumineux fractionnement liquides site minier butane éthane isobutane propane naturels liquéfié GPL méthodes classiques récupération stations épuration"
                        },
                        {
                            "id": "211141",
                            "text": "Extraction in situ de sables bitumineux",
                            "keywords": "extraction in situ bitume pétrole brut sables bitumineux thermique lourd synthétique production minière récupération drainage expansion gaz dissous"
                        },
                        {
                            "id": "211142",
                            "text": "Extraction minière de sables bitumineux",
                            "keywords": "excavation sables bitumineux exploitation minière extraction pétrole bitume brut"
                        }
                    ]
                },
                {
                    "id": "212",
                    "text": "Extraction minière et exploitation en carrière (sauf l'extraction de pétrole et de gaz)",
                    "keywords": "carrière charbon exploitation extraction gaz l'enrichissement l'extraction métalliques minéraux minière pétrole préparation",
                    "children": [
                        {
                            "id": "2121",
                            "text": "Extraction de charbon",
                            "keywords": "appelées biais bitumineux charbon ciel d'anthracite d'extraction exploitées extraction installations lavoirs l'échantillonnage l'exploitation l'extraction lignite méthodes mine minières nettoyage opérations ouvert pair poussier préparation soient souterraine surface tarière",
                            "children": [
                                {
                                    "id": "212114",
                                    "text": "Extraction de charbon bitumineux",
                                    "keywords": "appelées bitumineux charbon exploitées extraction installations lavoirs l'extraction mine minières nettoyage opérations pair préparation soient"
                                },
                                {
                                    "id": "212115",
                                    "text": "Extraction de charbon subbitumineux",
                                    "keywords": "appelées charbon exploitées extraction installations lavoirs l'extraction mine minières nettoyage opérations pair préparation soient subbitumineux"
                                },
                                {
                                    "id": "212116",
                                    "text": "Extraction de charbon de lignite",
                                    "keywords": "appelées charbon exploitées extraction installations lavoirs l'extraction lignite mine minières nettoyage opérations pair préparation soient"
                                }
                            ]
                        },
                        {
                            "id": "2122",
                            "text": "Extraction de minerais métalliques",
                            "keywords": "agglomèrent broient calcinent concassent d'enrichissement desservies distincte effectuant effectuent exploitées extraction façon flottation gravitaire installations lavent l'extraction lixivient métalliques minerai minerais minéraux mines opérations pair sèchent séparation traitement usines",
                            "children": [
                                {
                                    "id": "212210",
                                    "text": "Extraction de minerais de fer",
                                    "keywords": "agglomérats associés extraction fer fourneaux hauts l'enrichissement l'exception l'extraction manganésifères minerais opérations préparation principalement produisent recherchés sinter teneur"
                                },
                                {
                                    "id": "212220",
                                    "text": "Extraction de minerais d'or et d'argent",
                                    "keywords": "argent d'argent d'or etou extraction l'enrichissement l'extraction minerais préparation principalement recherchés teneur"
                                },
                                {
                                    "id": "212231",
                                    "text": "Extraction de minerais de plomb-zinc",
                                    "keywords": "extraction l'enrichissement l'extraction minerais plomb plomb-zinc préparation zinc"
                                },
                                {
                                    "id": "212232",
                                    "text": "Extraction de minerais de nickel-cuivre",
                                    "keywords": "etou extraction l'enrichissement l'extraction minerais nickel nickel-cuivre préparation"
                                },
                                {
                                    "id": "212233",
                                    "text": "Extraction de minerais de cuivre-zinc",
                                    "keywords": "concentrés cuivre cuivre-zinc etou extraction l'enrichissement l'extraction lixiviation minerai minerais précipitation préparation récupération"
                                },
                                {
                                    "id": "212291",
                                    "text": "Extraction de minerais d'uranium",
                                    "keywords": "d'uranium d'uranium-radium-vanadium extraction l'enrichissement l'extraction minerais préparation"
                                },
                                {
                                    "id": "212299",
                                    "text": "Extraction de tous les autres minerais métalliques",
                                    "keywords": "extraction figurent l'enrichissement l'extraction métalliques minerais préparation"
                                }
                            ]
                        },
                        {
                            "id": "2123",
                            "text": "Extraction de minerais non métalliques",
                            "keywords": "broyage carrière charbon concassage extraction lavage l'extraction métalliques minerais minière première préparation procèdent usines",
                            "children": [
                                {
                                    "id": "212314",
                                    "text": "Extraction de granite",
                                    "keywords": "blocs carrière concassé connexes dalles dégrossis extraction granite l'extraction minière roches taille"
                                },
                                {
                                    "id": "212315",
                                    "text": "Extraction de calcaire",
                                    "keywords": "blocs broyage calcaire carrière concassé connexes dalles dégrossis extraction l'extraction minière pulvérisation roches taille"
                                },
                                {
                                    "id": "212316",
                                    "text": "Extraction de marbre",
                                    "keywords": "blocs carrière concassé dalles d'ardoise dégrossis extraction l'extraction marbre minière taille"
                                },
                                {
                                    "id": "212317",
                                    "text": "Extraction de grès",
                                    "keywords": "blocs carrière concassé dalles dégrossis extraction grès l'extraction minière taille"
                                },
                                {
                                    "id": "212323",
                                    "text": "Extraction de sable et de gravier",
                                    "keywords": "carrières criblage dragage extraction gravier lavage l'exploitation préparation sable"
                                },
                                {
                                    "id": "212326",
                                    "text": "Extraction de schiste, d'argile et de minerais réfractaires",
                                    "keywords": "argileux briques carrière céramiques ciment connexes d'argile disponibles distincts exploitées extraction fabrication figuline kaolin l'argile l'enrichissement l'extraction matériaux minerais mines minière pair poteries préparation produits rapports réfractaires schiste types usines"
                                },
                                {
                                    "id": "212392",
                                    "text": "Extraction de diamant",
                                    "keywords": "diamant extraction l'enrichissement l'extraction préparation"
                                },
                                {
                                    "id": "212393",
                                    "text": "Extraction de sel",
                                    "keywords": "extraction gemme l'extraction partir puits récupération salants sel"
                                },
                                {
                                    "id": "212394",
                                    "text": "Extraction d'amiante",
                                    "keywords": "d'amiante extraction l'amiante l'enrichissement l'extraction préparation"
                                },
                                {
                                    "id": "212395",
                                    "text": "Extraction de gypse",
                                    "keywords": "extraction gypse l'enrichissement l'extraction préparation"
                                },
                                {
                                    "id": "212396",
                                    "text": "Extraction de potasse",
                                    "keywords": "extraction l'enrichissement l'extraction potasse préparation"
                                },
                                {
                                    "id": "212397",
                                    "text": "Extraction de tourbe",
                                    "keywords": "extraction l'extraction tourbe traitement"
                                },
                                {
                                    "id": "212398",
                                    "text": "Extraction de tous les autres minerais non métalliques",
                                    "keywords": "extraction figurent l'enrichissement l'extraction métalliques minerais préparation"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "2131",
                    "text": "Activités de soutien à l'extraction minière, pétrolière et gazière",
                    "keywords": "carrière classiques contractuelles couvre d'échantillons d'ententes gaz géologiques l'exploration l'extraction méthodes minerai minéraux minière observations pétrole prélèvement prestation prospection rémunération requis services sites soutien vertu visant",
                    "children": [
                        {
                            "id": "213111",
                            "text": "Forage à forfait de puits de pétrole et de gaz",
                            "keywords": "cadre champs compte contractuelles d'autrui d'ententes forage forfait gaz l'exploitation pétrole puits rémunération vertu"
                        },
                        {
                            "id": "213117",
                            "text": "Forage à forfait (sauf de puits de pétrole et de gaz)",
                            "keywords": "d'essai diamant forage forfait gaz l'exception minéraux pétrole prospection puits sondage types visant"
                        },
                        {
                            "id": "213118",
                            "text": "Services relatifs à l'extraction de pétrole et de gaz",
                            "keywords": "compte contractuelles d'autrui d'ententes forage forfait gaz l'extraction pétrole prestation rémunération services vertu"
                        },
                        {
                            "id": "213119",
                            "text": "Autres activités de soutien à l'extraction minière",
                            "keywords": "acquis biais carottes compte contractuelles d'autrui d'ententes d'exploration d'obtenir effectué entreprises figurent forage forfait l'exploration l'extraction minéraux minière permettant prestation rémunération services sondage soutien spécialisés vertu visant"
                        }
                    ]
                }
            ]
        },
        {
            "id": "22",
            "text": "Services publics",
            "keywords": "assurent conduites connexes d'eau d'électricité d'installations distribution eaux égouts fourniture gaz gestion infrastructure l'eau l'entremise l'exploitation naturel permanente production publics services traitement transformation transport tuyauteries usées usines",
            "children": [
                {
                    "id": "2211",
                    "text": "Production, transport et distribution d'électricité",
                    "keywords": "bloc centrales centres d'électricité distribuer distribution électricité etou finals jusqu'aux l'électricité production produire transport transporter utilisateurs",
                    "children": [
                        {
                            "id": "221111",
                            "text": "Production d'hydroélectricité",
                            "keywords": "d'hydroélectricité hydraulique installations l'électricité l'énergie partir pompée production produire produisent réserve"
                        },
                        {
                            "id": "221112",
                            "text": "Production d'électricité à partir de combustibles fossiles",
                            "keywords": "charbon classiques combustibles combustion d'électricité fossiles gaz interne l'électricité moyen partir pétrole production produire systèmes turbines vapeur"
                        },
                        {
                            "id": "221113",
                            "text": "Production d'électricité d'origine nucléaire",
                            "keywords": "centrales d'électricité d'origine l'électricité nucléaire nucléaires partir production produire"
                        },
                        {
                            "id": "221119",
                            "text": "Autres activités de production d'électricité",
                            "keywords": "d'électricité éolienne figurent l'électricité l'énergie marémotrice production produire servant solaire"
                        },
                        {
                            "id": "221121",
                            "text": "Transport et gestion d'électricité en bloc",
                            "keywords": "bloc centre coordonnent d'électricité derniers distribuer distribution entre facilitent gèrent gestion intégrante l'électricité lignes moyens organisent partie production publics s'effectue sein services source système transformateurs transport transporter"
                        },
                        {
                            "id": "221122",
                            "text": "Distribution d'électricité",
                            "keywords": "centrales consommateurs courtiers d'électricité d'énergie distribuer distribution électricité éventuellement exploités individuels intégrante l'électricité l'entremise lignes négociants négocient partie réseaux s'effectue spécialisées système transformateurs usagers vente"
                        }
                    ]
                },
                {
                    "id": "221210",
                    "text": "Distribution de gaz naturel",
                    "keywords": "canalisations consommateurs distribuer distribution exploités gaz l'entremise marchands moyen naturel négociants négocient réseau réseaux synthétique vente"
                },
                {
                    "id": "2213",
                    "text": "Réseaux d'aqueduc et d'égout et autres",
                    "keywords": "connexes d'aqueduc d'aqueducs d'égout d'égouts exploiter réseaux systèmes",
                    "children": [
                        {
                            "id": "221310",
                            "text": "Réseaux d'aqueduc et systèmes d'irrigation",
                            "keywords": "captage d'aqueduc d'irrigation distribution domestiques exploiter fins industrielles l'eau réseaux systèmes traitement"
                        },
                        {
                            "id": "221320",
                            "text": "Installations d'épuration des eaux usées",
                            "keywords": "collecte déchets d'égouts d'épuration eaux exploiter installations l'élimination réseaux traitement usées usines"
                        },
                        {
                            "id": "221330",
                            "text": "Production de vapeur et conditionnement de l'air",
                            "keywords": "chauffé conditionnement distribuer etou l'air production produire refroidi vapeur"
                        }
                    ]
                }
            ]
        },
        {
            "id": "23",
            "text": "Construction",
            "keywords": "acceptées afin agence appel appelé appellations architecturale arrangements assumé assurer autrui avant bâtiment bâtiments celui certains charge civil classé classés clé client combinant compétences compte concepteur-constructeur concepteurs-constructeurs conception conception-construction conséquent constructeur constructeurs construction constructions construire construit construite contrat d'abord d'assurer degré d'entrepreneur dépend dépendant d'équipement désignation désignés d'établissements différences différente d'immeubles d'importants directement distinctions distingue distinguer dit diverses divisé doit domaine domaines donnant donné d'ordonnancement d'ouvrages effectifs effectuer elles-mêmes employés encore entreprend entrepreneur entrepreneurs entreprise entreprises essentiellement établissement études exécutés exercer existants existe exploitant exploitants faisabilité faisant financement financière financiers fins fonctions formant général généralement généraux génie gestion grands immobilière importantes intégrée intrants l'aménagement l'ampleur l'électricité l'ensemble l'entrepreneur l'entreprise l'équipement l'établissement l'exécution liés lotissement maçonnerie main main-d'oeuvre marchand métier milieu nature nécessitant nécessitent neuves oeuvrent offert offrent ouvrages ouvriers parfois particulier partie peinture pendant peuvent placés plusieurs portant présentent principal principales processus production professionnelles projet projets promotion propre proprement propres propriétaire propriétaires question qu'un réalisent réalisés regroupés rénovation réparation requis résidentielle respecter responsabilité responsables risque routes rubrique s'agir savoir sélection semblables séparé service services seul signe soient soumission sous-jacentes sous-secteurs sous-traitance sous-traitant sous-traitants sous-traite sous-traitent spécialisent spécialisés spécialités spéculateur spéculateurs structure structures supervision technique tenir terrain titre totalité tout toutefois travaillent travailler travaux types unique utilisée variations vendre vente vertu",
            "children": [
                {
                    "id": "236",
                    "text": "Construction de bâtiments",
                    "keywords": "bâtiments classés commerciale construction constructions construire d'ouvrages entrepreneurs existants fonction industrielle l'assemblage nature neuves panneaux partie peuvent place préfabriqués première prémoulés production réaliser rénovation réparation résidentielle responsables sous-traités spécialisés temporaires tout travaux vocation",
                    "children": [
                        {
                            "id": "236110",
                            "text": "Construction résidentielle",
                            "keywords": "bâtiments concepteurs-constructeurs construction constructions construire entrepreneurs entreprises exploitants généraux gestion multifamiliales remodeler rénover résidentielle résidentielles résidentiels spécialisés travaux unifamiliales"
                        },
                        {
                            "id": "236210",
                            "text": "Construction de bâtiments et de structures à usage industriel",
                            "keywords": "additionnelles ajouts bâtiments certaines cimenteries concepteurs-constructeurs construction construire entrepôts entrepreneurs entreprises ex exploitants fourneaux généraux gestion hauts importantes incinérateurs incluse industriel industriels neufs ouvrages p procédés production retrouve s'apparentant similaires spécialisés structures transformations travaux usage"
                        },
                        {
                            "id": "236220",
                            "text": "Construction de bâtiments à usage commercial et institutionnel",
                            "keywords": "ajouts bâtiments céréales chargés commercial commerciaux concepteurs-constructeurs connexes construction construire entrepreneurs entreprises exploitants généraux gestion importantes industrialisés institutionnel institutionnels intérieures l'assemblage neufs ouvrages piscines place préfabriqués silos spécialisés stades structures transformations travaux usage"
                        }
                    ]
                },
                {
                    "id": "237",
                    "text": "Travaux de génie civil",
                    "keywords": "activité additionnelles améliorer autoroutes barrages bâtiments celui-ci civil classée classés compétences complets construction construire construisent d'ajout d'amélioration démarcation diverses domaine donc d'ouvrages dragage drainage effectuent effectuer électriques éléments entrepreneurs équipement espaces ex existants faut feux fournir fournissent généralement génie grande grands infrastructures lignes l'installation lotissement maintenance mêmes nécessite n'est normalement nouveaux ouvrages p parcs partie peindre peuvent projets propre publics rapport réparation requis ressources routes selon semblables sentiers services signalisation spécialisé spécialisés spécifiques structures terrain transformation travaux types utiliser visant",
                    "children": [
                        {
                            "id": "237110",
                            "text": "Construction d'aqueducs et d'égouts et structures connexes",
                            "keywords": "associées bâtiments canalisations comprendre conduites connexes construction construire d'aqueducs d'eau d'égout d'égouts d'épuration d'ouvrages eaux ex incluse intégrante l'eau neufs p partie peuvent pompage reconstruction réfection réparations réseaux réservoirs spécialisées stations structures traitement travaux usines"
                        },
                        {
                            "id": "237120",
                            "text": "Construction d'oléoducs et de gazoducs et structures connexes",
                            "keywords": "associées bâtiments canalisations comprendre conduites connexes construction construire d'oléoducs ex gaz gazoducs incluse intégrante neufs oléoducs ouvrages p partie pétrole peuvent pompage raffineries réalisés reconstruction réfection réparations réseaux réservoirs spécialisées stations structures travaux"
                        },
                        {
                            "id": "237130",
                            "text": "Construction de lignes de transmission d'énergie électrique et de télécommunication et structures connexes",
                            "keywords": "associées bâtiments centrales communication communications comprendre connexes construction construire d'alimentation d'émissionréception d'énergie électrique ex hydroélectriques incluse intégrante lignes nouveaux ouvrages p partie peuvent radio réalisés reconstruction réfection réparations réseaux sous-stations spécialisées structures télécommunication télécommunications télévision tours transmission travaux"
                        },
                        {
                            "id": "237210",
                            "text": "Lotissement de terrains",
                            "keywords": "bien chantiers commerciaux comportant constructeurs construction créés d'améliorations déboisement d'excavation d'infrastructures diviser effectuent ensuite industriels l'amélioration l'ampleur l'autre lotissement officielle parcs peuvent physique physiques précède projet publics résidentiels routes s'accompagne services subdivision suite terrains travaux uniquement varie vendre viabilisation viabiliser"
                        },
                        {
                            "id": "237310",
                            "text": "Construction de routes, de rues et de ponts",
                            "keywords": "associées autoroutes comprendre construction construire d'aéroport ex installation neufs ouvrages p peuvent pistes ponts rambardes réalisés reconstruction réfection réparations routes rues spécialisées surélevées travaux trottoirs voies"
                        },
                        {
                            "id": "237990",
                            "text": "Autres travaux de génie civil",
                            "keywords": "air associées civil comprendre construction d'ouvrage dragage drainage eau enfoncement ex génie installations l'aménagement marins maritimes neufs ouvrages p parcs peuvent pieux plein portant projets rangés réaliser réalisés reconstruction récréatifs réfection réparations ressources sentiers spécialisées travaux"
                        }
                    ]
                },
                {
                    "id": "238",
                    "text": "Entrepreneurs spécialisés",
                    "keywords": "- acceptées acier afin ajouts aspect atelier bâtiment bâtiments béton biens certains chantier chargés chaudières civil classées classés comprendre construction contrat couvrent d'établissements directement distinctions donné effectuent effectuer éléments elles-mêmes entrepreneur entrepreneur-exploitant entrepreneurs entreprises équipements eux-mêmes ex fabrication fabriquent finition fondations général généralement génie initiale installent l'électricité l'équipement l'installation maçonnerie maintenance monte-charge neufs nouvelle ouvrages p peinture peuvent plupart préfabriqué première préparation projet projets propriétaire réalisation réalisés rénovation réparation réparations requis respecter s'ils spécialisées spécialisés structuraux structures systèmes terrain toutefois transformations travaillent travailler travaux types vue",
                    "children": [
                        {
                            "id": "2381",
                            "text": "Entrepreneurs en travaux de fondations, de structure, et d'extérieur de bâtiment",
                            "keywords": "ajouts base bâtiment bâtiments c-à-d charpente comprendre coquille d'extérieur entrepreneurs fondation fondations maintenance neufs ouvrages peuvent réaliser réalisés réparations structure transformations travaux",
                            "children": [
                                {
                                    "id": "238110",
                                    "text": "Entrepreneurs en travaux de fondations et de structure en béton coulé",
                                    "keywords": "ajouts béton comprendre coulé couler coulis effectuant éléments entrepreneurs finir fondations gunitage l'injection maintenance neufs ouvrages peuvent réalisés réparations structuraux structure transformations travaux"
                                },
                                {
                                    "id": "238120",
                                    "text": "Entrepreneurs en montage de charpentes d'acier et mise en place de béton préfabriqué",
                                    "keywords": "acier afin ajouts assemblage assembler barres béton cages charpentes composantes comprendre construction coulé d'acier d'armature éléments entrepreneurs ériger etou ex faits installation maintenance mise montage neufs ouvrages p peuvent place poutres préfabriqué produits réalisés renforcer réparations similaires structuraux tiges transformations travaux treillis"
                                },
                                {
                                    "id": "238130",
                                    "text": "Entrepreneurs en charpenterie",
                                    "keywords": "ajouts bâtiments béton charpenterie comprendre entrepreneurs ériger l'acier l'aide maintenance matériaux mettre neufs ouvrages peuvent place réalisés réparations revêtement structure transformations travaux"
                                },
                                {
                                    "id": "238140",
                                    "text": "Entrepreneurs en travaux de maçonnerie",
                                    "keywords": "ajouts brique comprendre connexes effectuer entrepreneurs maçonnerie maintenance neufs ouvrages peuvent pierre poser réalisés réparations revêtements transformations travaux"
                                },
                                {
                                    "id": "238150",
                                    "text": "Entrepreneurs en travaux de vitrage et de vitrerie",
                                    "keywords": "ajouts bâtiments c-à-d comprendre connexes entrepreneurs installer maintenance neufs ouvertures ouvrages panneaux peuvent préparer réalisés réparations transformations travaux verre vitrage vitrerie"
                                },
                                {
                                    "id": "238170",
                                    "text": "Entrepreneurs en travaux de parements",
                                    "keywords": "ajouts aluminium bois brique comprendre descente eaux entrepreneurs exception extérieure finition gouttières installent installer maintenance matériaux murs-rideaux neufs ouvrages parements peuvent pierre pluviales réalisés réparations stuc transformations travaux tuyaux vinyle"
                                },
                                {
                                    "id": "238160",
                                    "text": "Entrepreneurs en travaux de toiture",
                                    "keywords": "ajouts c-à-d comprendre effectuer entrepreneurs installer lumière maintenance neufs ouvrages peinture peuvent puits pulvérisation réalisés réparations revêtement spécialisés toiture toitures traitement transformations travaux"
                                },
                                {
                                    "id": "238190",
                                    "text": "Entrepreneurs en autres travaux de fondations, de structure, et d'extérieur de bâtiment",
                                    "keywords": "ajouts bâtiment bâtiments comprendre d'extérieur effectuer entrepreneurs extérieure figurent finition fondation fondations maintenance neufs ouvrages peuvent réalisés réparations structure transformations travaux"
                                }
                            ]
                        },
                        {
                            "id": "2382",
                            "text": "Entrepreneurs en installation d'équipements techniques ",
                            "keywords": "ajouts ascenseurs aspirateur bâtiment central chauffage comprendre construction d'équipements eau électricité entrepreneurs entretenir équipements ex installations installent installer intégrante l'équipement maintenance mécanique monte-charge nettoyage neufs ouvrages p partie peuvent réalisés refroidissement réparations spécialisé stations-service système systèmes techniques transformations travaux",
                            "children": [
                                {
                                    "id": "238210",
                                    "text": "Entrepreneurs en travaux d'électricité et en installation de câblage",
                                    "keywords": "ajouts câblage d'électricité électricité électrique entrepreneurs entretenir fournir installation installer l'équipement main-d'oeuvre maintenance neufs ouvrages peuvent pièces réalisation réaliser réparations transformations travaux"
                                },
                                {
                                    "id": "238291",
                                    "text": "Entrepreneurs en installation d'ascenseurs et d'escaliers roulants",
                                    "keywords": "ajouts ascenseurs bâtiments comprendre d'ascenseurs d'escaliers dispositifs entrepreneurs escaliers installation installer maintenance neufs ouvrages peuvent réalisés réparations réparer roulants semblables transformations transport travaux trottoirs"
                                },
                                {
                                    "id": "238220",
                                    "text": "Entrepreneurs en plomberie, chauffage et climatisation",
                                    "keywords": "ajouts chauffage classés climatisation comprendre entrepreneurs entretenir équipements fournir installer main-d'oeuvre maintenance neufs ouvrages peuvent pièces plomberie réalisation réalisés réparations transformations travaux"
                                },
                                {
                                    "id": "238299",
                                    "text": "Entrepreneurs en installation de tout autre équipement technique",
                                    "keywords": "ajouts central chaudières comprendre construction d'aspirateur démantèlement d'équipement entrepreneurs équipement exemples figurent importants installation installer l'équipement lourd machinerie maintenance neufs ouvrages peuvent réalisés réparations réparer systèmes technique tout transformations travaux tubulures"
                                }
                            ]
                        },
                        {
                            "id": "2383",
                            "text": "Entrepreneurs en travaux de finition de bâtiments",
                            "keywords": "ajouts bâtiments comprendre entrepreneurs finition maintenance neufs ouvrages peuvent réaliser réalisés réparations requis spécialisés transformations travaux",
                            "children": [
                                {
                                    "id": "238310",
                                    "text": "Entrepreneurs en installation de cloisons sèches et travaux d'isolation",
                                    "keywords": "ajouts bâtiment cloisons comprendre d'appui décoratif d'isolation effectuer entrepreneurs installation installer jointoiement l'application lattes l'isolation maintenance neufs ordinaire ouvrages peuvent plâtrage plâtre pose poser réalisés réparations sèches servant transformations travaux"
                                },
                                {
                                    "id": "238320",
                                    "text": "Entrepreneurs en peinture et tapisserie",
                                    "keywords": "ajouts bâtiments comprendre décapage décorer entrepreneurs génie gros maintenance murs neufs ouvrages papier partie peindre peint peinture peuvent poser préparation réalisés recouvrement réparations sablage secondaire surface tapisserie transformations travaux"
                                },
                                {
                                    "id": "238330",
                                    "text": "Entrepreneurs en travaux de revêtements de sol",
                                    "keywords": "ajouts bois carrelage comprendre dur entrepreneurs installer linoléum maintenance neufs ouvrages peuvent réalisés réparations réparer résilients revêtements sol tapis transformations travaux"
                                },
                                {
                                    "id": "238340",
                                    "text": "Entrepreneurs en pose de carreaux et coulage de terrazzo",
                                    "keywords": "ajouts carreaux céramique ciment comprendre coulage couler entrepreneurs etou installer l'intérieur maintenance marbre mélanger mettre mosaïque neufs ouvrages particules peuvent pierre place pose réalisés réparations seulement terrazzo tout transformations travaux tuile"
                                },
                                {
                                    "id": "238350",
                                    "text": "Entrepreneurs en petite menuiserie",
                                    "keywords": "ajouts comprendre entrepreneurs finition maintenance menuiserie neufs ouvrages petite peuvent réalisés réparations transformations travaux"
                                },
                                {
                                    "id": "238390",
                                    "text": "Entrepreneurs en autres travaux de finition de bâtiment",
                                    "keywords": "ajouts bâtiment bâtiments comprendre effectuer entrepreneurs figurent finition maintenance neufs ouvrages peuvent réalisés réparations transformations travaux"
                                }
                            ]
                        },
                        {
                            "id": "2389",
                            "text": "Autres entrepreneurs spécialisés",
                            "keywords": "ajouts bâtiments clôtures comprendre conducteur échafaudages effectuer entrepreneurs figurent grues hauts l'extérieur l'installation location maintenance neufs ouvrages peuvent préparation réalisés réparations sablage spécialisées spécialisés terrain transformations travaux",
                            "children": [
                                {
                                    "id": "238910",
                                    "text": "Entrepreneurs en préparation de terrains",
                                    "keywords": "bâtiments chantiers conducteur défricher démolition déplacer effectuer entrepreneurs fosses grues l'enlèvement l'excavation l'installation louent matériel miniers morts-terrains nivellement ouvrages préparation septiques terrain terrains terre types"
                                },
                                {
                                    "id": "238990",
                                    "text": "Tous les autres entrepreneurs spécialisés",
                                    "keywords": "ajouts comprendre construction effectuer entrepreneurs figurent maintenance neufs ouvrages peuvent réalisés réparations spécialisés transformations travaux"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "id": "31-33",
            "text": "Fabrication",
            "keywords": "agricoles appartenant appellations assimilées bicyclettes biens certaines chose classées composants connus consommation construction coupe destinés détaillants diverses domaines domicile d'outils d'ouvrages établissement fabrication fabriques fabriqués finis finition forestière l'aide l'assemblage l'enrichissement l'exploitation l'utilisation machines main manufactures matières mécaniques mélange minerais nouveaux ordinateurs peuvent physiques placage posséder post-récoltes premières procédés production produire produits propres réalisées s'agir séchage secteurs s'effectuer selon semi-finis servir similaires substances teinture thermique traitement transformation transforment transformer travailleurs usine usines utilisera viande",
            "children": [
                {
                    "id": "311",
                    "text": "Fabrication d'aliments",
                    "keywords": "animale consommation d'aliments destinés fabrication humaine production",
                    "children": [
                        {
                            "id": "3111",
                            "text": "Fabrication d'aliments pour animaux",
                            "keywords": "animaux céréales d'aliments d'ingrédients fabrication graines mouture oléagineuses partir produits viande",
                            "children": [
                                {
                                    "id": "311111",
                                    "text": "Fabrication d'aliments pour chiens et chats",
                                    "keywords": "chats chiens d'aliments fabrication"
                                },
                                {
                                    "id": "311119",
                                    "text": "Fabrication d'aliments pour autres animaux ",
                                    "keywords": "aliments animaux d'aliments fabrication figurent"
                                }
                            ]
                        },
                        {
                            "id": "3112",
                            "text": "Mouture de grains céréaliers et de graines oléagineuses ",
                            "keywords": "céréales corps déjeuner fabrication graines gras huiles mélange mouture oléagineuses petit produits raffinage",
                            "children": [
                                {
                                    "id": "311221",
                                    "text": "Mouture humide du maïs",
                                    "keywords": "d'amidon fabrication humide légumes maïs mouture"
                                },
                                {
                                    "id": "311224",
                                    "text": "Transformation de graines oléagineuses ",
                                    "keywords": "broyage comestibles fabriquer graines huiles l'extraction noix oléagineuses peuvent produits transformation"
                                },
                                {
                                    "id": "311225",
                                    "text": "Raffinage et mélange de graisses et d'huiles",
                                    "keywords": "achetées animales brutes comestibles désodoriser d'huiles fabrication fabriquer graisses huiles mélange partiellement peuvent produits raffinage raffinées transformation utiliser végétales"
                                },
                                {
                                    "id": "311230",
                                    "text": "Fabrication de céréales pour petit déjeuner ",
                                    "keywords": "céréales déjeuner fabrication petit"
                                },
                                {
                                    "id": "311211",
                                    "text": "Minoterie",
                                    "keywords": "assurent céréales farine fruits intégrés légumes mélanges minoterie mouture pâte produits riz transformation"
                                },
                                {
                                    "id": "311214",
                                    "text": "Usinage du riz et malterie",
                                    "keywords": "base céréales d'orge fabrication farine glaçage l'usinage malt malterie nettoyage riz seigle tourteaux usinage"
                                }
                            ]
                        },
                        {
                            "id": "3113",
                            "text": "Fabrication de sucre et de confiseries",
                            "keywords": "confiseries fabrication sucre",
                            "children": [
                                {
                                    "id": "311310",
                                    "text": "Fabrication de sucre",
                                    "keywords": "betterave brut canne fabrication partir raffiné sirop sucre"
                                },
                                {
                                    "id": "311340",
                                    "text": "Fabrication de confiseries non chocolatées",
                                    "keywords": "chocolatées confiseries fabrication"
                                },
                                {
                                    "id": "311351",
                                    "text": "Fabrication de chocolat et de confiseries chocolatées à partir de fèves de cacao",
                                    "keywords": "cacao chocolat chocolatées chocolaterie confiseries décortiquer fabrication fabriquer fèves moudre partir produits torréfier"
                                },
                                {
                                    "id": "311352",
                                    "text": "Fabrication de confiseries à partir de chocolat acheté",
                                    "keywords": "acheté chocolat chocolatées confiseries fabrication partir"
                                }
                            ]
                        },
                        {
                            "id": "3114",
                            "text": "Mise en conserve de fruits et de légumes et fabrication de spécialités alimentaires",
                            "keywords": "alimentaires congelés conservation conserve d'accompagnement déshydratation divers fabrication fruits ingrédients légumes marinage mer mise partir plats procédés résistance similaires spécialités",
                            "children": [
                                {
                                    "id": "311420",
                                    "text": "Mise en conserve, marinage et séchage de fruits et de légumes",
                                    "keywords": "bouillons chaleur conservation conserve d'au déshydratation fabrication fonde fruits ingrédients l'aide légumes lyophilisation marinage mélanges mise nécessite pourvu procèdent procédés salade salées sauces saumurage séchage secs solutions soupes stérilisation utilisé vinaigre"
                                },
                                {
                                    "id": "311410",
                                    "text": "Fabrication d'aliments congelés",
                                    "keywords": "congélation congelés d'accompagnement d'aliments divers fabrication fruits ingrédients légumes mer partir plats résistance"
                                }
                            ]
                        },
                        {
                            "id": "3115",
                            "text": "Fabrication de produits laitiers",
                            "keywords": "fabrication laitiers produits succédanés",
                            "children": [
                                {
                                    "id": "311511",
                                    "text": "Fabrication de lait de consommation ",
                                    "keywords": "consommation fabrication lait produits succédanés transformé"
                                },
                                {
                                    "id": "311515",
                                    "text": "Fabrication de beurre, de fromage et de produits laitiers secs et concentrés",
                                    "keywords": "beurre concentrés fabrication fromage laitiers produits secs succédanés"
                                },
                                {
                                    "id": "311520",
                                    "text": "Fabrication de crème glacée et de desserts congelés",
                                    "keywords": "congelés crème desserts fabrication glacée"
                                }
                            ]
                        },
                        {
                            "id": "3116",
                            "text": "Fabrication de produits de viande",
                            "keywords": "fabrication produits viande",
                            "children": [
                                {
                                    "id": "311611",
                                    "text": "Abattage d'animaux (sauf les volailles)",
                                    "keywords": "abattage abattent animaux d'animaux ensuite gibier l'abattage petit préparent produits viande volaille volailles"
                                },
                                {
                                    "id": "311614",
                                    "text": "Fonte de graisses animales et transformation de la viande provenant de carcasses ",
                                    "keywords": "achetées animales carcasses carton coupe déchets désignés fonte graisses installations l'emballage os préparation provenant série sous-produits terme traitement transformation viande"
                                },
                                {
                                    "id": "311615",
                                    "text": "Transformation de la volaille",
                                    "keywords": "gibier l'abattage petit préparation sous-produits transformation transformée viande volaille"
                                }
                            ]
                        },
                        {
                            "id": "3117",
                            "text": "Préparation et conditionnement de poissons et de fruits de mer",
                            "keywords": "arêtes bord conditionnement congélation conserve coquillages crustacés d'animaux décoquillage désignés écailles entrailles flottantes frais fruits fumage graisses huiles l'enlèvement marins mer mise nageoires poison poisson poissons préparation salage séchage soupes terme têtes transformation transforment usines",
                            "children": [
                                {
                                    "id": "311710",
                                    "text": "Préparation et conditionnement de poissons et de fruits de mer",
                                    "keywords": "arêtes bord conditionnement congélation conserve coquillages crustacés d'animaux décoquillage désignés écailles entrailles flottantes frais fruits fumage graisses huiles l'enlèvement marins mer mise nageoires poison poisson poissons préparation salage séchage soupes terme têtes transformation transforment usines"
                                }
                            ]
                        },
                        {
                            "id": "3118",
                            "text": "Boulangeries et fabrication de tortillas",
                            "keywords": "boulangerie boulangeries consommation destinés détail fabrication immédiate produits tortillas vente",
                            "children": [
                                {
                                    "id": "311811",
                                    "text": "Boulangeries de détail",
                                    "keywords": "boulangerie boulangeries consommation destinés détail fabrication fabriquent farine immédiate mélanges partir pâte produits vente"
                                },
                                {
                                    "id": "311814",
                                    "text": "Boulangeries commerciales et fabrication de produits de boulangerie congelés",
                                    "keywords": "boulangerie boulangeries commerciales congelés destinés détail fabrication produits vente"
                                },
                                {
                                    "id": "311821",
                                    "text": "Fabrication de biscuits et de craquelins",
                                    "keywords": "biscottes biscuits craquelins fabrication produits similaires"
                                },
                                {
                                    "id": "311824",
                                    "text": "Fabrication de pâtes alimentaires sèches, de pâte et de mélanges de farine à partir de farine achetée",
                                    "keywords": "achetée fabrication farine mélanges partir pâte préparés alimentaires fabrication pâtes sèches"
                                },
                                {
                                    "id": "311830",
                                    "text": "Fabrication de tortillas",
                                    "keywords": "fabrication tortillas"
                                }
                            ]
                        },
                        {
                            "id": "3119",
                            "text": "Fabrication d'autres aliments",
                            "keywords": "aliments d'aliments fabrication figurent",
                            "children": [
                                {
                                    "id": "311911",
                                    "text": "Fabrication de noix grillées et de beurre d'arachides",
                                    "keywords": "aliments beurre céréales conserve cuisson d'arachides fabrication graines grignoter grillage grillées mise noix salage séchage transformation"
                                },
                                {
                                    "id": "311919",
                                    "text": "Fabrication d'autres aliments à grignoter",
                                    "keywords": "aliments d'aliments fabrication figurent grignoter"
                                },
                                {
                                    "id": "311920",
                                    "text": "Fabrication de café et de thé",
                                    "keywords": "café d'extraits fabrication instantanés lyophilisés mélange produits succédanés thé tisanes torréfaction"
                                },
                                {
                                    "id": "311930",
                                    "text": "Fabrication de sirops et de concentrés aromatisants",
                                    "keywords": "aromatisants boissons concentrés distributrices fabrication gazeuses préparation produits similaires sirops"
                                },
                                {
                                    "id": "311940",
                                    "text": "Fabrication d'assaisonnements et de vinaigrettes",
                                    "keywords": "d'assaisonnements d'épices fabrication vinaigrettes"
                                },
                                {
                                    "id": "311990",
                                    "text": "Fabrication de tous les autres aliments",
                                    "keywords": "alimentaires aliments conditionnement coupés d'aliments fabrication figurent fraîches légumes l'unité pâtes pelés périssables pizzas préparés repas revente salades sandwiches vue"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "312",
                    "text": "Fabrication de boissons et de produits du tabac",
                    "keywords": "boissons fabrication fabriquer produits tabac",
                    "children": [
                        {
                            "id": "3121",
                            "text": "Fabrication de boissons",
                            "keywords": "boissons fabrication fabriquer",
                            "children": [
                                {
                                    "id": "312110",
                                    "text": "Fabrication de boissons gazeuses et de glace",
                                    "keywords": "boissons bouteille fabrication fabriquer gazeuse gazeuses glace l'eau mettent naturelle préalablement purifient"
                                },
                                {
                                    "id": "312120",
                                    "text": "Brasseries",
                                    "keywords": "alcool bière blonde brasseries brune fabriquer liqueurs malt"
                                },
                                {
                                    "id": "312130",
                                    "text": "Vineries",
                                    "keywords": "achetés cultiver distiller fabriquer fruits l'eau-de-vie mélanger partir raisin raisins vin vineries vins"
                                },
                                {
                                    "id": "312140",
                                    "text": "Distilleries",
                                    "keywords": "ajoutant alcools boissons distiller distilleries eaux-de-vie gin ingrédients mélanger notons principaux produits rhum toniques vodka whisky"
                                }
                            ]
                        },
                        {
                            "id": "3122",
                            "text": "Fabrication du tabac",
                            "keywords": "fabrication fabriquer produits tabac",
                            "children": [
                                {
                                    "id": "312210",
                                    "text": "Écôtage et resséchage des feuilles de tabac",
                                    "keywords": "calibrage dernier écôtage écôter effectuent feuilles l'emballage resséchage ressécher tabac traitement tri vieillissent"
                                },
                                
                                {
                                    "id": "312220",
                                    "text": "Fabrication de produits du tabac",
                                    "keywords": "cigarettes fabrication fabriquer produits tabac"
                                }
                            ]
                        },
                        {
                            "id": "312310",
                            "text": "Fabrication de produits du cannabis",
                            "keywords": "cigarettes de cannabis fabrication liquides à vapoter et concentrés, fabrication"
                        }
                    ]
                },
                {
                    "id": "313",
                    "text": "Usines de textiles",
                    "keywords": "fabriquer filés finissage produits textile textiles tissus tricotés usines vêtements",
                    "children": [
                        {
                            "id": "3131",
                            "text": "Usines de fibres, de filés et de fils",
                            "keywords": "achetés broderie comparables couture crochet fabrication fabriquer fibre fibres fil filaments filer filés fils frivolité humaine mouliner texturer usages usines",
                            "children": [
                                {
                                    "id": "313110",
                                    "text": "Usines de fibres, de filés et de fils",
                                    "keywords": "achetés broderie comparables couture crochet fabrication fabriquer fibre fibres fil filaments filer filés fils frivolité humaine mouliner texturer usages usines"
                                }
                            ]
                        },
                        {
                            "id": "3132",
                            "text": "Usines de tissus",
                            "keywords": "effectuer fabriquent fabriquer finissage peuvent produits rangés textile tissus tricotés usines vêtements",
                            "children": [
                                {
                                    "id": "313240",
                                    "text": "Usines de tricots",
                                    "keywords": "arachné chaîne circulaires composition double effectuer fabriquer finissage interlock l'aide maille maillé malimo métiers peuvent plateau procédés produits rangés semblables simple spéciale textiles tissu tissus trame tricotage tricotent tricoter tricots usines"
                                },
                                {
                                    "id": "313210",
                                    "text": "Usines de tissus larges",
                                    "keywords": "effectuer fabriquer faits finissage larges partir peuvent place produits rangés tissent tisser tissus usines"
                                },
                                {
                                    "id": "313220",
                                    "text": "Usines de tissus étroits et de broderies Schiffli",
                                    "keywords": "broderie broderies corde effectuer élastiques étroits fabriquent fabriquer filés fils finissage gainés mécaniquement peuvent rangés schiffli tisser tissu tissus tresser usines"
                                },
                                {
                                    "id": "313230",
                                    "text": "Usines de non-tissés",
                                    "keywords": "aiguilletés chimiques combinés effectuer entrecroisant etou fabriquent fabriquer feutres fibres finissage liant mécaniques non-tissés peuvent procédés rangés seuls solvants thermiques tissus usines utilisent"
                                }
                            ]
                        },
                        {
                            "id": "3133",
                            "text": "Finissage de textiles et de tissus et revêtement de tissus",
                            "keywords": "carpettes enduits fabrication filés fils finissage lamellés l'exception produits revêtement tapis textile textiles tissus vêtements",
                            "children": [
                                {
                                    "id": "313310",
                                    "text": "Finissage de textiles et de tissus",
                                    "keywords": "acheter appelés application blanchiment calandrage carpettes cela chimique délavage écrus embobiner entrepreneurs établissement fabricants fabriqués filés fils finir finissage flocage ignifuger imperméabiliser impression imputrescibiliser l'exception mécanique nappage opérations plissé produits rétrécissage rouleau substance suivantes tapis teinture textile textiles tissus trame transformateurs vêtements"
                                },
                                {
                                    "id": "313320",
                                    "text": "Revêtement de tissus",
                                    "keywords": "caoutchoutage cirage enduits fabriquer finition imprégnés laminage laminés procédés revêtement semblables soumettre spéciaux textiles tissus vernissage vêtements"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "314",
                    "text": "Usines de produits textiles",
                    "keywords": "fabriquer produits textiles usines vêtements",
                    "children": [
                        {
                            "id": "3141",
                            "text": "Usines de textiles domestiques",
                            "keywords": "carpettes domestiques fabriquer linge maison rideaux tapis textiles usines",
                            "children": [
                                {
                                    "id": "314110",
                                    "text": "Usines de tapis et de carpettes",
                                    "keywords": "aiguilletés carpettes fabriquer finition paillassons produits semblables tapis tissés tuftés usines"
                                },
                                {
                                    "id": "314120",
                                    "text": "Usines de rideaux et de linge de maison",
                                    "keywords": "accessoires achetés courtepointes couvertures douche draps fabriquer linge maison matériaux nappes partir rideaux serviettes tentures usines"
                                }
                            ]
                        },
                        {
                            "id": "3149",
                            "text": "Usines d'autres produits textiles",
                            "keywords": "fabriquer figurent produits textiles usines",
                            "children": [
                                {
                                    "id": "314910",
                                    "text": "Usines de sacs en textile et de grosse toile",
                                    "keywords": "bâches base fabriquer grosse industriel produits sacs substituts tentes textile toile transport usage usines"
                                },
                                {
                                    "id": "314990",
                                    "text": "Usines de tous les autres produits textiles",
                                    "keywords": "broder contrat déchets effilocher fabriquer façons figurent produits recycler termes textiles usines vêtements"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "315",
                    "text": "Fabrication de vêtements",
                    "keywords": "fabrication vêtements",
                    "children": [
                        {
                            "id": "3151",
                            "text": "Usines de tricotage de vêtements",
                            "keywords": "effectuer établissement fabrication fabriqués filés finissage partir peuvent rangés tissus tricotage tricotent tricots usines vêtements",
                            "children": [
                                {
                                    "id": "315110",
                                    "text": "Usines de bas et de chaussettes",
                                    "keywords": "bas chaussettes effectuer enfants femmes finissage hommes peuvent rangés tissus tricotage tricotent usines"
                                },
                                {
                                    "id": "315190",
                                    "text": "Usines de tricotage d'autres vêtements ",
                                    "keywords": "effectuer figurent finissage gants peuvent rangés tissus tricotage tricotent usines vêtements"
                                }
                            ]
                        },
                        {
                            "id": "3152",
                            "text": "Fabrication de vêtements coupés-cousus",
                            "keywords": "coupés-cousus fabrication fabriqués partir tissus vêtements",
                            "children": [
                                {
                                    "id": "315210",
                                    "text": "Fabrication à forfait de vêtements coupés-cousus",
                                    "keywords": "appartenant chemises coupe coupés-cousus couture désignés effectuent entrepreneurs fabrication forfait fournitures généralement l'assemblage manches opérations partir terme vêtements"
                                },
                                {
                                    "id": "315220",
                                    "text": "Fabrication de vêtements coupés-cousus pour hommes et garçons",
                                    "keywords": "acheté coupés-cousus fabrication garçons hommes nuit partir sous-vêtements tissu vêtements achetés complets désignés destinés détail manteaux pardessus partir tailleur terme tissus vente ajustées chemises notons partir principaux produits t-shirts jeans pantalons figurent"
                                },
                                {
                                    "id": "315241",
                                    "text": "Fabrication de vêtements coupés-cousus pour bébés",
                                    "keywords": "achetés articles bébés besoins centimètres classification coupés-cousus désignation désigne enfants fabrication inférieure jeunes n'excède partir taille terme tissus vêtements x"
                                },
                                {
                                    "id": "315249",
                                    "text": "Fabrication de vêtements coupés-cousus pour dames et filles",
                                    "keywords": "achetés coupés-cousus détente fabrication femmes filles lingerie nuit partir tissus vêtements blouses chemises coupées-cousues couturiers désignés destinés détail robes terme vente ajustés jupes manteaux tailleurs vestons figurent"
                                },
                                {
                                    "id": "315281",
                                    "text": "Fabrication de vêtements en fourrure et en cuir",
                                    "keywords": "cuir fabrication fourrure vêtements"
                                },
                                {
                                    "id": "315289",
                                    "text": "Fabrication de tous les autres vêtements coupés-cousus",
                                    "keywords": "achetés coupés-cousus fabrication figurent partir tissus vêtements"
                                }
                            ]
                        },
                        {
                            "id": "3159",
                            "text": "Fabrication d'accessoires vestimentaires et d'autres vêtements",
                            "keywords": "d'accessoires fabrication figurent vestimentaires vêtements",
                            "children": [
                                {
                                    "id": "315990",
                                    "text": "Fabrication d'accessoires vestimentaires et d'autres vêtements",
                                    "keywords": "d'accessoires fabrication figurent vestimentaires vêtements"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "316",
                    "text": "Fabrication de produits en cuir et de produits analogues",
                    "keywords": "analogues cuir fabrication fabriquer produits",
                    "children": [
                        {
                            "id": "316110",
                            "text": "Tannage et finissage du cuir et des peaux",
                            "keywords": "achètent apprêter confient corroyer cuir d'animaux finissage fourrure obtenir peaux sous-traitants tannage tanner teinter transformateurs transformation"
                        },
                        {
                            "id": "316210",
                            "text": "Fabrication de chaussures",
                            "keywords": "caoutchouc chaussures cuir fabrication fabriquer matériaux pantoufles plastique sport"
                        },
                        {
                            "id": "316990",
                            "text": "Fabrication d'autres produits en cuir et produits analogues",
                            "keywords": "analogues articles cuir elle fabrication fabriquer figurent main matériaux métal notons personne petits porte-billets porte-clés porte-monnaie précieux principaux produits qu'une sac sacs transporte valises"
                        }
                    ]
                },
                {
                    "id": "321",
                    "text": "Fabrication de produits en bois",
                    "keywords": "améliorent articles assurent billes bois caractéristiques charpente contreplaqués divers ensembles fabrication fabriquant fabriquent fabriquer groupes menuiserie naturelles panneaux partir plaquages préfabriquée préservation produisent produits reconstitué scient semblables transformé",
                    "children": [
                        {
                            "id": "3211",
                            "text": "Scieries et préservation du bois",
                            "keywords": "adoucir bardeaux billes billons bois brut charpente d'échantillon dégauchisseuse dimensions d'oeuvre fabriquer façonnage obtenir opération partir planches poteaux préservation produisent produits raboté scieries subissent surface transformation traverses uniformes",
                            "children": [
                                {
                                    "id": "321111",
                                    "text": "Scieries (sauf les usines de bardeaux et de bardeaux de fente)",
                                    "keywords": "adoucir bardages bardeaux billes billons bois brut charpente d'échantillon dégauchisseuse dimensions d'oeuvre exception fabriquer façonnage fente obtenir opération partir planches poteaux produisent produits raboté scieries subissent surface transformation traverses uniformes usines"
                                },
                                {
                                    "id": "321112",
                                    "text": "Usines de bardeaux et de bardeaux de fente",
                                    "keywords": "bardeaux bois fabriquer fendre fente pièces scier usines"
                                },
                                {
                                    "id": "321114",
                                    "text": "Préservation du bois",
                                    "keywords": "aqueux bois charpente chrome communs composés contreplaqué couper couramment créosote cuivre dimensions employée fabriqués feu inorganiques insectes l'aide l'arséniate méthode notons pieux piquets poteaux pourriture préservation pression produits protègent rond semblables substances traitement traiter"
                                }
                            ]
                        },
                        {
                            "id": "3212",
                            "text": "Fabrication de placages, de contreplaqués et de produits en bois reconstitué",
                            "keywords": "alternant assemblage billes bois certains charpente colle comporter comprime contreplaqué contreplaqués couches critères d'adhésifs écorçant éléments ensemble épaisseur fabrication fabriquer fabriqués feuille feuilles feuillu grain l'aide lamellation lamellé liants massif matériaux mince panneaux peuvent pièces placage placages pression produire produit produits reconstitué résineux selon sens techniques tranchant uniforme",
                            "children": [
                                {
                                    "id": "321217",
                                    "text": "Usines de panneaux de copeaux",
                                    "keywords": "ajoutés bois brins chaud copeaux ensemble fabriquer faits imperméable liant maintenus marais orientées panneaux particules peuplier pin pression produits tremble usines"
                                },
                                {
                                    "id": "321212",
                                    "text": "Usines de placages et de contreplaqués de résineux",
                                    "keywords": "contreplaqués fabriquer placages résineux usines"
                                },
                                {
                                    "id": "321211",
                                    "text": "Usines de placages et de contreplaqués de feuillus",
                                    "keywords": "contreplaqués fabriquer feuillus placages usines"
                                },
                                {
                                    "id": "321215",
                                    "text": "Fabrication de produits de charpente en bois",
                                    "keywords": "bois charpente éléments fabrication fabriquer massif produits qu'en"
                                },
                                {
                                    "id": "321216",
                                    "text": "Usines de panneaux de particules et de fibres",
                                    "keywords": "bois chaud complètement constitués ensemble fabriquer fibres imperméable liant lignine maintenus opérations panneaux particules partiellement premiers pression résidus retenus seconds traitement usines"
                                }
                            ]
                        },
                        {
                            "id": "3219",
                            "text": "Fabrication d'autres produits en bois",
                            "keywords": "bois fabrication fabriquer figurent produits",
                            "children": [
                                {
                                    "id": "321911",
                                    "text": "Fabrication de fenêtres et de portes en bois",
                                    "keywords": "bois cadres ensuite fabrication fabriquer fenêtre fenêtres métal peuvent plastique porte portes recouverts"
                                },
                                {
                                    "id": "321919",
                                    "text": "Fabrication d'autres menuiseries préfabriquées",
                                    "keywords": "acheté bois dégauchir dégauchisseuses dresseuses fabrication fabriquer façon figurent machines matériau menuiserie menuiseries ouvrages plastique préfabriquée préfabriquées revêtue sécher toupies tours travailler utilisent"
                                },
                                {
                                    "id": "321920",
                                    "text": "Fabrication de contenants et de palettes en bois",
                                    "keywords": "bois contenant contenants éléments fabrication fabriquer monter palettes pièces planchages prêts produits tonnelier"
                                },
                                {
                                    "id": "321991",
                                    "text": "Préfabrication de maisons (mobiles)",
                                    "keywords": "bâtiments châssis constants d'eau d'égouts déplacements d'usage fabriquer maisons mobiles multiples muni posées préfabrication raccorder résidentiel roues services structures transportables"
                                },
                                {
                                    "id": "321992",
                                    "text": "Préfabrication de bâtiments en bois",
                                    "keywords": "bâtiment bâtiments bois cabanes chantiers complets éléments fabriquent fabriquer l'extérieur maisons monter panneaux parties place préfabrication préfabriqués produire rondins"
                                },
                                {
                                    "id": "321999",
                                    "text": "Fabrication de tous les autres produits divers en bois",
                                    "keywords": "bois divers fabrication fabriquer figurent produits"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "327",
                    "text": "Fabrication de produits minéraux non métalliques",
                    "keywords": "additifs base briques calcaire céramique chauffent chimiques ciment coupe fabrication fabriquer façonnage finition granite l'ardoise marbre mélangent métalliques meulage minéraux pierres préparations produits réfractaires verre",
                    "children": [
                        {
                            "id": "3273",
                            "text": "Fabrication de ciment et de produits en béton",
                            "keywords": "béton blocs briques ciment fabrication fabriquer hydraulique l'emploi prêt produits tuyaux",
                            "children": [
                                {
                                    "id": "327390",
                                    "text": "Fabrication d'autres produits en béton",
                                    "keywords": "béton fabrication fabriquer figurent produits"
                                },
                                {
                                    "id": "327320",
                                    "text": "Fabrication de béton préparé",
                                    "keywords": "béton ciment compacte concassée fabrication fabriquer forme gravier l'eau livrer malléable mélanger pierre préparé sable"
                                },
                                {
                                    "id": "327310",
                                    "text": "Fabrication de ciment",
                                    "keywords": "broyer ciment fabrication humide mâchefer produire puis sec voie"
                                },
                                {
                                    "id": "327330",
                                    "text": "Fabrication de tuyaux, briques et blocs en béton",
                                    "keywords": "béton blocs briques ciment d'agrégats d'eau fabrication fabriquer mélange tuyaux"
                                }
                            ]
                        },
                        {
                            "id": "327120",
                            "text": "Fabrication de matériaux de construction en argile et de produits réfractaires",
                            "keywords": "argile avoir construction cuire d'argile durcir fabrication fabriqués façonner matériaux mouler partir peuvent possédant produits propriétés réfractaires semblables"
                        },
                        {
                            "id": "327110",
                            "text": "Fabrication de poteries, d'articles en céramique et d'appareils sanitaires",
                            "keywords": "appareils articles avoir blanche céramique cuire cuisson d'appareils d'argile d'articles décoration émailler fabrication fabriqués façonner grand mouler partir peuvent porcelaine possédant poteries produits propriétés public sanitaires semblables spécialisent vaisselle"
                        },
                        {
                            "id": "327215",
                            "text": "Fabrication de produits en verre à partir de verre acheté",
                            "keywords": "acheté achètent articles comprimer fabrication façon façonner fondre main partir produits souffler verre"
                        },
                        {
                            "id": "327214",
                            "text": "Fabrication de verre",
                            "keywords": "câble câbles fabrication fabriquer faisceaux faits fibres gainées groisil optiques partir peuvent produits sable verre"
                        },
                        {
                            "id": "327990",
                            "text": "Fabrication de tous les autres produits minéraux non métalliques",
                            "keywords": "fabrication fabriquer figurent métalliques minéraux produits"
                        },
                        {
                            "id": "327910",
                            "text": "Fabrication de produits abrasifs",
                            "keywords": "abrasifs abrasives d'abrasif fabrication fabriquer matériaux meules produits revêtus"
                        },
                        {
                            "id": "327420",
                            "text": "Fabrication de produits en gypse",
                            "keywords": "composés entièrement fabrication fabriquer gypse principalement produits"
                        },
                        {
                            "id": "327410",
                            "text": "Fabrication de chaux",
                            "keywords": "broyage calcaire calcinée calcium carbonate chaux criblage d'éclats dolomie fabrication fabriquer grillage hydratée mort sources vive"
                        }
                    ]
                },
                {
                    "id": "322",
                    "text": "Fabrication du papier",
                    "keywords": "assembler bois cellulosiques contenues coupe diverses effectuées fabrication façonnage feuille fibres impuretés matériaux opérations papier pâte produits résultent séparer sources transformé usagé",
                    "children": [
                        {
                            "id": "3221",
                            "text": "Usines de pâte à papier, de papier et de carton",
                            "keywords": "carton fabriquer papier pâte transformation usines",
                            "children": [
                                {
                                    "id": "322111",
                                    "text": "Usines de pâte mécanique",
                                    "keywords": "défibreur fabriquer matériau mécanique mécaniques méthodes mi-chimique mi-chimiques n'importe notons partir pâte principaux produits provenant ptm quel thermomécanique usines"
                                },
                                {
                                    "id": "322121",
                                    "text": "Usines de papier (sauf le papier journal)",
                                    "keywords": "carton fabrication fabriquent fabriquer journal papier pâte transformation usines"
                                },
                                {
                                    "id": "322130",
                                    "text": "Usines de carton",
                                    "keywords": "carton fabrication fabriquent fabriquer pâte transformation usines"
                                },
                                {
                                    "id": "322122",
                                    "text": "Usines de papier journal",
                                    "keywords": "d'impression fabriquent fabriquer journal mécanique papier pâte usines"
                                },
                                {
                                    "id": "322112",
                                    "text": "Usines de pâte chimique",
                                    "keywords": "après chimique chimiques déchets fabriquer kraft matériau moyens n'importe obtenue papier partir pâte quel soude sulfate traitement transforment usines"
                                }
                            ]
                        },
                        {
                            "id": "3222",
                            "text": "Fabrication de produits en papier transformé",
                            "keywords": "achetés carton fabrication fabriquer papier partir produits transformé",
                            "children": [
                                {
                                    "id": "322212",
                                    "text": "Fabrication de boîtes pliantes en carton",
                                    "keywords": "acheté boîtes carton fabrication fabriquer partir pliantes"
                                },
                                {
                                    "id": "322219",
                                    "text": "Fabrication d'autres contenants en carton",
                                    "keywords": "acheté alimentaires boîtes carton conserve contenants fabrication fabriquer figurent fûts hygiéniques montées partir récipients"
                                },
                                {
                                    "id": "322220",
                                    "text": "Fabrication de sacs en papier et de papier couché et traité",
                                    "keywords": "achetés carton collées composer contenir contrecollés couche couché couches d'aluminium ensemble fabrication fabriquer feuilles matériaux papier partir peuvent plastique plusieurs produits sacs seule souples traité uniquement"
                                },
                                {
                                    "id": "322299",
                                    "text": "Fabrication de tous les autres produits en papier transformé",
                                    "keywords": "acheté boîtes d'oeufs fabrication fabriquer figurent moulés papier partir pâte produits transformé"
                                },
                                {
                                    "id": "322211",
                                    "text": "Fabrication de boîtes en carton ondulé et en carton compact",
                                    "keywords": "acheté boîtes carton compact fabrication fabriquer feuilles ondulé partir produits semblables"
                                },
                                {
                                    "id": "322230",
                                    "text": "Fabrication d'articles de papeterie",
                                    "keywords": "articles classement d'articles écrire fabrication fabriquer papeterie semblables sert usages"
                                },
                                {
                                    "id": "322291",
                                    "text": "Fabrication de produits hygiéniques en papier",
                                    "keywords": "achètent base divers fabrication fabriquer hygiénique hygiéniques jetables matière papier produits tampons textile"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "323",
                    "text": "Impression et activités connexes de soutien",
                    "keywords": "connexes d'impression fournir impression services soutien",
                    "children": [
                        {
                            "id": "323115",
                            "text": "Impression numérique",
                            "keywords": "balayée bien caractère commandées couleurs d'encre d'impression documents effectuer électrostatiques équipés façon fichier fournir graphique haute impression imprimer informatique introduite jet l'image l'impression l'imprimante machine machines numérique numérisée ordinateur percussion préalables principaux produits puis pulvérisation résolution scanners séparation services simplement spécialisés tâches très utilisent"
                        },
                        {
                            "id": "323116",
                            "text": "Impression de formulaires commerciaux en liasses",
                            "keywords": "commerciaux formulaires impression imprimer liasses"
                        },
                        {
                            "id": "323113",
                            "text": "Sérigraphie commerciale",
                            "keywords": "caractère commerciale couper d'enseigne documents effectuer équipés format généralement grand graphique images impriment lettres l'impression papier préalables produisent sérigraphie servant soie stencils tâches trames vêtements"
                        },
                        {
                            "id": "323114",
                            "text": "Impression instantanée",
                            "keywords": "commerciale effectuer équipés etou impression imprimantes instantanée l'impression offset percussion petites préalables presses tâches utilisant"
                        },
                        {
                            "id": "323119",
                            "text": "Autres activités d'impression",
                            "keywords": "d'impression figurent fournir services"
                        },
                        {
                            "id": "323120",
                            "text": "Activités de soutien à l'impression",
                            "keywords": "commerciaux fournir imprimeurs l'impression préparation reliure services soutien"
                        }
                    ]
                },
                {
                    "id": "324",
                    "text": "Fabrication de produits du pétrole et du charbon",
                    "keywords": "brut charbon craquage distillation exige fabrication finis intermédiaires l'aide pétrole principal procédé produits raffinage séparation sous-produits techniques transformation",
                    "children": [
                        {
                            "id": "324122",
                            "text": "Fabrication de bardeaux et de matériaux de revêtement en asphalte",
                            "keywords": "achetés asphalte bardeaux bitume bitumineux collage d'asphalte fabrication feuilles feutre imprégné matériaux papier partir produits revêtement revêtements rouleaux"
                        },
                        {
                            "id": "324190",
                            "text": "Fabrication d'autres produits du pétrole et du charbon",
                            "keywords": "charbon conversion fabrication figurent pétrole produits raffinage raffinés usés"
                        },
                        {
                            "id": "324121",
                            "text": "Fabrication de mélanges d'asphaltage et de pavés d'asphalte",
                            "keywords": "achetés asphaltiques bitumineux blocs d'asphaltage d'asphalte fabrication goudron mélanges partir pavage pavés produits"
                        },
                        {
                            "id": "324110",
                            "text": "Raffineries de pétrole",
                            "keywords": "brut craquage distillation moyen pétrole procédés raffinage raffineries transformer"
                        }
                    ]
                },
                {
                    "id": "325",
                    "text": "Fabrication de produits chimiques",
                    "keywords": "chimiques fabrication inorganiques matières organiques partir premières préparations produits",
                    "children": [
                        {
                            "id": "3251",
                            "text": "Fabrication de produits chimiques de base",
                            "keywords": "base chimiquement chimiques composés craquage définis distillation distincts éléments fabrication fabriqués généralement l'aide procédés produits thermique",
                            "children": [
                                {
                                    "id": "325190",
                                    "text": "Fabrication d'autres produits chimiques organiques de base",
                                    "keywords": "acides alcool alicycliques base bois chimiques chlorure consommation destiné d'éthanol distillation esters éthylique fabrication figurent glycol goudron gras houille hydrocarbures l'éthylène méthanol notons organiques principaux produits vinyle"
                                },
                                {
                                    "id": "325189",
                                    "text": "Fabrication de tous les autres produits chimiques inorganiques de base",
                                    "keywords": "base chimiques fabrication figurent inorganiques produits"
                                },
                                {
                                    "id": "325181",
                                    "text": "Fabrication d'alcalis et de chlore",
                                    "keywords": "chlore d'alcalis d'électrolyse fabrication généralement l'aide procédé"
                                },
                                {
                                    "id": "325130",
                                    "text": "Fabrication de teintures et de pigments synthétiques",
                                    "keywords": "fabrication inorganiques laqués organiques pigments synthèse synthétiques teintures toners"
                                },
                                {
                                    "id": "325120",
                                    "text": "Fabrication de gaz industriels",
                                    "keywords": "comprimée fabrication forme gaz industriels inorganiques liquide organiques solide"
                                },
                                {
                                    "id": "325110",
                                    "text": "Fabrication de produits pétrochimiques",
                                    "keywords": "acycliques aliphatiques aromatiques benzène charges constitués craquage cycliques d'alimentation définition dérivées d'hydrocarbures fabrication fins gaz l'éthylène liquides naturel notons pétrochimiques pétrole principaux procédés produits propène propylène reformage styrène toluène transformation utilisés vapeur xylène"
                                }
                            ]
                        },
                        {
                            "id": "3252",
                            "text": "Fabrication de résines, de caoutchouc synthétique et de fibres et de filaments artificiels et synthétiques",
                            "keywords": "artificiels base caoutchouc fabrication fibres filaments monomères polymères polymériser polystyrène procédé résines styrène synthétique synthétiques textiles transformer",
                            "children": [
                                {
                                    "id": "325220",
                                    "text": "Fabrication de fibres et de filaments artificiels et synthétiques",
                                    "keywords": "artificielles artificiels brin cellulose continu dérivées dérivés d'étoupe fabrication fabriquées fibres fil filaments forme généralement livrent matières monofilament naturelles organiques partir pétrochimiques polymères premières prenant principalement produits synthétiques texturation"
                                },
                                {
                                    "id": "325210",
                                    "text": "Fabrication de résines et de caoutchouc synthétique",
                                    "keywords": "base caoutchouc chimiques fabrication matières organiques partir plastiques produits résines synthétique synthétiques"
                                }
                            ]
                        },
                        {
                            "id": "3253",
                            "text": "Fabrication de pesticides, d'engrais et d'autres produits chimiques agricoles",
                            "keywords": "agricoles antiparasitaires azotées chimiques d'engrais domestiques engrais fabrication fertilisantes matières mixtes notons pesticides phosphoriques principaux produits",
                            "children": [
                                {
                                    "id": "325320",
                                    "text": "Fabrication de pesticides et d'autres produits chimiques agricoles",
                                    "keywords": "agricoles antiparasitaires chimiques domestiques fabrication fabriquent fertilisants pesticides produits"
                                },
                                {
                                    "id": "325313",
                                    "text": "Fabrication d'engrais chimiques (sauf la potasse)",
                                    "keywords": "azotées chimiques compost d'engrais fabrication fabriquent fertilisantes fertilisants l'acide l'ammoniac l'exception l'urée matières mélange mélanges naturels nitrique organiques phosphorique phosphoriques potasse produire produisent produits soient utilisés"
                                },
                                {
                                    "id": "325314",
                                    "text": "Fabrication d'engrais mixtes",
                                    "keywords": "d'engrais fabrication fabriquer fertilisants matières mélange mixtes produites vue"
                                }
                            ]
                        },
                        {
                            "id": "3254",
                            "text": "Fabrication de produits pharmaceutiques et de médicaments",
                            "keywords": "adaptées ampoules animaux base broyage chimique classement comprimés concassage conditionnement connexes destinés distillation drogues externe fabrication fermentation flacons formes interne l'extraction l'homme l'usage médicaments peuvent pharmaceutiques plusieurs pommades procédés produits rangés solvant synthèse utiliser",
                            "children": [
                                {
                                    "id": "325410",
                                    "text": "Fabrication de produits pharmaceutiques et de médicaments",
                                    "keywords": "adaptées ampoules animaux base broyage chimique classement comprimés concassage conditionnement connexes destinés distillation drogues externe fabrication fermentation flacons formes interne l'extraction l'homme l'usage médicaments peuvent pharmaceutiques plusieurs pommades procédés produits rangés solvant synthèse utiliser"
                                }
                            ]
                        },
                        {
                            "id": "3255",
                            "text": "Fabrication de peintures, de revêtements et d'adhésifs",
                            "keywords": "d'adhésifs fabrication peintures revêtements",
                            "children": [
                                {
                                    "id": "325520",
                                    "text": "Fabrication d'adhésifs",
                                    "keywords": "colles connexes d'adhésifs fabrication produits"
                                },
                                {
                                    "id": "325510",
                                    "text": "Fabrication de peintures et de revêtements",
                                    "keywords": "connexes fabrication liants mélange peintures pigments produire produits revêtements solvants teintures"
                                }
                            ]
                        },
                        {
                            "id": "3256",
                            "text": "Fabrication de savons, de détachants et de produits de toilette",
                            "keywords": "détachants fabrication produits savons toilette",
                            "children": [
                                {
                                    "id": "325620",
                                    "text": "Fabrication de produits de toilette",
                                    "keywords": "composition fabrication mélange préparation produits toilette"
                                },
                                {
                                    "id": "325610",
                                    "text": "Fabrication de savons et d'autres produits nettoyants ",
                                    "keywords": "détachants fabrication savons"
                                }
                            ]
                        },
                        {
                            "id": "3259",
                            "text": "Fabrication d'autres produits chimiques",
                            "keywords": "chimiques fabrication figurent produits",
                            "children": [
                                {
                                    "id": "325999",
                                    "text": "Fabrication de tous les autres produits chimiques divers",
                                    "keywords": "chimiques divers fabrication figurent produits"
                                },
                                {
                                    "id": "325920",
                                    "text": "Fabrication d'explosifs",
                                    "keywords": "détonateurs d'explosifs dispositifs explosifs fabrication munitions produits"
                                },
                                {
                                    "id": "325991",
                                    "text": "Compoundage sur commande de résines achetées",
                                    "keywords": "achetées commande compoundage mélange partir plastiques préparation produites produits recyclés résines"
                                },
                                {
                                    "id": "325910",
                                    "text": "Fabrication d'encre d'imprimerie",
                                    "keywords": "cartouches couleur d'encre d'imprimerie fabrication fabriquent jet noire"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "326",
                    "text": "Fabrication de produits en plastique et en caoutchouc",
                    "keywords": "apparentées bruts caoutchouc classés constitue exception fabrication fabriquent fabriquer faits généralement matière parce plastique pneus polymères produits propriétés règle regroupées seule techniques traitement",
                    "children": [
                        {
                            "id": "3261",
                            "text": "Fabrication de produits en plastique",
                            "keywords": "compression coulage extrusion fabrication fabriquer finals gamme grâce injection intermédiaires moulage neuves partir permettent peuvent plastique plastiques plupart procédés production produits recyclées résines soufflage utilisées vaste",
                            "children": [
                                {
                                    "id": "326111",
                                    "text": "Fabrication de sacs et de sachets en plastique",
                                    "keywords": "accessoire activité cellulose enduire fabrication fabriquent feuilles former imprimer matière pellicules peuvent plastique plastiques renforcés résines sachets sacs seule stratifier titre transformation"
                                },
                                {
                                    "id": "326150",
                                    "text": "Fabrication de produits en mousse d'uréthane et en d'autres mousses plastiques (sauf de polystyrène)",
                                    "keywords": "base d'uréthane fabrication matière mousse mousses plastique plastiques polystyrène produits résines transformation"
                                },
                                {
                                    "id": "326130",
                                    "text": "Fabrication de plaques, de feuilles (sauf d'emballage) et de formes stratifiées en plastique",
                                    "keywords": "chaud coller comprimer d'emballage fabrication feuilles formes généralement imprégner plaques plastique plastiques procédé profilées profilés résines stratification stratifiées tiges"
                                },
                                {
                                    "id": "326196",
                                    "text": "Fabrication de portes et de fenêtres en plastique",
                                    "keywords": "fabrication fenêtres plastique portes"
                                },
                                {
                                    "id": "326198",
                                    "text": "Fabrication de tous les autres produits en plastique",
                                    "keywords": "fabrication figurent plastique produits"
                                },
                                {
                                    "id": "326191",
                                    "text": "Fabrication d'appareils sanitaires en plastique",
                                    "keywords": "d'appareils fabrication plastique sanitaires"
                                },
                                {
                                    "id": "326193",
                                    "text": "Fabrication de pièces en plastique pour véhicules automobiles",
                                    "keywords": "automobiles communs d'assemblage étapes fabrication fabriquées l'extrusion moulage pièces plastique procédés véhicules"
                                },
                                {
                                    "id": "326160",
                                    "text": "Fabrication de bouteilles en plastique",
                                    "keywords": "bouteilles couler fabrication plastique souffler"
                                },
                                {
                                    "id": "326140",
                                    "text": "Fabrication de produits en mousse de polystyrène",
                                    "keywords": "base d'isolation fabrication figure mousse polystyrène principaux produits résines rigide transformation"
                                },
                                {
                                    "id": "326121",
                                    "text": "Fabrication de profilés non stratifiés en plastique",
                                    "keywords": "boyaux fabrication feuilles figurent pellicules plastique plastiques profilés renforcés résines sacs saucisses stratifiés synthétiques tiges transformation tubes"
                                },
                                {
                                    "id": "326122",
                                    "text": "Fabrication de tuyaux et de raccords de tuyauterie en plastique",
                                    "keywords": "fabrication plastique plastiques raccords résines transformation tuyauterie tuyaux"
                                },
                                {
                                    "id": "326114",
                                    "text": "Fabrication de pellicules et de feuilles en plastique",
                                    "keywords": "fabrication feuilles pellicules plastique plastiques renforcées résines transformation"
                                }
                            ]
                        },
                        {
                            "id": "3262",
                            "text": "Fabrication de produits en caoutchouc",
                            "keywords": "caoutchouc collage fabrication finals intermédiaires l'aide l'extrusion moulage naturel procédés produits recyclé synthétique taillage tour traiter vulcanisation",
                            "children": [
                                {
                                    "id": "326290",
                                    "text": "Fabrication d'autres produits en caoutchouc",
                                    "keywords": "caoutchouc fabrication figurent produits"
                                },
                                {
                                    "id": "326220",
                                    "text": "Fabrication de tuyaux souples et de courroies en caoutchouc et en plastique",
                                    "keywords": "caoutchouc courroies etou fabrication naturel partir plastique plastiques renforcés résines souples synthétique tuyaux"
                                },
                                {
                                    "id": "326210",
                                    "text": "Fabrication de pneus",
                                    "keywords": "air caoutchouc chambres fabrication naturel neuf partir pneumatiques pneus rechapage remise synthétique"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "331",
                    "text": "Première transformation des métaux",
                    "keywords": "affiner ajouter alliages barres base brute chimiques électriques étirage fabriquer ferraille ferreux feuilles fils fondre fonte forme fourneaux fours hauts laminage lingots liquide métalliques métaux minerai moules peuvent première produire produit produits provenant raffinage rubans substances tiges transformation utilisé",
                    "children": [
                        {
                            "id": "3311",
                            "text": "Sidérurgie",
                            "keywords": "acier alliages après arc avoir barres carbone combustion contient couler d'acier débris dotées électriques fer feuilles fondre fonte forme formes fours gueuse lingots liquide minerai mini-aciéries ouvrés peuvent plaques première produire produits qu'il retiré rubans sidérurgie simples solide tiges transformer uniquement",
                            "children": [
                                {
                                    "id": "331110",
                                    "text": "Sidérurgie",
                                    "keywords": "acier alliages après arc avoir barres carbone combustion contient couler d'acier débris dotées électriques fer feuilles fondre fonte forme formes fours gueuse lingots liquide minerai mini-aciéries ouvrés peuvent plaques première produire produits qu'il retiré rubans sidérurgie simples solide tiges transformer uniquement"
                                }
                            ]
                        },
                        {
                            "id": "3312",
                            "text": "Fabrication de produits en acier à partir d'acier acheté",
                            "keywords": "acheté acier d'acier étirage fabrication fabriquer fer fil formes froid laminer partir produits tubes tuyaux",
                            "children": [
                                {
                                    "id": "331210",
                                    "text": "Fabrication de tubes et de tuyaux en fer et en acier à partir d'acier acheté",
                                    "keywords": "acheté acier d'acier fabrication fer gros partir produire rivetés soudés tubes tuyaux"
                                },
                                {
                                    "id": "331222",
                                    "text": "Étirage de fils d'acier",
                                    "keywords": "acier barres câbles carbure d'acier étirage étirer fabriquer fer fil filière fils métallique produire produits tiges travers tréfilés"
                                },
                                {
                                    "id": "331221",
                                    "text": "Fabrication de formes en acier laminé à froid",
                                    "keywords": "acheté acier barres chaud d'acier fabrication feuilles formes froid l'acier laminé laminées laminer partir produits réchauffer rubans"
                                }
                            ]
                        },
                        {
                            "id": "3313",
                            "text": "Production et transformation d'alumine et d'aluminium",
                            "keywords": "alliages bauxite couler d'alumine d'aluminium étirer extraire extruder fabriquer formes généralement l'alumine l'aluminium laminer minerais n'importe partir procédé production produire quel raffiner simples transformation",
                            "children": [
                                {
                                    "id": "331313",
                                    "text": "Production primaire d'alumine et d'aluminium",
                                    "keywords": "bauxite consistent couler d'alumine d'aluminium établissement étirer extraire extruder formes généralement l'alumine l'aluminium laminer partir primaire production produire produit secondaires simples"
                                },
                                {
                                    "id": "331317",
                                    "text": "Laminage, étirage, extrusion et alliage de l'aluminium",
                                    "keywords": "alliage alliages barres blooms chaud d'aluminium débris diverses ensuite étirage extraire extrusion fabriquer fassent feuilles fil formes froid l'aluminium laminage lingots l'isoler opérations plaques produire simples subir tiges transformer tubes tuyaux"
                                }
                            ]
                        },
                        {
                            "id": "3314",
                            "text": "Production et transformation de métaux non ferreux (sauf l'aluminium)",
                            "keywords": "alliages étirer extruder ferreux fondre l'aluminium laminer métaux production raffiner transformation",
                            "children": [
                                {
                                    "id": "331410",
                                    "text": "Fonte et affinage de métaux non ferreux (sauf l'aluminium)",
                                    "keywords": "affinage consistent électrolytiques établissement extruder ferreux fondre fonte formes l'aluminium laminer métaux minerais partir procédés produits raffiner secondaires simples"
                                },
                                {
                                    "id": "331420",
                                    "text": "Laminage, étirage, extrusion et alliage du cuivre",
                                    "keywords": "alliage alliages barres bronze cuivre déchets ensuite étirage étirer extruder extrusion fabriquer fassent feuilles fil fils laiton laminage laminer l'isoler opérations partir plaques produits ré-allier récupérer rubans spécialisés subir tubes"
                                },
                                {
                                    "id": "331490",
                                    "text": "Laminage, étirage, extrusion et alliage de métaux non ferreux (sauf le cuivre et l'aluminium)",
                                    "keywords": "alliage alliages barres cuivre déchets ensuite étirage étirer extruder extrusion fabriquer fassent ferreux feuilles figurent fil fils l'aluminium laminage laminer l'isoler métaux opérations partir plaques produits ré-allier récupèrent rubans spécialisés subir tubes"
                                }
                            ]
                        },
                        {
                            "id": "3315",
                            "text": "Fonderies",
                            "keywords": "couler fabriquer fonderies fondu matrices métal moules pièces",
                            "children": [
                                {
                                    "id": "331529",
                                    "text": "Fonderies de métaux non ferreux (sauf moulage sous pression)",
                                    "keywords": "aluminium autrement couler cuivre etc fabriquer ferreux figurent fonderies fondus métaux moulage moules pièces pression zinc"
                                },
                                {
                                    "id": "331511",
                                    "text": "Fonderies de fer",
                                    "keywords": "alliages couler fabriquer fer fonderies fondus gueuse moules pièces"
                                },
                                {
                                    "id": "331514",
                                    "text": "Fonderies d'acier",
                                    "keywords": "creux d'acier fabriquer fonderies fondu moules partir pièces pleins utiliser"
                                },
                                {
                                    "id": "331523",
                                    "text": "Fonderies de métaux non ferreux, moulage sous pression",
                                    "keywords": "aluminium cuivre etc fabriquer ferreux fonderies fondus forte introduire matrice métallique métaux moulage moule pièces pression zinc"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "332",
                    "text": "Fabrication de produits métalliques",
                    "keywords": "assembler boulons charpentes chaudières conteneurs coutellerie d'architecture d'expédition écrous éléments entre estamper fabrication fabriquer ferreux fil forger former main métallique métalliques métaux outils produits quincaillerie réservoirs ressorts tourner tournés vis",
                    "children": [
                        {
                            "id": "3321",
                            "text": "Forgeage et estampage",
                            "keywords": "chaud commande découper définitives dimensions ébavurage emboutir estampage estampées eux-mêmes fabriquant feuilles finir forgeage forgées forger forme généralement métal meulage opération peuvent pièce pièces presque produire produisent revendent subir surface travaillent utilisent",
                            "children": [
                                {
                                    "id": "332113",
                                    "text": "Forgeage",
                                    "keywords": "allonger augmenter chaud comprennent cylindre davantage ébavurant effectuer employées façonner finition forge forgeage forgées forger hydraulique l'écrasement longueur l'utilisation marteau marteau-pilon marteaux matrices métal moyen perçage peuvent pièce pièces presse presses rectifiant réduire refoulage section techniques transformer transversale travail"
                                },
                                {
                                    "id": "332118",
                                    "text": "Estampage",
                                    "keywords": "accouplée aménagés avant bien cylindres découpage découper dessins différentes dimensions dit ébavurage encoches estampage façonner fentes feuilles formes l'aide limite l'opération machine matrice matrices mesure métal métalliques opérations peuvent pièce plusieurs pressage pressages proprement rotatifs s'effectuer seul travail trous voulues"
                                }
                            ]
                        },
                        {
                            "id": "3322",
                            "text": "Fabrication de coutellerie et d'outils à main",
                            "keywords": "bois coutellerie d'entretien d'outils fabrication fabriquer généraux limes main métaux outils tranchants travail travaux utilisés",
                            "children": [
                                {
                                    "id": "332210",
                                    "text": "Fabrication de coutellerie et d'outils à main",
                                    "keywords": "bois coutellerie d'entretien d'outils fabrication fabriquer généraux limes main métaux outils tranchants travail travaux utilisés"
                                }
                            ]
                        },
                        {
                            "id": "3323",
                            "text": "Fabrication de produits d'architecture et d'éléments de charpentes métalliques",
                            "keywords": "charpente charpentes d'architecture d'éléments éléments fabrication fabriquer métalliques produits travaux",
                            "children": [
                                {
                                    "id": "332311",
                                    "text": "Préfabrication de bâtiments en métal et de leurs composants",
                                    "keywords": "bâtiments composants métal métalliques préfabrication préfabriquer"
                                },
                                {
                                    "id": "332314",
                                    "text": "Fabrication de barres pour béton armé",
                                    "keywords": "achetées adhérence armé assemblages barres béton coupage d'armature fabrication fabriquer façonnage haute ouvrages pliage"
                                },
                                {
                                    "id": "332319",
                                    "text": "Fabrication d'autres tôles fortes et éléments de charpentes",
                                    "keywords": "achetées chaîne charpente charpentes d'acier découper effectué éléments épaisses fabrication fabriquer façonner figurent fortes installer mesure montage percer peuvent place plaques plier souder tôles travail usine vue"
                                },
                                {
                                    "id": "332321",
                                    "text": "Fabrication de portes et de fenêtres en métal",
                                    "keywords": "acier aluminium cadres fabrication fabriquer fenêtres garnitures métal métalliques moulures moustiquaires portes seuils"
                                },
                                {
                                    "id": "332329",
                                    "text": "Fabrication d'autres produits métalliques d'ornement et d'architecture",
                                    "keywords": "d'architecture d'ornement fabrication fabriquer figurent métalliques produits"
                                }
                            ]
                        },
                        {
                            "id": "3324",
                            "text": "Fabrication de chaudières, de réservoirs et de contenants d'expédition",
                            "keywords": "boîtes chaleur chaudières conserve contenants découper d'expédition échangeurs épais fabrication fabriquer façonner léger métal métalliques pièces produits réservoirs souder",
                            "children": [
                                {
                                    "id": "332420",
                                    "text": "Fabrication de réservoirs en métal (épais)",
                                    "keywords": "acier découper doivent épais fabrication fabriquer façonner gros installer métal montés pièces place réservoirs souder"
                                },
                                {
                                    "id": "332431",
                                    "text": "Fabrication de canettes",
                                    "keywords": "achetées acier aluminium canettes chrome contenants d'oxyde fabrication fabriquer feuilles métal recouvert"
                                },
                                {
                                    "id": "332439",
                                    "text": "Fabrication d'autres contenants en métal",
                                    "keywords": "contenants fabrication fabriquer feuilles figurent léger métal"
                                },
                                {
                                    "id": "332410",
                                    "text": "Fabrication de chaudières et d'échangeurs de chaleur",
                                    "keywords": "barres centrales chaîne chaleur chaudières d'échangeurs découper fabrication fabriquer façonner feuilles installer mesure métal montées nucléaires peuvent pièces place plaques souder tubes tuyaux usine"
                                }
                            ]
                        },
                        {
                            "id": "3325",
                            "text": "Fabrication d'articles de quincaillerie",
                            "keywords": "d'articles fabrication fabriquer métallique quincaillerie",
                            "children": [
                                {
                                    "id": "332510",
                                    "text": "Fabrication d'articles de quincaillerie",
                                    "keywords": "d'articles fabrication fabriquer métallique quincaillerie"
                                }
                            ]
                        },
                        {
                            "id": "3326",
                            "text": "Fabrication de ressorts et de produits en fil métallique",
                            "keywords": "acheté fabrication fabriquer faits fil métallique produits ressorts",
                            "children": [
                                {
                                    "id": "332611",
                                    "text": "Fabrication de ressorts (en métal épais)",
                                    "keywords": "automobiles échantillonnage épais fabrication fabriquer fort général machines matériels métal ressorts transport utilisés véhicules"
                                },
                                {
                                    "id": "332619",
                                    "text": "Fabrication d'autres produits en fil métallique",
                                    "keywords": "acheté fabrication fabriquer faits figurent fil métallique produits"
                                }
                            ]
                        },
                        {
                            "id": "3327",
                            "text": "Ateliers d'usinage, fabrication de produits tournés, de vis, d'écrous et de boulons",
                            "keywords": "aléser ateliers automatiques boulons chaîne complètes d'assemblage d'écrous destinées d'usinage écrous exploiter fabrication fabriquer façon fileter industrielles machines machines-outils métal pièces produisent produits tourner tournés tours transformer utilisent vendues vis visseuses",
                            "children": [
                                {
                                    "id": "332710",
                                    "text": "Ateliers d'usinage",
                                    "keywords": "aléseuses ateliers automatiques commande complètes destinés d'usinage équipements exploiter fabrication fraiseuses machines machines-outils mesure métal numérique pièces polisseuses produire réparation servant tours travailler vendus visseuses"
                                },
                                {
                                    "id": "332720",
                                    "text": "Fabrication de produits tournés, de vis, d'écrous et de boulons",
                                    "keywords": "aléser boulons coupant d'assemblage d'écrous dresser écrous équipés fabrication fabriquer façonner fendre fileter machines-outils métal métalliques moleter outil pièces précision produits rivets rondelles tourner tournés tours vis"
                                }
                            ]
                        },
                        {
                            "id": "3328",
                            "text": "Revêtement, gravure, traitement thermique et par le froid, et activités analogues",
                            "keywords": "analogues appliquer brasage chaud chauffer chromage coloration consistent destinés durcir durcissement effectuent façons galvanoplastie général graver gravure matières métal métalliques métaux notons opérations placage placages plastique polissage précieux produits recouvrir revêtement sablage semblables thermique traitement traiter travailler trempage vendus",
                            "children": [
                                {
                                    "id": "332810",
                                    "text": "Revêtement, gravure, traitement thermique et par le froid, et activités analogues",
                                    "keywords": "analogues appliquer brasage chaud chauffer chromage coloration consistent destinés durcir durcissement effectuent façons galvanoplastie général graver gravure matières métal métalliques métaux notons opérations placage placages plastique polissage précieux produits recouvrir revêtement sablage semblables thermique traitement traiter travailler trempage vendus"
                                }
                            ]
                        },
                        {
                            "id": "3329",
                            "text": "Fabrication d'autres produits métalliques",
                            "keywords": "fabrication fabriquer figurent métalliques produits",
                            "children": [
                                {
                                    "id": "332910",
                                    "text": "Fabrication de soupapes en métal",
                                    "keywords": "accessoires appareils connexes couler débit fabrication fabriquer gaz hydrauliques liquides métal pneumatiques régler soupapes tuyauteries usiner utilisées"
                                },
                                {
                                    "id": "332991",
                                    "text": "Fabrication de roulements à billes et à rouleaux",
                                    "keywords": "billes chemins fabrication fabriquer pièces rouleaux roulement roulements"
                                },
                                {
                                    "id": "332999",
                                    "text": "Fabrication de tous les autres produits métalliques divers",
                                    "keywords": "divers fabrication fabriquer figurent métalliques produits"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "333",
                    "text": "Fabrication de machines",
                    "keywords": "acheter applications assemblent classes classés commerciales complètes composent conçues contraire d'établissements distinction diverses d'usage d'usinage éléments employées encore entre eux-mêmes exclusive existe fabrication fabriquent fabriquer façon fondamentale former général généraux groupes indication industrie industrielles l'agriculture l'imprimerie machine machines métaux moyen neuf neuves opérations particulier particulière particulières peuvent pièces pompage premiers procédés production produisent rangés reflète remettre sous-ensembles spécialiser structure tendance transformation utilisées",
                    "children": [
                        {
                            "id": "3331",
                            "text": "Fabrication de machines pour l'agriculture, la construction et l'extraction minière",
                            "keywords": "conçues construction fabrication fabriquer l'agriculture l'extraction l'industrie machines minière utilisées",
                            "children": [
                                {
                                    "id": "333110",
                                    "text": "Fabrication de machines agricoles",
                                    "keywords": "agricoles arrosage battage champs commercialisation d'entretien entretien fabrication fabriquer horticoles machines moisson neige pelouses plantations préparation récoltes résidentielles servant sol souffleuses travaux"
                                },
                                {
                                    "id": "333120",
                                    "text": "Fabrication de machines pour la construction",
                                    "keywords": "arbres bétonneuses camions chargement chenilles ciel construction coupe défonceuses dents épandeuses etc fabrication fabriquer forestiers frontal grues lames l'exploitation l'extraction l'industrie lourds machines manutention matériel mécaniques minerai minière munis ouvert pelles peuvent pneus principalement servent tracteurs traitées travaux utilisées"
                                },
                                {
                                    "id": "333130",
                                    "text": "Fabrication de machines pour l'extraction minière et l'exploitation pétrolière et gazière",
                                    "keywords": "fabrication fabriquer gazière l'exploitation l'extraction machines matériel minière pétrolière"
                                }
                            ]
                        },
                        {
                            "id": "3332",
                            "text": "Fabrication de machines industrielles",
                            "keywords": "conçues fabrication fabriquer industrielles machines manufacturières précises utilisées",
                            "children": [
                                {
                                    "id": "333245",
                                    "text": "Fabrication de machines pour les scieries et le travail du bois",
                                    "keywords": "billes bois d'oeuvre fabrication fabriquer machines scieries servant transformer travail"
                                },
                                {
                                    "id": "333246",
                                    "text": "Fabrication de machines pour l'industrie du caoutchouc et du plastique",
                                    "keywords": "caoutchouc fabrication fabriquer l'industrie machines plastique servent traitement"
                                },
                                {
                                    "id": "333247",
                                    "text": "Fabrication de machines pour l'industrie papetière",
                                    "keywords": "fabrication fabriquer l'industrie machines papetière papier servant"
                                },
                                {
                                    "id": "333248",
                                    "text": "Fabrication de toutes les autres machines industrielles",
                                    "keywords": "fabrication fabriquer figurent industrielles machines"
                                }
                            ]
                        },
                        {
                            "id": "3333",
                            "text": "Fabrication de machines pour le commerce et les industries de services",
                            "keywords": "commerce fabrication fabriquer machines servant services",
                            "children": [
                                {
                                    "id": "333310",
                                    "text": "Fabrication de machines pour le commerce et les industries de services",
                                    "keywords": "commerce fabrication fabriquer machines servant services"
                                }
                            ]
                        },
                        {
                            "id": "3334",
                            "text": "Fabrication d'appareils de ventilation, de chauffage, de climatisation et de réfrigération commerciale",
                            "keywords": "chauffage climatisation commerciale d'appareils fabrication fabriquer matériel réfrigération ventilation",
                            "children": [
                                {
                                    "id": "333413",
                                    "text": "Fabrication de ventilateurs, de soufflantes et de purificateurs d'air industriels et commerciaux",
                                    "keywords": "commerciales commerciaux d'air fabrication fabriquer industrielles industriels machines purificateurs soufflantes ventilateurs"
                                },
                                {
                                    "id": "333416",
                                    "text": "Fabrication d'appareils de chauffage et de réfrigération commerciale",
                                    "keywords": "chauffage commercial commerciale d'appareils électrique fabrication fabriquer industriel matériel réfrigération"
                                }
                            ]
                        },
                        {
                            "id": "3335",
                            "text": "Fabrication de machines-outils pour le travail du métal",
                            "keywords": "accessoires bâtis calibres connexes couper fabrication fabriquer façonner fonctionnent industriels lorsqu'elles machines machines-outils main matrices métal moules outils personne peuvent pièces produits rouleaux s'agit tenues travail utilisées",
                            "children": [
                                {
                                    "id": "333511",
                                    "text": "Fabrication de moules industriels",
                                    "keywords": "couler fabrication industriels métalliques moules usiner"
                                },
                                {
                                    "id": "333519",
                                    "text": "Fabrication d'autres machines-outils pour le travail du métal",
                                    "keywords": "accessoires bâtis calibres connexes couper fabrication fabriquer façonner figurent fonctionnent industriels lorsqu'elles machines machines-outils main matrices métal moules outils personne peuvent pièces produits rouleaux s'agit tenues travail utilisées"
                                }
                            ]
                        },
                        {
                            "id": "3336",
                            "text": "Fabrication de moteurs, de turbines et de matériel de transmission de puissance",
                            "keywords": "automobiles avions combustion d'entraînement embrayages énergie éoliennes fabrication fabriquer grande industriels interne l'électricité matériel mécanismes moteurs produire puissance servant solaire transmission turbines turbogénérateurs variateurs vent vitesse",
                            "children": [
                                {
                                    "id": "333619",
                                    "text": "Fabrication d'autres moteurs et types de matériel de transmission de puissance",
                                    "keywords": "fabrication fabriquer figurant matériel moteurs puissance transmission types"
                                },
                                {
                                    "id": "333611",
                                    "text": "Fabrication de turbines et de groupes turbogénérateurs",
                                    "keywords": "fabrication fabriquer groupes turbines turbogénérateurs"
                                }
                            ]
                        },
                        {
                            "id": "3339",
                            "text": "Fabrication d'autres machines d'usage général",
                            "keywords": "conçues d'usage fabrication fabriquer figurent général industrie machines particulière utilisées",
                            "children": [
                                {
                                    "id": "333990",
                                    "text": "Fabrication de toutes les autres machines d'usage général",
                                    "keywords": "conçues d'usage fabrication fabriquer figurent général industrie machines particulière utilisées"
                                },
                                {
                                    "id": "333910",
                                    "text": "Fabrication de pompes et de compresseurs",
                                    "keywords": "compresseurs courant d'usage fabrication fabriquer matériel pompage pompes"
                                },
                                {
                                    "id": "333920",
                                    "text": "Fabrication de matériel de manutention",
                                    "keywords": "fabrication fabriquer manutention matériel"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "334",
                    "text": "Fabrication de produits informatiques et électroniques",
                    "keywords": "appel caractérisés circuits communication composants conception d'ordinateurs électroniques fabrication informatique informatiques intégrés l'utilisation matériel miniaturisation périphérique procédés production produits recours similaires spécialisées technologies très",
                    "children": [
                        {
                            "id": "3341",
                            "text": "Fabrication de matériel informatique et périphérique",
                            "keywords": "analogique analogiques arithmétiques automatiques autonomes balayage bancaires barres besoins boîtier calculs capables chargée circuits classification claviers codes commande compacts complètes comporter composants conçus considérés contrainte décision d'entrée-sortie déterminés devra d'exécuter dispositifs disques doit données d'ordinateurs doté dotés écrans ensembles exécution exige fabrication fins fonction fonctions fréquent gab guichets humaine hybride immédiatement imprimantes informatique installé intervention jeux l'acheteur lecteurs l'exécution l'extérieur l'intérieur logique l'ordinateur lots lui-même l'utilisateur manettes matériel mathématiques minimalement modèles modification monter nécessaires notons numérique ordinateurs passage-machine passifs pendant périphérique périphériques permettant peuvent plaquette point principaux programmation programme programmes rom simuler souris stockage suivantes terminaux tpv traitement types unités utilisés vendus vente",
                            "children": [
                                {
                                    "id": "334110",
                                    "text": "Fabrication de matériel informatique et périphérique",
                                    "keywords": "analogique analogiques arithmétiques automatiques autonomes balayage bancaires barres besoins boîtier calculs capables chargée circuits classification claviers codes commande compacts complètes comporter composants conçus considérés contrainte décision d'entrée-sortie déterminés devra d'exécuter dispositifs disques doit données d'ordinateurs doté dotés écrans ensembles exécution exige fabrication fins fonction fonctions fréquent gab guichets humaine hybride immédiatement imprimantes informatique installé intervention jeux l'acheteur lecteurs l'exécution l'extérieur l'intérieur logique l'ordinateur lots lui-même l'utilisateur manettes matériel mathématiques minimalement modèles modification monter nécessaires notons numérique ordinateurs passage-machine passifs pendant périphérique périphériques permettant peuvent plaquette point principaux programmation programme programmes rom simuler souris stockage suivantes terminaux tpv traitement types unités utilisés vendus vente"
                                }
                            ]
                        },
                        {
                            "id": "3342",
                            "text": "Fabrication de matériel de communication",
                            "keywords": "air câble capter communication électroniques fabrication matériel moyens radiodiffusion satellite servant signaux télédiffusion téléphonique",
                            "children": [
                                {
                                    "id": "334210",
                                    "text": "Fabrication de matériel téléphonique",
                                    "keywords": "appareils autonomes composants d'équipement données fabrication fil grands matériel peuvent produits systèmes téléphonique transmission"
                                },
                                {
                                    "id": "334220",
                                    "text": "Fabrication de matériel de radiodiffusion, de télédiffusion et de communication sans fil",
                                    "keywords": "communication fabrication fil matériel radiodiffusion télédiffusion"
                                },
                                {
                                    "id": "334290",
                                    "text": "Fabrication d'autres types de matériel de communication",
                                    "keywords": "communication fabrication figurent matériel types"
                                }
                            ]
                        },
                        {
                            "id": "3343",
                            "text": "Fabrication de matériel audio et vidéo",
                            "keywords": "audio électronique fabrication matériel vidéo",
                            "children": [
                                {
                                    "id": "334310",
                                    "text": "Fabrication de matériel audio et vidéo",
                                    "keywords": "audio électronique fabrication matériel vidéo"
                                }
                            ]
                        },
                        {
                            "id": "3344",
                            "text": "Fabrication de semi-conducteurs et d'autres composants électroniques",
                            "keywords": "chargement circuits composants couvre électroniques fabrication flexibles imprimés matière nues plaquettes production rigides semi-conducteurs stratifiée suivantes touchant",
                            "children": [
                                {
                                    "id": "334410",
                                    "text": "Fabrication de semi-conducteurs et d'autres composants électroniques",
                                    "keywords": "chargement circuits composants couvre électroniques fabrication flexibles imprimés matière nues plaquettes production rigides semi-conducteurs stratifiée suivantes touchant"
                                }
                            ]
                        },
                        {
                            "id": "3345",
                            "text": "Fabrication d'instruments de navigation, de mesure et de commande et d'instruments médicaux",
                            "keywords": "commande d'instruments fabrication médicaux mesure navigation",
                            "children": [
                                {
                                    "id": "334512",
                                    "text": "Fabrication d'appareils de mesure et de commande et d'appareils médicaux",
                                    "keywords": "commande d'appareils fabrication médicaux mesure"
                                },
                                {
                                    "id": "334511",
                                    "text": "Fabrication d'instruments de navigation et de guidage",
                                    "keywords": "d'instruments fabrication guidage matériel navigation"
                                }
                            ]
                        },
                        {
                            "id": "3346",
                            "text": "Fabrication et reproduction de supports magnétiques et optiques",
                            "keywords": "audio bandes compacts comprennent d'enregistrements disques disquettes durs enregistrés fabrication logiciels magnétiques magnétoscopiques multimédias optiques produits reproduction scellés série sonores supports vidéo vides",
                            "children": [
                                {
                                    "id": "334610",
                                    "text": "Fabrication et reproduction de supports magnétiques et optiques",
                                    "keywords": "audio bandes compacts comprennent d'enregistrements disques disquettes durs enregistrés fabrication logiciels magnétiques magnétoscopiques multimédias optiques produits reproduction scellés série sonores supports vidéo vides"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "335",
                    "text": "Fabrication de matériel, d'appareils et de composants électriques",
                    "keywords": "composants d'appareils d'électricité destinés distribution électriques fabrication l'utilisation matériel production produits",
                    "children": [
                        {
                            "id": "3351",
                            "text": "Fabrication de matériel électrique d'éclairage",
                            "keywords": "d'ampoules d'appareils d'éclairage électrique électriques fabrication matériel tubes",
                            "children": [
                                {
                                    "id": "335110",
                                    "text": "Fabrication d'ampoules électriques et de leurs pièces",
                                    "keywords": "ampoules d'ampoules électriques fabrication lampes pièces tubes types"
                                },
                                {
                                    "id": "335120",
                                    "text": "Fabrication d'appareils d'éclairage",
                                    "keywords": "d'appareils d'éclairage fabrication lampadaires lampes table"
                                }
                            ]
                        },
                        {
                            "id": "3352",
                            "text": "Fabrication d'appareils ménagers",
                            "keywords": "appareils bain cuisine d'appareils fabrication ménagers salle",
                            "children": [
                                {
                                    "id": "335210",
                                    "text": "Fabrication de petits appareils électroménagers",
                                    "keywords": "appareils commerciaux électriques électroménagers fabrication ménagers petits"
                                },
                                {
                                    "id": "335223",
                                    "text": "Fabrication de gros appareils ménagers de cuisine",
                                    "keywords": "appareils cuisine d'accessoires électriques fabrication gros ménagers"
                                },
                                {
                                    "id": "335229",
                                    "text": "Fabrication d'autres gros appareils ménagers",
                                    "keywords": "appareils d'accessoires électriques fabrication figurent gros ménagers"
                                }
                            ]
                        },
                        {
                            "id": "3353",
                            "text": "Fabrication de matériel électrique",
                            "keywords": "d'électricité distribution électrique fabrication matériel production",
                            "children": [
                                {
                                    "id": "335311",
                                    "text": "Fabrication de transformateurs de puissance et de distribution et de transformateurs spéciaux",
                                    "keywords": "distribution fabrication mesure puissance spéciaux transformateurs"
                                },
                                {
                                    "id": "335312",
                                    "text": "Fabrication de moteurs et de générateurs",
                                    "keywords": "électriques fabrication générateurs moteurs"
                                },
                                {
                                    "id": "335315",
                                    "text": "Fabrication d'appareillage de connexion, de commutation et de relais et de commandes d'usage industriel",
                                    "keywords": "commandes commutation connexion d'appareillage d'usage électrique fabrication industriel matériel protection relais"
                                }
                            ]
                        },
                        {
                            "id": "3359",
                            "text": "Fabrication d'autres types de matériel et de composants électriques",
                            "keywords": "composants courant d'accessoires d'électricité dispositifs électriques fabrication figurent matériel stockage transmission transport types",
                            "children": [
                                {
                                    "id": "335930",
                                    "text": "Fabrication de dispositifs de câblage",
                                    "keywords": "câblage courant dispositifs fabrication porteurs"
                                },
                                {
                                    "id": "335990",
                                    "text": "Fabrication de tous les autres types de matériel et composants électriques",
                                    "keywords": "composants électriques fabrication figurent matériel types"
                                },
                                {
                                    "id": "335910",
                                    "text": "Fabrication de batteries et de piles",
                                    "keywords": "batteries d'accumulateur fabrication pièces piles primaires secondaires stockage"
                                },
                                {
                                    "id": "335920",
                                    "text": "Fabrication de fils et de câbles électriques et de communication",
                                    "keywords": "achetés avant câbles communication effectuent électriques fabrication faits ferreux fibres fils isoler l'isolement optiques parfois réétirage"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "336",
                    "text": "Fabrication de matériel de transport",
                    "keywords": "air carrosseries complets divers eau établis fabrication fabriquent fonction gens groupes l'équipement marchandises matériel matériels moyens nouveaux pièces produits rail reconstruction remorques route routier servant transport transporter utilisé véhicules",
                    "children": [
                        {
                            "id": "3361",
                            "text": "Fabrication de véhicules automobiles",
                            "keywords": "automobiles cabine camion châssis fabrication fabriquent montent puis retrouve sous-ensembles véhicule véhicules",
                            "children": [
                                {
                                    "id": "336110",
                                    "text": "Fabrication de voitures et de véhicules automobiles légers",
                                    "keywords": "automobiles châssis électriques fabrication légers retrouve route usage véhicules voitures vue"
                                },
                                {
                                    "id": "336120",
                                    "text": "Fabrication de camions lourds",
                                    "keywords": "camions châssis fabrication lourds route usage véhicules vue"
                                }
                            ]
                        },
                        {
                            "id": "3362",
                            "text": "Fabrication de carrosseries et de remorques de véhicules automobiles",
                            "keywords": "acheté automobiles cabine cabines camions carrosserie carrosseries châssis commercial d'usage fabrication montées peuvent remorques véhicules vendues",
                            "children": [
                                {
                                    "id": "336211",
                                    "text": "Fabrication de carrosseries de véhicules automobiles",
                                    "keywords": "acheté achètent allongée ambulances automobiles balayeuses cabine camions carrosserie carrosseries cas châssis d'autobus détachées donc donnent fabrication fabriquent léger limousines lourd monté montés peuvent pièces pompiers retrouve rues semi-fini séparément spéciaux terminent véhicule véhicules vendues"
                                },
                                {
                                    "id": "336212",
                                    "text": "Fabrication de remorques de camions",
                                    "keywords": "camions châssis fabrication remorques"
                                },
                                {
                                    "id": "336215",
                                    "text": "Fabrication de maisons mobiles, roulottes de tourisme et campeuses",
                                    "keywords": "campeuses commercial d'usage fabrication maisons mobiles remorques roulottes tourisme"
                                }
                            ]
                        },
                        {
                            "id": "3363",
                            "text": "Fabrication de pièces pour véhicules automobiles",
                            "keywords": "automobiles celle correspondant fabrication moteurs neuves partie pièces réusinent véhicules",
                            "children": [
                                {
                                    "id": "336370",
                                    "text": "Emboutissage de pièces en métal pour véhicules automobiles",
                                    "keywords": "automobiles bavures connexes embouti emboutissage fabrication finis l'ébavurage l'élimination l'estampage métal opérations pièces produits résultant transforment véhicules"
                                },
                                {
                                    "id": "336390",
                                    "text": "Fabrication d'autres pièces pour véhicules automobiles",
                                    "keywords": "automobiles d'accessoires fabrication figurent pièces véhicules"
                                },
                                {
                                    "id": "336310",
                                    "text": "Fabrication de moteurs et de pièces de moteurs à essence pour véhicules automobiles",
                                    "keywords": "automobiles destinés essence fabrication moteurs pièces réusinage servir soient véhicules"
                                },
                                {
                                    "id": "336320",
                                    "text": "Fabrication de matériel électrique et électronique pour véhicules automobiles",
                                    "keywords": "automobiles combustion électrique électriques électronique électroniques fabrication interne matériel moteurs pièces réusinage véhicules"
                                },
                                {
                                    "id": "336330",
                                    "text": "Fabrication de composants de direction et de suspension pour véhicules automobiles (sauf les ressorts)",
                                    "keywords": "automobiles composants crémaillère direction fabrication l'exception mécanismes ressorts retrouve réusinage suspension systèmes véhicules"
                                },
                                {
                                    "id": "336340",
                                    "text": "Fabrication de systèmes de freinage pour véhicules automobiles",
                                    "keywords": "automobiles composants fabrication freinage systèmes véhicules"
                                },
                                {
                                    "id": "336350",
                                    "text": "Fabrication de pièces de transmission et de groupe motopropulseur pour véhicules automobiles",
                                    "keywords": "automobiles fabrication motopropulseur pièces réusinage transmission véhicules"
                                },
                                {
                                    "id": "336360",
                                    "text": "Fabrication de sièges et enjolivures intérieures pour véhicules automobiles",
                                    "keywords": "automobiles banquettes ceintures d'accessoires enjolivures fabrication garnitures intérieures matériel sangles sécurité sièges tissu transport véhicules"
                                }
                            ]
                        },
                        {
                            "id": "3364",
                            "text": "Fabrication de produits aérospatiaux et de leurs pièces",
                            "keywords": "aéronefs aérospatiaux auxiliaire conception conversion d'aéronefs fabrication matériel missiles moteurs pièces production produits propulsion prototypes retrouvent révision spatiaux systèmes tout usine véhicules",
                            "children": [
                                {
                                    "id": "336410",
                                    "text": "Fabrication de produits aérospatiaux et de leurs pièces",
                                    "keywords": "aéronefs aérospatiaux auxiliaire conception conversion d'aéronefs fabrication matériel missiles moteurs pièces production produits propulsion prototypes retrouvent révision spatiaux systèmes tout usine véhicules"
                                }
                            ]
                        },
                        {
                            "id": "3365",
                            "text": "Fabrication de matériel ferroviaire roulant",
                            "keywords": "autopropulsé ballast banlieue châssis chemin dameuses d'autre d'entretien fabrication fer ferroviaire gabarit importe locomotives matériel peu pièces poseurs rails rapide régaleuses retrouve réusinage roulant spécial train voie wagons",
                            "children": [
                                {
                                    "id": "336510",
                                    "text": "Fabrication de matériel ferroviaire roulant",
                                    "keywords": "autopropulsé ballast banlieue châssis chemin dameuses d'autre d'entretien fabrication fer ferroviaire gabarit importe locomotives matériel peu pièces poseurs rails rapide régaleuses retrouve réusinage roulant spécial train voie wagons"
                                }
                            ]
                        },
                        {
                            "id": "3366",
                            "text": "Construction de navires et d'embarcations",
                            "keywords": "barges cale carénage chantier comprenant comprennent construction construire d'embarcations désigne destinées d'usine embarcation embarcations entend fabrication fins fixes installations l'exploitation lorsqu'ils matériel modification naval navire navires offerts parties personnelles préfabriquées production récréatives réfection sèche servant services spécialisés terme transformation utilisées utilisés",
                            "children": [
                                {
                                    "id": "336611",
                                    "text": "Construction et réparation de navires",
                                    "keywords": "barges cale carénage chantier comprenant comprennent construction construire destinées d'usine embarcations entend fins fixes installations l'exploitation lorsqu'ils matériel modification naval navires offerts parties personnelles préfabriquées production récréatives réfection réparation sèche services spécialisés transformation utilisé utilisées"
                                },
                                {
                                    "id": "336612",
                                    "text": "Construction d'embarcations",
                                    "keywords": "construction d'embarcations destinée embarcation entend fabrication fins personnelles récréatives utilisée"
                                }
                            ]
                        },
                        {
                            "id": "3369",
                            "text": "Fabrication d'autres types de matériel de transport",
                            "keywords": "fabrication figurent matériel pièces transport types",
                            "children": [
                                {
                                    "id": "336990",
                                    "text": "Fabrication d'autres types de matériel de transport",
                                    "keywords": "fabrication figurent matériel pièces transport types"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "337",
                    "text": "Fabrication de meubles et de produits connexes",
                    "keywords": "articles aspect assembler bureaux cadre cadres canapés classés classiques composés concepteurs conçus confié connexes considérés découpe démontés design dominant effectué emploient expédiés fabrication fabriquer façonner fonction fonctionnelles hôtels important industriels l'absence l'attention lequel l'esthétique l'établissement l'usage maison matériau matériaux mesure meuble meubles montés moulage nombre opérations personnel peuvent pièces plat plusieurs portée procédés processus production produits propre qualités quel rembourrés retrouve selon servi stratification travail utilisé",
                    "children": [
                        {
                            "id": "3371",
                            "text": "Fabrication de meubles de maison et d'établissement institutionnel et d'armoires de cuisine",
                            "keywords": "armoires bains bâtiments bois comptoirs conçus cuisine d'armoires d'établissement écoles églises fabrication fabriquer institutionnel institutionnels maison meubles publics restaurants salle utilisés",
                            "children": [
                                {
                                    "id": "337121",
                                    "text": "Fabrication de meubles de maison rembourrés",
                                    "keywords": "fabrication fabriquer maison meubles rembourrés"
                                },
                                {
                                    "id": "337123",
                                    "text": "Fabrication d'autres meubles de maison en bois",
                                    "keywords": "bois chambres d'hôtel fabrication fabriquer logements maison meubles peuvent privés rembourrés retrouver"
                                },
                                {
                                    "id": "337126",
                                    "text": "Fabrication de meubles de maison (sauf en bois et rembourrés)",
                                    "keywords": "bois fabrication fabriquer maison meubles rembourrés"
                                },
                                {
                                    "id": "337127",
                                    "text": "Fabrication de meubles d'établissement institutionnel",
                                    "keywords": "bâtiments conçus d'établissement d'usine écoles églises établis fabrication fabriquer institutionnel institutions meubles mobilier porte-outils publics restaurants utilisés"
                                },
                                {
                                    "id": "337110",
                                    "text": "Fabrication d'armoires et de comptoirs de cuisine en bois",
                                    "keywords": "armoires bains bois comptoirs conçus cuisine d'armoires fabrication fabriquer installés permanence salle"
                                }
                            ]
                        },
                        {
                            "id": "3372",
                            "text": "Fabrication de meubles de bureau (y compris les articles d'ameublement)",
                            "keywords": "articles bureau bureaux cadres chaises d'ameublement d'exposition fabrication fabriquer genres magasin meubles pièces vitrines",
                            "children": [
                                {
                                    "id": "337213",
                                    "text": "Fabrication de meubles de bureau en bois, y compris les boiseries architecturales faites sur commande",
                                    "keywords": "architecturales bois boiseries bureau bureaux chaises commande composés d'accessoires fabrication fabriquer intérieurs mesure meubles surtout"
                                },
                                {
                                    "id": "337214",
                                    "text": "Fabrication de meubles de bureau (sauf en bois)",
                                    "keywords": "bois bureau bureaux chaises fabrication fabriquer matériaux meubles"
                                },
                                {
                                    "id": "337215",
                                    "text": "Fabrication de vitrines d'exposition, de cloisons, de rayonnages et de casiers",
                                    "keywords": "articles bureau cadres casiers cloisons d'ameublement d'exposition fabrication fabriquer genres magasin meuble meubles pièces rayonnages semblables usages vitrines"
                                }
                            ]
                        },
                        {
                            "id": "3379",
                            "text": "Fabrication d'autres produits connexes aux meubles",
                            "keywords": "connexes fabrication figurent meubles produits",
                            "children": [
                                {
                                    "id": "337910",
                                    "text": "Fabrication de matelas",
                                    "keywords": "connexes fabrication fabriquer matelas produits"
                                },
                                {
                                    "id": "337920",
                                    "text": "Fabrication de stores et de persiennes",
                                    "keywords": "connexes fabrication fabriquer l'intérieur persiennes produits stores"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "339",
                    "text": "Activités diverses de fabrication",
                    "keywords": "articles bijoux bureau diverses fabrication fabriquent figurent fournitures gamme jouets matériel médicaux produits sport vaste",
                    "children": [
                        {
                            "id": "3391",
                            "text": "Fabrication de fournitures et de matériel médicaux",
                            "keywords": "fabrication fournitures lentilles lunettes matériel médicaux meulage prescription rigides usine",
                            "children": [
                                {
                                    "id": "339110",
                                    "text": "Fabrication de fournitures et de matériel médicaux",
                                    "keywords": "fabrication fournitures lentilles lunettes matériel médicaux meulage prescription rigides usine"
                                }
                            ]
                        },
                        {
                            "id": "3399",
                            "text": "Autres activités diverses de fabrication",
                            "keywords": "diverses fabrication figurent",
                            "children": [
                                {
                                    "id": "339990",
                                    "text": "Toutes les autres activités diverses de fabrication",
                                    "keywords": "diverses fabrication figurent"
                                },
                                {
                                    "id": "339920",
                                    "text": "Fabrication d'articles de sport et d'athlétisme",
                                    "keywords": "chaussures d'articles d'athlétisme fabrication sport vêtements"
                                },
                                {
                                    "id": "339910",
                                    "text": "Fabrication de bijoux et de pièces d'argenterie",
                                    "keywords": "articles bijoux ciselure couverts culture d'argenterie d'articles dégrossissage étain fabrication facettage fantaisie frappe gemmes gravure l'eau-forte métaux monnaies pelage perçage perles pièces pierres plaqué polissage précieuses précieux sciage seconde semi-précieuses sertissage taille tonnelage"
                                },
                                {
                                    "id": "339930",
                                    "text": "Fabrication de poupées, de jouets et de jeux",
                                    "keywords": "fabrication jeux jouets poupées"
                                },
                                {
                                    "id": "339950",
                                    "text": "Fabrication d'enseignes",
                                    "keywords": "carton d'affiches d'enseignes fabrication matières papier similaires"
                                },
                                {
                                    "id": "339940",
                                    "text": "Fabrication de fournitures de bureau (sauf la papeterie)",
                                    "keywords": "bureau fabrication fournitures papeterie papier"
                                }
                            ]
                        }
                    ]
                }
                
            ]
        },
        
        
        {
            "id": "41",
            "text": "Commerce de gros",
            "keywords": "achètent agents agricoles appeler appellations assurer assurés autrement bannière beaucoup biens bureau bureaux catégorie cependant certains classes client clientèle clients commerce commerciaux commission compte concessionnaires connexes connus consommation co-op coopératives courtiers d'acheteurs d'autre d'entrepôts d'équipement détaillants deviennent d'honoraires d'import-export directement distributeurs distribution dit diverses donc emploient entrent entreprises entretiennent étape expédier finals formation fournir fournissent fournisseur fournisseurs gammes garantie général gestion grande grandes grands gros grossiste grossistes groupes huit institutionnelle intermédiaire intermédiaires interne l'emballage l'étiquetage l'expédition liens logistique lourds machines marchandises marchands marketing matériel méthode moyennant nécessaire négociants organisés particulière partir peuvent pièce poids premiers produit produits promotion propre propriétaires quantités rassemblent rayon réclamations répartition repose requise s'approprient selon services soient sous-secteurs soutien stock stocks tiers titre traitement travaillent types utilisateurs vendent vendre vendues vente versement",
            "children": [
                {
                    "id": "411",
                    "text": "Grossistes-marchands de produits agricoles",
                    "keywords": "agricoles animaux céréales gros grossistes-distributeurs produits vendre vivants",
                    "children": [
                        {
                            "id": "411110",
                            "text": "Grossistes-marchands d'animaux vivants",
                            "keywords": "animaux d'animaux grossistes-distributeurs vendre vivants"
                        },
                        {
                            "id": "411120",
                            "text": "Grossistes-marchands de graines oléagineuses et de grains céréaliers",
                            "keywords": "céréales élévateurs exploitent graines grains gros grossistes-distributeurs l'entreposage oléagineuses primaire vendre"
                        },
                        {
                            "id": "411130",
                            "text": "Grossistes-marchands de produits et plantes de pépinières",
                            "keywords": "gros grossistes-distributeurs pépinières plantes produits vendre"
                        },
                        {
                            "id": "411190",
                            "text": "Grossistes-marchands d'autres produits agricoles",
                            "keywords": "agricoles bruts figurent gros grossistes-distributeurs produits traités vendre"
                        }
                    ]
                },
                {
                    "id": "412",
                    "text": "Grossistes-marchands de pétrole et de produits pétroliers",
                    "keywords": "brut domestique gaz grossistes-distributeurs liquéfié mazout pétrole pétroliers produits raffinés vendre",
                    "children": [
                        {
                            "id": "412110",
                            "text": "Grossistes-marchands de pétrole et de produits pétroliers",
                            "keywords": "brut domestique gaz grossistes-distributeurs liquéfié mazout pétrole pétroliers produits raffinés vendre"
                        }
                    ]
                },
                {
                    "id": "413",
                    "text": "Grossistes-marchands de produits alimentaires, de boissons et de tabac",
                    "keywords": "alimentaires boissons gros grossistes-distributeurs produits tabac vendre",
                    "children": [
                        {
                            "id": "413190",
                            "text": "Grossistes-marchands d'autres gammes spécialisées d'aliments",
                            "keywords": "alimentaires aliments conditionnés congelés conserves figurent gros grossistes-distributeurs produits spécialisés spéciaux vendre"
                        },
                        {
                            "id": "413210",
                            "text": "Grossistes-marchands de boissons non alcoolisées",
                            "keywords": "alcoolisées boissons gros grossistes-distributeurs vendre"
                        },
                        {
                            "id": "413160",
                            "text": "Grossistes-marchands de viandes rouges et de produits de viande",
                            "keywords": "conditionnée congelée cuite fraîche fumée gros grossistes-distributeurs produits rouges vendre viande viandes"
                        },
                        {
                            "id": "413110",
                            "text": "Grossistes-marchands de gamme complète d'aliments",
                            "keywords": "alimentaires gamme généraux gros grossistes-distributeurs produits vendre"
                        },
                        {
                            "id": "413120",
                            "text": "Grossistes-marchands de produits laitiers",
                            "keywords": "gros grossistes-distributeurs lait laitiers produits vendre"
                        },
                        {
                            "id": "413140",
                            "text": "Grossistes-marchands de poissons et de fruits de mer",
                            "keywords": "congelés emballés frais fruits fumés gros grossistes-distributeurs mer poisson poissons vendre"
                        },
                        {
                            "id": "413150",
                            "text": "Grossistes-marchands de fruits et légumes frais",
                            "keywords": "détaillants fournissent frais fruits gros grossistes-distributeurs légumes nettoyer reconditionner trier vendre"
                        },
                        {
                            "id": "413130",
                            "text": "Grossistes-marchands de volailles et d'oeufs",
                            "keywords": "d'oeufs gros grossistes-distributeurs habillée oeufs vendre volaille volailles"
                        },
                        {
                            "id": "413220",
                            "text": "Grossistes-marchands de boissons alcoolisées",
                            "keywords": "alcoolisées boissons gros grossistes-distributeurs vendre"
                        },
                        {
                            "id": "413310",
                            "text": "Grossistes-marchands de cigarettes et de produits du tabac",
                            "keywords": "cigarettes gros grossistes-distributeurs produits tabac traités vendre"
                        },
                        {
                            "id": "413410",
                            "text": "Grossistes-marchands de cannabis",
                            "keywords": "grossistes-marchands d'huile de cannabis grossistes-marchands de cannabis séché"
                        }
                    ]
                },
                {
                    "id": "414",
                    "text": "Grossistes-marchands d'articles personnels et ménagers",
                    "keywords": "accessoires appareils articles beauté chaussures d'articles divers divertissement équipements gros grossistes-distributeurs maison ménagers personnels pharmacie produits textiles toilette vendre vêtements",
                    "children": [
                        {
                            "id": "414450",
                            "text": "Grossistes-marchands d'enregistrements vidéo",
                            "keywords": "enregistrées gros grossistes vendre vidéocassettes"
                        },
                        {
                            "id": "414410",
                            "text": "Grossistes-marchands de bijoux et de montres",
                            "keywords": "argenterie bijoux coutellerie couverts gros grossistes-distributeurs métal montres plats précieux vendre"
                        },
                        {
                            "id": "414420",
                            "text": "Grossistes-marchands de livres, de périodiques et de journaux",
                            "keywords": "dictionnaires encyclopédies gros grossistes-distributeurs journaux livres manuels périodiques vendre"
                        },
                        {
                            "id": "414430",
                            "text": "Grossistes-marchands de matériel et fournitures photographiques",
                            "keywords": "fournitures gros grossistes-distributeurs matériel photographiques vendre"
                        },
                        {
                            "id": "414440",
                            "text": "Grossistes-marchands d'enregistrements sonores",
                            "keywords": "achètent cassettes compacts concessionnaires désigne disques distribuent distributeurs enregistrements formes gros grossistes guichet importés l'appellation parfois rayon sonores unique vendre"
                        },
                        {
                            "id": "414460",
                            "text": "Grossistes-marchands de jouets et d'articles de passe-temps",
                            "keywords": "articles d'articles gros grossistes-distributeurs jouets passe-temps vendre"
                        },
                        {
                            "id": "414470",
                            "text": "Grossistes-marchands d'articles de divertissement et de sport",
                            "keywords": "articles d'articles divertissement gros grossistes-distributeurs sport vendre"
                        },
                        {
                            "id": "414510",
                            "text": "Grossistes-marchands de produits et fournitures pharmaceutiques",
                            "keywords": "articles contrôlés fournitures gros grossistes-distributeurs marque médicaments pharmaceutiques pharmacie produits vendre"
                        },
                        {
                            "id": "414520",
                            "text": "Grossistes-marchands d'articles de toilette, de cosmétiques et d'articles divers ",
                            "keywords": "articles cosmétiques d'articles divers gros grossistes-distributeurs pharmacie produits toilette vendre"
                        },
                        {
                            "id": "414210",
                            "text": "Grossistes-marchands de matériel de divertissement au foyer",
                            "keywords": "divertissement équipements foyer gros grossistes-distributeurs matériel neufs pièces vendre"
                        },
                        {
                            "id": "414220",
                            "text": "Grossistes-marchands d'appareils ménagers",
                            "keywords": "appareils d'appareils électriques gros grossistes-distributeurs ménagers neufs petits vendre"
                        },
                        {
                            "id": "414310",
                            "text": "Grossistes-marchands de porcelaine, verrerie, faïence et poterie",
                            "keywords": "articles céramique cuisine faïence gros grossistes-distributeurs ménage porcelaine poterie table ustensiles vendre verrerie"
                        },
                        {
                            "id": "414320",
                            "text": "Grossistes-marchands de revêtements de sol",
                            "keywords": "gros grossistes-distributeurs revêtements sol vendre"
                        },
                        {
                            "id": "414330",
                            "text": "Grossistes-marchands de linge de maison, de tentures et d'autres textiles domestiques",
                            "keywords": "domestiques gros grossistes-distributeurs linge literie maison tentures textiles vendre"
                        },
                        {
                            "id": "414390",
                            "text": "Grossistes-marchands d'autres accessoires de maison",
                            "keywords": "accessoires assortiment cadres d'accessoires décoration fenêtres figurent gros grossistes-distributeurs maison miroirs mobilier objets spécialiser stores tableaux vendre"
                        },
                        {
                            "id": "414110",
                            "text": "Grossistes-marchands de vêtements et d'accessoires vestimentaires",
                            "keywords": "accessoires adultes d'accessoires enfants gros grossistes-distributeurs vendre vestimentaires vêtements"
                        },
                        {
                            "id": "414120",
                            "text": "Grossistes-marchands de chaussures",
                            "keywords": "chaussures gros grossistes-distributeurs vendre"
                        },
                        {
                            "id": "414130",
                            "text": "Grossistes-marchands de tissus à la pièce et d'articles de mercerie",
                            "keywords": "articles d'articles gros grossistes-distributeurs mercerie nouveautés pièce tissu tissus vendre"
                        }
                    ]
                },
                {
                    "id": "415",
                    "text": "Grossistes-marchands de véhicules automobiles, et de pièces et d'accessoires de véhicules automobiles ",
                    "keywords": "accessoires automobiles gros grossistes-distributeurs pièces pneus véhicules vendre",
                    "children": [
                        {
                            "id": "415310",
                            "text": "Grossistes-marchands de pièces et d'accessoires d'occasion pour véhicules automobiles",
                            "keywords": "accessoires automobiles d'accessoires démontées démonter d'occasion ferrailleurs généralement gros grossistes-distributeurs pièces véhicules vendent vendre"
                        },
                        {
                            "id": "415190",
                            "text": "Grossistes-marchands de véhicules de plaisance et d'autres véhicules automobiles",
                            "keywords": "automobiles camping figurent gros grossistes-distributeurs moteur plaisance remorques véhicules vendre"
                        },
                        {
                            "id": "415210",
                            "text": "Grossistes-marchands de pneus",
                            "keywords": "air chambres gros grossistes-distributeurs pneus véhicules vendre"
                        },
                        {
                            "id": "415290",
                            "text": "Grossistes-marchands d'autres pièces et d'accessoires neufs pour véhicules automobiles",
                            "keywords": "accessoires automobiles carrossiers chimiques d'accessoires figurent fournitures gros grossistes-distributeurs neuf neufs pièces produits rembourreurs remis véhicules vendre"
                        },
                        {
                            "id": "415120",
                            "text": "Grossistes-marchands de camions, de tracteurs routiers et d'autobus",
                            "keywords": "autobus camions d'autobus d'occasion gros grossistes-distributeurs lourds neufs poids routiers tracteurs vendre"
                        },
                        {
                            "id": "415110",
                            "text": "Grossistes-marchands d'automobiles et de camions légers neufs et d'occasion",
                            "keywords": "automobiles camions d'automobiles d'occasion gros grossistes-distributeurs légers mini-fourgonnettes neufs sport véhicules vendre"
                        }
                    ]
                },
                {
                    "id": "416",
                    "text": "Grossistes-marchands de matériaux et fournitures de construction",
                    "keywords": "bois chauffage climatisation construction d'oeuvre électriques fournitures gros grossistes-distributeurs matériaux matériel menuiserie métal métalliques plomberie préfabriquée produits quincaillerie vendre",
                    "children": [
                        {
                            "id": "416110",
                            "text": "Grossistes-marchands de fils et de fournitures électriques de construction",
                            "keywords": "centrales construction électriques équipements fils fournitures génératrices gros grossistes grossistes-distributeurs l'électricité matériel moteurs production transformateurs transmission vendre"
                        },
                        {
                            "id": "416120",
                            "text": "Grossistes-marchands de matériel et fournitures de plomberie, de chauffage et de climatisation",
                            "keywords": "chauffage climatisation fournitures gros grossistes-distributeurs matériel plomberie vendre"
                        },
                        {
                            "id": "416210",
                            "text": "Grossistes-distributeurs de métaux et de produits métalliques",
                            "keywords": "client couper demande emboutir façon gros grossistes-distributeurs métalliques métaux peuvent produits transformer vendre"
                        },
                        {
                            "id": "416310",
                            "text": "Grossistes-marchands d'une gamme générale de fournitures de construction",
                            "keywords": "bois choix construction d'oeuvre électriques fournitures générales gros grossistes-distributeurs peinture plomberie quincaillerie tout vendre verre"
                        },
                        {
                            "id": "416320",
                            "text": "Grossistes-marchands de bois d'oeuvre, de contreplaqués et de menuiseries préfabriquées",
                            "keywords": "bois brut construction contreplaqué contreplaqués d'oeuvre dressé gros grossistes-distributeurs menuiserie menuiseries préfabriquée préfabriquées produits vendre"
                        },
                        {
                            "id": "416330",
                            "text": "Grossistes-marchands d'articles de quincaillerie",
                            "keywords": "d'articles gros grossistes-distributeurs outils quincaillerie spécialisés vendre"
                        },
                        {
                            "id": "416340",
                            "text": "Grossistes-marchands de peintures, de vitres et de papier peint",
                            "keywords": "articles décoration gros grossistes-distributeurs mural papier peint peintures vendre vernis verre vitres"
                        },
                        {
                            "id": "416390",
                            "text": "Grossistes-marchands de gammes spécialisées de fournitures de construction",
                            "keywords": "construction figurent fournitures gros grossistes-distributeurs spéciales spécialisées vendre"
                        }
                    ]
                },
                {
                    "id": "417",
                    "text": "Grossistes-marchands de machines, de matériel et de fournitures",
                    "keywords": "communication construction équipements foresterie fournitures gros grossistes-distributeurs industriels jardinage l'agriculture l'entretien l'extraction machines matériel minière ordinateurs pelouses vendre",
                    "children": [
                        {
                            "id": "417110",
                            "text": "Grossistes-marchands de machines et matériel pour l'agriculture, l'entretien des pelouses et le jardinage",
                            "keywords": "d'occasion gros grossistes-distributeurs jardinage l'agriculture l'entretien machines matériel neufs pelouses pièces vendre"
                        },
                        {
                            "id": "417210",
                            "text": "Grossistes-marchands de machines, matériel et fournitures pour la construction et la foresterie",
                            "keywords": "construction d'occasion foresterie fournitures gros grossistes-distributeurs machines matériel neufs pièces vendre"
                        },
                        {
                            "id": "417220",
                            "text": "Grossistes-marchands de machines, matériel et fournitures pour l'extraction minière, pétrolière et gazière",
                            "keywords": "d'occasion fournitures gaz gazière gros grossistes-distributeurs l'exploitation l'extraction machines matériel minerais minière neufs pétrole pétrolière pièces raffineries vendre"
                        },
                        {
                            "id": "417230",
                            "text": "Grossistes-marchands de machines, matériel et fournitures industriels",
                            "keywords": "d'occasion fournitures gros grossistes-distributeurs industriels machines matériel neufs pièces vendre"
                        },
                        {
                            "id": "417310",
                            "text": "Grossistes-marchands d'ordinateurs, de périphériques et de logiciels de série",
                            "keywords": "d'occasion d'ordinateurs gros grossistes-distributeurs logiciels neufs ordinateurs périphériques série vendre"
                        },
                        {
                            "id": "417990",
                            "text": "Grossistes-marchands de tous les autres machines, matériel et fournitures",
                            "keywords": "aéronef assortiment automobiles bateau classes d'aéronef d'attractions d'occasion figurent fournitures gros grossistes grossistes-distributeurs jeux locomotives machines matériel moteurs neufs non-électronique parcs pêche plaisance produits rangés spécialiser terrains véhicules vendre"
                        },
                        {
                            "id": "417320",
                            "text": "Grossistes-marchands de composants électroniques, et de matériel et fournitures de navigation et de communication",
                            "keywords": "communication composants électroniques fournitures gros grossistes-distributeurs interphones matériel navigation neufs sonorisation systèmes téléavertisseurs téléphones usagés vendre"
                        },
                        {
                            "id": "417910",
                            "text": "Grossistes-marchands de machines et matériel de bureau et de magasin",
                            "keywords": "accessoires bureau d'occasion gros grossistes-distributeurs machines magasin matériel meubles neufs vendre"
                        },
                        {
                            "id": "417920",
                            "text": "Grossistes-marchands de machines, matériel et fournitures d'établissements de service",
                            "keywords": "d'établissement d'occasion fournitures gros grossistes-distributeurs machines matériel neufs services vendre"
                        },
                        {
                            "id": "417930",
                            "text": "Grossistes-marchands de machines, matériel et fournitures d'usage professionnel",
                            "keywords": "d'occasion d'usage fournitures gros grossistes-distributeurs machines matériel neufs professionnel usage vendre"
                        }
                    ]
                },
                {
                    "id": "418",
                    "text": "Grossistes-marchands de produits divers",
                    "keywords": "agricoles assimilés automobiles billes bois chimiques copeaux divers d'occasion figurent fournitures gros grossistes-distributeurs jetables machines marchandises matières métaux minerais minéraux papier plastique précieux produits recyclables vendre",
                    "children": [
                        {
                            "id": "418990",
                            "text": "Tous les autres grossistes-marchands",
                            "keywords": "activité assortiment constituer diverses figurent gros grossistes-distributeurs importante ligne marchandises n'est produits suffisamment unique vendre"
                        },
                        {
                            "id": "418410",
                            "text": "Grossistes-marchands de produits chimiques et de produits analogues (sauf agricoles)",
                            "keywords": "agricoles analogues chimiques domestique formes gaz gros grossistes-distributeurs industriel industriels nettoyage plastique plastiques préparations primaires produits résines usage vendre"
                        },
                        {
                            "id": "418110",
                            "text": "Grossistes-marchands de métaux recyclables",
                            "keywords": "acheter automobiles casse destinées ferreux grossistes-distributeurs métaux mettre morceaux récupération recyclables trier vendre"
                        },
                        {
                            "id": "418120",
                            "text": "Grossistes-marchands de papier et carton recyclables",
                            "keywords": "acheter carton cartons grossistes-distributeurs journaux mettre morceaux papier papiers recyclables trier usagés vendre"
                        },
                        {
                            "id": "418190",
                            "text": "Grossistes-marchands d'autres matières recyclables",
                            "keywords": "acheter boues broyer déchiqueter d'épuration figurent grossistes-distributeurs liquides matières mettre morceaux plastiques recyclables textiles trier vendre verre"
                        },
                        {
                            "id": "418210",
                            "text": "Grossistes-marchands de papeterie et de fournitures de bureau",
                            "keywords": "bureau fournitures gros grossistes-distributeurs papeterie vendre"
                        },
                        {
                            "id": "418220",
                            "text": "Grossistes-marchands d'autres papiers et de produits en plastique jetables",
                            "keywords": "assiettes assortiment ciré classes coutellerie étirable film gros grossistes-distributeurs hygiénique jetables ménagers mouchoirs nappes papier papiers plastique plateaux produits rangés récipients serviettes spécialiser tasses vendre"
                        },
                        {
                            "id": "418310",
                            "text": "Grossistes-marchands d'aliments pour animaux d'élevage",
                            "keywords": "aliments animaux d'aliments d'élevage gros grossistes grossistes-distributeurs maison vendre"
                        },
                        {
                            "id": "418390",
                            "text": "Grossistes-marchands de produits chimiques et autres fournitures agricoles",
                            "keywords": "agricoles assortiment chimiques classes engrais figurent fournitures gros grossistes-distributeurs herbicides pesticides produits rangés spécialiser vendre"
                        },
                        {
                            "id": "418320",
                            "text": "Grossistes-marchands de semences",
                            "keywords": "culture cultures fleurs gazon grandes gros grossistes-distributeurs horticoles plantes semences vendre"
                        },
                        {
                            "id": "418910",
                            "text": "Grossistes-marchands de billes et de copeaux de bois",
                            "keywords": "billes billons bois copeaux forestiers gros grossistes-distributeurs produits transformés vendre"
                        },
                        {
                            "id": "418920",
                            "text": "Grossistes-marchands de minéraux, de minerais et de métaux précieux",
                            "keywords": "concentrés gros grossistes-distributeurs métaux minerais minéraux précieux vendre"
                        },
                        {
                            "id": "418930",
                            "text": "Grossistes-marchands de marchandises d'occasion (sauf les machines et les produits automobiles)",
                            "keywords": "automobiles d'occasion gros grossistes-distributeurs machines marchandises produits vendre"
                        }
                    ]
                },
                {
                    "id": "419",
                    "text": "Commerce électronique de gros entre entreprises, et agents et courtiers",
                    "keywords": "acheter achetés acheteurs agents appartenant appelés commerce commerciales commission compte courtiers d'approvisionnement détenir d'exportation d'honoraires d'importation d'intermédiaires effectuent électronique électroniques entre entreprises etou genres gros mandant manufacturiers marchés moyennant négociants opérations produits propriété représentants servent tiers titre travaillant vendeurs vendre vendus vente versement",
                    "children": [
                        {
                            "id": "419120",
                            "text": "Agents et courtiers du commerce de gros",
                            "keywords": "acheter achetés acheteurs agents appartenant assumer biens commerce commerciales commission compte courtiers d'approvisionnement d'exportation d'importation d'intermédiaires effectuent entre etou genres gros mandant manufacturiers moyennant négociants normalement opérations produits propriété représentants servent tiers titre travaillant vendeurs vendre vendus vente versement"
                        },
                        {
                            "id": "419110",
                            "text": "Commerce électronique de gros entre entreprises",
                            "keywords": "achetés acheteurs assumer biens commerce commission d'honoraires d'intermédiaires d'occasion électronique électroniques entre entreprises facilitent faciliter général gros internet l'encan ligne marchés moyennant moyens neufs opérations produits propriété servent titre vendeurs vendus vente versement"
                        }
                    ]
                }
            ]
        },
        {
            "id": "44-45",
            "text": "Commerce de détail",
            "keywords": "alors après-vente assimilés assurent atteindre attirer automatiques biens bureau caractéristiques cas catalogue catalogues certains chaîne chez ci-après classés clientèle clients commerce commercialiser compte conçus connexes consommation construction d'achat d'appareils date d'automobiles décrites d'électronique démonstrations dernier dernière d'établissements détail détaillant détaillants d'exposition diffèrent diffusion d'installation d'instruments directe distributeurs distribution domicile donc d'ordinateurs effectuée effet électriques électroniques entreprises étalages etc eux façon fenêtres fixes fournir fournissent fournitures fréquemment garnitures généralement grand grands hors infopublicité institutionnelle intéressent journaux l'achat l'information livraison livrent logiciels magasin magasins maillon maisons manière marchandise marchandises marchands matériaux mazout médias ménagers ménages messager méthodes mobiles moment moyens musique neuves nombre normalement nouvelles organisés particuliers passants payer petites peuvent plomberie points porte-à-porte postaux présentations presse principales public publication publicité quantités radio radiodiffusion recourant recourent règle réparation représente revanche revêtements salles selon servent service services servir situés sociétés sol stands stations-service suivants surtout technologies télévision temporaires tiers touchent toucher traditionnels transformation types utilisent varient vendent vendeurs vendre vente",
            "children": [
                {
                    "id": "441",
                    "text": "Concessionnaires de véhicules et de pièces automobiles",
                    "keywords": "accessoires automobiles détail généralement marchands particuliers pièces rattachent services spécialisés s'y types véhicules vendre vente",
                    "children": [
                        {
                            "id": "441210",
                            "text": "Concessionnaires de véhicules récréatifs ",
                            "keywords": "accessoires autocaravanes campeuses caravanes détachées détail d'occasion fournir marchands neufs outre pièces plaisance réparation services véhicules vendent vendre"
                        },
                        {
                            "id": "441220",
                            "text": "Concessionnaires de motocyclettes, de bateaux et d'autres véhicules automobiles ",
                            "keywords": "accessoires automobiles avions bateaux détachées détail d'occasion fournir marchands motocyclettes motoneiges neufs outre pièces remorques réparation services tout-terrains utilitaires véhicules vendent vendre"
                        },
                        {
                            "id": "441310",
                            "text": "Magasins de pièces et d'accessoires pour véhicules automobiles",
                            "keywords": "accessoires automobiles d'accessoires détail d'occasion généralement installateur lesquels magasins nécessaire neuf neufs pièces remis réparer véhicules vendre"
                        },
                        {
                            "id": "441320",
                            "text": "Marchands de pneus",
                            "keywords": "air chambres complémentaires détail fournissent l'alignement l'équilibrage marchands montage outre pneus roues services vendre"
                        },
                        {
                            "id": "441110",
                            "text": "Concessionnaires d'automobiles neuves ",
                            "keywords": "accessoires automobiles camionnettes camions consommateurs d'automobiles détachées détail directement d'occasion fournir général légers loueurs marchands mini-fourgonnettes neufs neuves outre pièces réparation services sportifs utilitaires véhicules vendent vendre voitures"
                        },
                        {
                            "id": "441120",
                            "text": "Concessionnaires d'automobiles d'occasion ",
                            "keywords": "automobiles camionnettes camions d'automobiles détail d'occasion légers marchands mini-fourgonnettes sportifs utilitaires véhicules vendre"
                        }
                    ]
                },
                {
                    "id": "442",
                    "text": "Magasins de meubles et d'accessoires de maison",
                    "keywords": "accessoires beaucoup complément d'accessoires décoration détail d'exposition intérieure magasins maison meubles neufs offrent partir salles services vendent vendre",
                    "children": [
                        {
                            "id": "442110",
                            "text": "Magasins de meubles",
                            "keywords": "accessoires appareils bureau décoration détail d'intérieur électroniques fournir gros intérieure magasins maison ménagers meubles neufs peuvent revêtements services sol vendre"
                        },
                        {
                            "id": "442210",
                            "text": "Magasins de revêtements de sol",
                            "keywords": "assurent carreaux céramique détail d'installation magasins moquettes neufs outre parquets réparation revêtements services sol sols tapis vendre vinyle"
                        },
                        {
                            "id": "442291",
                            "text": "Magasins de garnitures de fenêtres",
                            "keywords": "détail fenêtres garnitures magasins mesure poser prêts stores tentures vendre"
                        },
                        {
                            "id": "442292",
                            "text": "Magasins de matériel d'encadrement",
                            "keywords": "affiches cadres d'art d'encadrement détail d'oeuvres encadrer estampes limité magasins matériel mesure monter nombre originales outre peuvent plastifier poser prêts vendre"
                        },
                        {
                            "id": "442298",
                            "text": "Magasins de tous les autres accessoires de maison",
                            "keywords": "accessoires détail figurent magasins maison neufs vendre"
                        }
                    ]
                },
                {
                    "id": "443",
                    "text": "Magasins d'appareils électroniques et ménagers",
                    "keywords": "appareils articles audio comparables d'appareils détachées détail électroniques équipement fournir magasins ménagers ordinateurs outre peuvent photographiques pièces réparation services vendre vidéo",
                    "children": [
                        {
                            "id": "443143",
                            "text": "Magasins d'appareils ménagers, de téléviseurs et d'autres appareils électroniques",
                            "keywords": "appareils audio d'appareils détail d'occasion électroniques fournir logiciels magasins matériel ménagers neufs ordinateurs outre peuvent réparation services téléviseurs vendre vidéo"
                        },
                        {
                            "id": "443144",
                            "text": "Magasins d'ordinateurs et de logiciels",
                            "keywords": "accessoires connexes détachées détail d'occasion d'ordinateurs électroniques fournir informatique jeux l'emploi logiciels magasins matériel neufs ordinateurs outre périphériques peuvent pièces prêts produits réparation services vendre"
                        },
                        {
                            "id": "443145",
                            "text": "Magasins d'appareils et de fournitures photographiques",
                            "keywords": "accessoires appareils d'appareils détachées détail développement d'occasion équipements films fournir fournitures magasins neufs outre peuvent photographiques pièces réparation services vendre"
                        },
                        {
                            "id": "443146",
                            "text": "Magasins d'enregistrements vidéo et audio",
                            "keywords": "audio bandes compacts détail disques enregistrements format magasins neufs préenregistrées support vendre vidéo"
                        }
                    ]
                },
                {
                    "id": "444",
                    "text": "Marchands de matériaux de construction et de matériel et fournitures de jardinage",
                    "keywords": "construction détail fournitures gamme jardinage l'extérieur marchands matériaux matériel motorisé plants produits rénovation spécialisée vendre",
                    "children": [
                        {
                            "id": "444110",
                            "text": "Centres de rénovation",
                            "keywords": "articles assurent bois centres construction détail distincts domestiques électrique fenêtres fournitures gamme jardinage l'installation marchandises matériaux matériel ménagers outils papier parfois peint peinture plomberie portes présentées quincaillerie rayons rénovation réparation revêtements sol vendent vendre"
                        },
                        {
                            "id": "444120",
                            "text": "Magasins de peinture et de papier peint",
                            "keywords": "connexes détail fournitures magasins papier peint peinture vendre"
                        },
                        {
                            "id": "444130",
                            "text": "Quincailleries",
                            "keywords": "articles connus construction détail distincts fournitures généraux jardinage l'outillage matériel ménagers nom normalement peinture peuvent présentés produits quincaillerie quincailleries rayons vendre"
                        },
                        {
                            "id": "444190",
                            "text": "Autres marchands de matériaux de construction ",
                            "keywords": "construction détail d'installation fournir marchands matériaux outre peuvent services spécialisés vendre"
                        },
                        {
                            "id": "444210",
                            "text": "Magasins de matériel motorisé pour l'extérieur",
                            "keywords": "détachées détail électrique extérieurs fournir l'extérieur magasins matériel motorisé peuvent pièces réparation services travaux vendent vendre"
                        },
                        {
                            "id": "444220",
                            "text": "Pépinières et centres de jardinage",
                            "keywords": "arbres arbustes bulbes centres cultivés d'aménagement détail fournir gazon généralement jardinage paysager pépinières peuvent plantes plants produits semences services vendre"
                        }
                    ]
                },
                {
                    "id": "445",
                    "text": "Magasins d'alimentation",
                    "keywords": "alimentaires boissons d'alimentation détail gamme magasins produits spécialisée vendre",
                    "children": [
                        {
                            "id": "445120",
                            "text": "Dépanneurs",
                            "keywords": "alcooliques aliments appelés billets boissons connexes conserves consommation courante dépanneurs détail fournir gamme gazeuses général grignoter journaux lait laitiers limitée loterie louer ménage nettoyage pain papiers peuvent produits revues services tabac trouve vendent vendre vidéos"
                        },
                        {
                            "id": "445210",
                            "text": "Boucheries",
                            "keywords": "boucheries congelées détail épiceries fines fraîche fraîches fumées surtout vendent vendre viande volaille"
                        },
                        {
                            "id": "445220",
                            "text": "Poissonneries",
                            "keywords": "congelés détail frais fruits fumés mer poisson poissonneries vendre"
                        },
                        {
                            "id": "445230",
                            "text": "Marchés de fruits et de légumes",
                            "keywords": "détail frais fruits légumes marchés vendre"
                        },
                        {
                            "id": "445291",
                            "text": "Boulangeries-pâtisseries",
                            "keywords": "boulangeries-pâtisseries consommation cuits destinés détail immédiate pain pâtisseries place vendre"
                        },
                        {
                            "id": "445292",
                            "text": "Confiseries et magasins de noix",
                            "keywords": "bonbons confiseries détail magasins maïs noix soufflé vendre"
                        },
                        {
                            "id": "445299",
                            "text": "Tous les autres magasins d'alimentation spécialisée",
                            "keywords": "alimentaires d'alimentation détail figurent magasins spécialisée spécialités vendre"
                        },
                        {
                            "id": "445310",
                            "text": "Magasins de bière, de vin et de spiritueux",
                            "keywords": "alcooliques bière boissons détail emballage liqueurs magasins spiritueux vendre vin"
                        },
                        {
                            "id": "445110",
                            "text": "Supermarchés et autres épiceries (sauf les dépanneurs)",
                            "keywords": "alimentaires aliments appelés articles boulangerie congelés conserves dépanneurs détail divers domestiques épiceries fraîches frais fruits gamme grignoter laitiers légumes médicaments nettoyage ordonnance outre papier pâtisserie poisson préparées produits qu'articles séchés supermarchés toilette vendent vendre vendus viandes volaille"
                        }
                    ]
                },
                {
                    "id": "446",
                    "text": "Magasins de produits de santé et de soins personnels",
                    "keywords": "alimentaires aliments appareils beauté cosmétiques détail l'optique magasins parfumerie personnels pharmacies produits santé soins suppléments vendent vendre",
                    "children": [
                        {
                            "id": "446199",
                            "text": "Magasins de tous les autres produits de santé et de soins personnels",
                            "keywords": "d'articles détail d'installation figurent fournir gammes magasins outre personnels peuvent produits réglage santé services soins spécialisées vendre"
                        },
                        {
                            "id": "446110",
                            "text": "Pharmacies",
                            "keywords": "aliments appareils appelés articles articles-cadeaux cartes certains confiserie cosmétiques détail d'hygiène fournitures grignoter médicaments médicaux nouveauté ordonnance outre papeterie personnelle pharmacies photographiques produits tabac vendent vendre voeux"
                        },
                        {
                            "id": "446120",
                            "text": "Magasins de cosmétiques, de produits de beauté et de parfums",
                            "keywords": "articles beauté cosmétiques détail magasins parfums produits toilette vendre"
                        },
                        {
                            "id": "446130",
                            "text": "Magasins de produits optiques",
                            "keywords": "ajuster assurent certains commande contact détail locaux lunettes magasins optiques ordonnance polissage prescrits produits soleil vendre verres"
                        },
                        {
                            "id": "446191",
                            "text": "Magasins de suppléments alimentaires (aliments de santé)",
                            "keywords": "alimentaires aliments d'aliments détail énergétiques gamme limitée magasins nutritifs peuvent santé suppléments vendre vitamines"
                        }
                    ]
                },
                {
                    "id": "447",
                    "text": "Stations-service",
                    "keywords": "atelier automobile carburant carburants commerce commission compte conjointement dépanneur détail exploitent exploités moteurs perçoivent peuvent propriétaires réparation restaurant stations-service vendre vendus",
                    "children": [
                        {
                            "id": "447110",
                            "text": "Stations-service avec dépanneurs",
                            "keywords": "aliments automobile boissons carburant compte dépanneur dépanneurs détail exploitant exploitent gamme gazeuses grignoter lait limitée offrant pain produits propriétaires stations-service tout vendre"
                        },
                        {
                            "id": "447190",
                            "text": "Autres stations-service",
                            "keywords": "atelier automobile automobiles carburant commerce commerces compte conjointement détail diesel exploitent exploités figurent huiles l'essence peuvent propriétaires réparation restaurant stations-service vendre"
                        }
                    ]
                },
                {
                    "id": "448",
                    "text": "Magasins de vêtements et d'accessoires vestimentaires",
                    "keywords": "accessoires d'accessoires détail magasins vendre vestimentaires vêtements",
                    "children": [
                        {
                            "id": "448150",
                            "text": "Magasins d'accessoires vestimentaires",
                            "keywords": "d'accessoires détail gamme magasins neufs unique vendre vestimentaires"
                        },
                        {
                            "id": "448110",
                            "text": "Magasins de vêtements pour hommes",
                            "keywords": "détail gamme garçons hommes magasins neuf peuvent prêt-à-porter retouches vendent vendre vêtements"
                        },
                        {
                            "id": "448120",
                            "text": "Magasins de vêtements pour femmes",
                            "keywords": "détail femmes gamme grossesse magasins neuf prêt-à-porter vendre vêtements"
                        },
                        {
                            "id": "448130",
                            "text": "Magasins de vêtements pour enfants et bébés",
                            "keywords": "bébés détail enfants gamme magasins neuf prêt-à-porter vendre vêtements"
                        },
                        {
                            "id": "448140",
                            "text": "Magasins de vêtements pour la famille",
                            "keywords": "âges détail famille gamme magasins neuf personnes prêt-à-porter sexes vendre vêtements"
                        },
                        {
                            "id": "448191",
                            "text": "Magasins de fourrures",
                            "keywords": "détail fourrure fourrures magasins mesure prêt-à-porter vendre vêtements"
                        },
                        {
                            "id": "448199",
                            "text": "Magasins de tous les autres types de vêtements ",
                            "keywords": "détail figurent gammes magasins neufs spécialisées vendre vêtements"
                        },
                        {
                            "id": "448210",
                            "text": "Magasins de chaussures",
                            "keywords": "chaussures détail genres l'entretien magasins neuves peuvent produits vendre"
                        },
                        {
                            "id": "448310",
                            "text": "Bijouteries",
                            "keywords": "argent articles bijouteries bijoux détail fournir massif montage montres pendules peuvent pierres plaqué réparation services taille vendre"
                        },
                        {
                            "id": "448320",
                            "text": "Magasins de bagages et de maroquinerie",
                            "keywords": "bagages cartables cuir d'articles détail gamme magasins mallettes maroquinerie précise produits semblables vendre"
                        }
                    ]
                },
                {
                    "id": "451",
                    "text": "Magasins d'articles de sport, d'articles de passe-temps, d'articles de musique et de livres",
                    "keywords": "accessoires articles audio couture d'articles détail enregistrements fil instruments jeux jouets lecture livres magasins musique passe-temps patrons sport tissus travaux vendre vidéo",
                    "children": [
                        {
                            "id": "451111",
                            "text": "Magasins spécialisés en équipement et en fournitures de golf",
                            "keywords": "articles équipements golf commerce détail magasins spécialisés équipement fournitures professionnels exploitation magasin"
                        },
                        {
                            "id": "451112",
                            "text": "Magasins spécialisés en équipement et en fournitures de ski",
                            "keywords": "magasins spécialisés équipement fournitures ski commerce détail"
                        },
                        {
                            "id": "451113",
                            "text": "Magasins spécialisés en équipement et en fournitures de cyclisme",
                            "keywords": "bicyclettes pièces marchands commerce détail neuves combinées réparation source primaire rentrée fonds accessoires ventes réparations magasins spécialisés équipement fournitures cyclisme"
                        },
                        {
                            "id": "451119",
                            "text": "Tous les autres magasins d'articles de sport",
                            "keywords": "appâts équipement pêche boutiques commerce détail armes munitions athlétisme balle-molle baseball boutique harnais camping chasse équitation articles équipements football gymnase hockey mise forme sportive fournitures vers vairons plongée apnée scaphandre autonome quilles randonnée excursion alpinisme soccer tables billard magasins tennis articles boutiques terrain jeu tir arc uniformes athlétiques voiles tentes"
                        },
                        {
                            "id": "451120",
                            "text": "Magasins d'articles de passe-temps, de jouets et de jeux",
                            "keywords": "artisanats d'articles détail fournitures jeux jouets magasins neufs passe-temps travaux vendre"
                        },
                        {
                            "id": "451130",
                            "text": "Magasins d'articles de couture et de travaux d'aiguille et de tissus à la pièce",
                            "keywords": "accessoires coudre couture d'aiguille d'articles détail fil machines magasins neufs patrons peuvent pièce tissus travaux vendre"
                        },
                        {
                            "id": "451140",
                            "text": "Magasins d'instruments et de fournitures de musique",
                            "keywords": "connexes détail d'instruments fournitures instruments louer magasins musique neufs partitions peuvent réparer vendre"
                        },
                        {
                            "id": "451310",
                            "text": "Librairies et marchands de journaux",
                            "keywords": "détail journaux librairies livres marchands neufs périodiques revues vendre"
                        }
                    ]
                },
                {
                    "id": "452",
                    "text": "Magasins de marchandises diverses ",
                    "keywords": "articles comprendre d'épicerie détail fournitures gamme genre magasins marchandises peuvent tout vendre",
                    "children": [
                        {
                            "id": "452110",
                            "text": "Grands magasins",
                            "keywords": "appelés certains concédée détail différents distincts gammes grands l'exploitation magasins multiples présentés produits rayons vendre"
                        },
                        {
                            "id": "452910",
                            "text": "Clubs-entrepôts",
                            "keywords": "appelés club clubs d'articles d'épicerie détail gamme grandes gros hypermarchés produits quantités vendre"
                        },
                        {
                            "id": "452991",
                            "text": "Magasins de fournitures pour la maison et l'auto",
                            "keywords": "accessoires appareils articles auto batteries détail fournitures gamme jardinage l'auto magasins maison matériel ménage ménagers petits pièces pneus quincaillerie qu'une sport vendre"
                        },
                        {
                            "id": "452999",
                            "text": "Tous les autres magasins de marchandises diverses de tout genre ",
                            "keywords": "détail divers figurent fournitures gamme genre magasins marchandises neuves tout vendre"
                        }
                    ]
                },
                {
                    "id": "453",
                    "text": "Magasins de détail divers",
                    "keywords": "animaleries animaux bureau cadeaux d'art d'articles détail divers d'occasion d'oeuvres fantaisie fleuristes fournitures gamme magasins maison maisons marchandises marchands mobiles papeterie préfabriquées souvenirs spécialisée spécialisés types vendant vendre",
                    "children": [
                        {
                            "id": "453110",
                            "text": "Fleuristes",
                            "keywords": "achetées compositions coupées détail fleuristes fleurs florales l'extérieur plantes pot préparent vendent vendre"
                        },
                        {
                            "id": "453210",
                            "text": "Magasins de fournitures de bureau et de papeterie",
                            "keywords": "assortiment bureau détail fournitures magasins matériel meubles papeterie scolaires vendre"
                        },
                        {
                            "id": "453220",
                            "text": "Magasins de cadeaux, d'articles de fantaisie et de souvenirs",
                            "keywords": "articles bibelots cadeaux cartes d'articles décorations détail fantaisie magasins noël papeterie peuvent souvenirs vendre voeux"
                        },
                        {
                            "id": "453310",
                            "text": "Magasins de marchandises d'occasion",
                            "keywords": "antiquités détail d'occasion magasins marchandises vendre"
                        },
                        {
                            "id": "453910",
                            "text": "Animaleries et magasins de fournitures pour animaux",
                            "keywords": "aliments animaleries animaux compagnie détail fournir fournitures magasins peuvent services toilettage vendre"
                        },
                        {
                            "id": "453920",
                            "text": "Marchands d'oeuvres d'art",
                            "keywords": "autochtones d'art destinées détail d'oeuvres édition exposer limitée marchands oeuvres originales sculptures vendre vendues"
                        },
                        {
                            "id": "453930",
                            "text": "Marchands de maisons mobiles",
                            "keywords": "détail d'installation d'occasion fournir maisons marchands matériel mobiles neufs outre peuvent pièces services vendre"
                        },
                        {
                            "id": "453992",
                            "text": "Magasins de matériel pour la fabrication de la bière et du vin",
                            "keywords": "avoir bière clientèle détail disposition fabrication fabriquer fournitures magasins matériel peuvent place servant vendre vin"
                        },
                        {
                            "id": "453993",
                            "text": "Magasins de cannabis",
                            "keywords": "huile de cannabis, commerce de détail produits séché semences"
                        },
                        {
                            "id": "453999",
                            "text": "Tous les autres magasins de détail divers (sauf les magasins de matériel pour la fabrication de la bière et du vin)",
                            "keywords": "bière détail divers d'occasion enchères fabrication figurent gamme gammes magasins marchandises matériel neuves spécialisées vendre vin"
                        }
                    ]
                },
                {
                    "id": "454",
                    "text": "Détaillants hors magasin",
                    "keywords": "automatiques catalogues classiques clients commercialisent démonstrations détail détaillants diffusion directe distributeurs domestique domicile électroniques hors internet journaux l'infopublicité livraison magasin marchandise marchandises mazout méthodes moyens porte présentation presse produits publication publicité radio radiodiffusion stands suivants télévision temporaire touchent vendre vente",
                    "children": [
                        {
                            "id": "454110",
                            "text": "Entreprises de magasinage électronique et de vente par correspondance",
                            "keywords": "achats domicile télé-achat télévision commerce détail articles fantaisie commandes postales bijoux bureaux prises opération catalogue bureau ventes électronique vente comptoirs correspondance magasins rayons multiples disques bandes audio disques compacts préenregistrés encans Internet entreprises magasinage directe fromage fruits livres magazines logiciels ordinateurs équipements périphériques pharmacies établissements soins santé hors lieux site téléchargement musique sites contenu audio vidéo téléchargé électronique"
                        },
                        {
                            "id": "454210",
                            "text": "Exploitants de distributeurs automatiques",
                            "keywords": "approvisionner automatiques détail distributeurs entretenir exploitants marchandise posséder"
                        },
                        {
                            "id": "454311",
                            "text": "Marchands de mazout de chauffage",
                            "keywords": "activité chaudières chauffage consistant consommateurs d'entretien détail directe entreprises l'acheteur livrer marchands mazout ménages offrir peuvent réparation services vendre vente"
                        },
                        {
                            "id": "454312",
                            "text": "Marchands de gaz de pétrole liquéfiés (gaz en bouteille) ",
                            "keywords": "bouteille détail directe gaz gpl liquéfié marchands pétrole vente"
                        },
                        {
                            "id": "454319",
                            "text": "Autres marchands de combustibles ",
                            "keywords": "chauffage ci-dessus combustible combustibles détail directe ensemble énumérés exceptés gaz liquéfié marchands mazout pétrole prédomine vente"
                        },
                        {
                            "id": "454390",
                            "text": "Autres établissements de vente directe",
                            "keywords": "clients démonstrations détail directe diverses domicile expositions figurent hors livraison magasin marchandises méthodes porte-à-porte produits stands temporaires toucher utilisent vendre vente"
                        }
                    ]
                }
            ]
        },
       
        {
            "id": "48-49",
            "text": "Transport et entreposage",
            "keywords": "aérien bon bureaux camion catégories commun d'entreposage d'installations d'organisation eau employés entreposage entreprises eux ferroviaire fournir genre installations l'entreposage liés marchandises messageries modes nationaux nombre offert organisés personnes pipeline poste répartis réseaux routier selon service services subdivisées terrestre territoire transport transportent vaste visés voyageurs",
            "children": [
                {
                    "id": "481",
                    "text": "Transport aérien",
                    "keywords": "aérien aéronef avion compte d'autrui fournir hélicoptère marchandises personnes public services transport",
                    "children": [
                        {
                            "id": "481110",
                            "text": "Transport aérien régulier",
                            "keywords": "aérien aéronef aéroports charge choix d'exploitation disposent facteurs fournir grande heures manoeuvre marchandises marge passagers quant régulier régulières réguliers routes services similaires transport vols"
                        },
                        {
                            "id": "481214",
                            "text": "Transport aérien d'affrètement non régulier",
                            "keywords": "aérien calculé d'affrètement d'heures distance droit etou fonction fournir marchandises moyennant nombre parcourue passagers régulier services transport vol"
                        },
                        {
                            "id": "481215",
                            "text": "Services de vols spécialisés non réguliers",
                            "keywords": "aérien aérienne aéronefs airs ambulance avion banderoles circulation forêts fournir fumée généraux haut incendies l'épandage l'inscription lutte marchandises particulier passagers petits photographie polyvalents prédominance production publicitaires rapports réguliers remorquage s'agir service services spécialisés transport utilisent vol vols"
                        }
                    ]
                },
                {
                    "id": "482",
                    "text": "Transport ferroviaire",
                    "keywords": "chemins courte distance fer ferroviaire fournir l'exploitation ligne longue services transport voyageurs",
                    "children": [
                        {
                            "id": "482112",
                            "text": "Transport ferroviaire de marchandises sur de courtes distances",
                            "keywords": "acheminer chemins courte courtes destinés distance distances fer ferroviaire ferroviaires généralement grand l'exploitation lieu lieux ligne lignes marchandises mode partie permettent plusieurs point provenant réseau transbordement transport transporter"
                        },
                        {
                            "id": "482114",
                            "text": "Transport ferroviaire de voyageurs",
                            "keywords": "ferroviaire fournir services transport voyageurs"
                        },
                        {
                            "id": "482113",
                            "text": "Transport ferroviaire de marchandises sur ligne principale",
                            "keywords": "appartenir branches chemins composé courtes destinés distances distincts exploite fer ferroviaire généralement grandes l'établissement l'exploitation ligne lignes marchandises partie peuvent plusieurs principales ramifient réseau secondaires système transport"
                        }
                    ]
                },
                {
                    "id": "483",
                    "text": "Transport par eau",
                    "keywords": "conçu eau effet fournir l'aide marchandises matériel passagers services transport",
                    "children": [
                        {
                            "id": "483214",
                            "text": "Transport sur les eaux intérieures par traversier",
                            "keywords": "eaux exploités intérieures l'exploitation ports transport traversier traversiers"
                        },
                        {
                            "id": "483116",
                            "text": "Transport hauturier, côtier et sur les Grands Lacs par traversier",
                            "keywords": "autopropulsés bord côtier grands hauturier lacs l'exploitation marchandises motorisés passagers servant transport traversier traversiers véhicules"
                        },
                        {
                            "id": "483115",
                            "text": "Transport hauturier, côtier et sur les Grands Lacs, sauf le transport par traversier",
                            "keywords": "considère côtier croisière exploitent fournir grands hauturier hauturiers lacs marchandises maritime navires partie passagers saint-laurent services transport traversier voie"
                        },
                        {
                            "id": "483213",
                            "text": "Transport sur les eaux intérieures (sauf par traversier) ",
                            "keywords": "eaux exception fournir intérieures marchandises passagers services transport traversier"
                        }
                    ]
                },
                {
                    "id": "484",
                    "text": "Transport par camion",
                    "keywords": "camion caractéristiques distances diverses doivent exercer faubourgs forme fournir l'aide l'autre l'intérieur localement longues marchandises matériel métropolitaine peuvent poids raison région services spéciales spécialisé taille transport transportées transporter",
                    "children": [
                        {
                            "id": "484110",
                            "text": "Transport local par camion de marchandises diverses",
                            "keywords": "camion diverses faubourgs fournir l'intérieur local marchandises métropolitaine offrent principalement région services transport"
                        },
                        {
                            "id": "484121",
                            "text": "Transport par camion de marchandises diverses sur de longues distances, charge complète",
                            "keywords": "camion charge charges complète complètes constituées destinations directement distances diverses d'origine expéditeur fournir généralement longues marchandises plusieurs point services seul transport transportées"
                        },
                        {
                            "id": "484122",
                            "text": "Transport par camion de marchandises diverses sur de longues distances, charge partielle",
                            "keywords": "camion caractérisent charge chargements charges dégroupage distances diverses envoi expéditeurs fournir généralement groupage jusqu'à livrées longues l'utilisation marchandises partielle partielles partir plusieurs préparation provenant réacheminées routier routiers services seul terminal terminaux transport transporteurs triées vue"
                        },
                        {
                            "id": "484210",
                            "text": "Déménagement de biens usagés de maison et de bureau",
                            "keywords": "auxiliaire biens bureau camion courtes d'activité déménagement distances institutionnel l'entreposage longues maison matériel meubles neufs peuvent titre transportent transporter usagé usagés"
                        },
                        {
                            "id": "484222",
                            "text": "Transport local par camion de vrac solide",
                            "keywords": "benne camion camions chimiques citernes fournir gravier local marchandises minerais neige poudres remorques routières sable services similaires solide transport transporter trémie utilisent véhicules vrac"
                        },
                        {
                            "id": "484223",
                            "text": "Transport local par camion de produits forestiers",
                            "keywords": "bois camion copeaux débité forestiers fournir grume local produits services transport"
                        },
                        {
                            "id": "484221",
                            "text": "Transport local par camion de vrac liquide",
                            "keywords": "camion chimiques citernes fournir lait l'eau liquide local marchandises pétroliers peuvent produits réfrigérées routières services transport transporter utilisent vrac"
                        },
                        {
                            "id": "484229",
                            "text": "Transport local par camion d'autres marchandises spéciales (sauf les biens usagés)",
                            "keywords": "biens camion figurent fournir l'aide local marchandises matériel services spéciales spécialisé transport usagés"
                        },
                        {
                            "id": "484231",
                            "text": "Transport par camion de vrac liquide sur de longues distances",
                            "keywords": "camion chimiques citernes distances fournir liquide longues marchandises pétroliers peuvent produits réfrigérées routières services transport transporter utilisent vrac"
                        },
                        {
                            "id": "484232",
                            "text": "Transport par camion de vrac solide sur de longues distances",
                            "keywords": "benne camion camions chimiques citernes distances fournir gravier longues marchandises minerais poudres remorques routières sable services similaires solide transport transporter trémie utilisent véhicules vrac"
                        },
                        {
                            "id": "484233",
                            "text": "Transport par camion de produits forestiers sur de longues distances",
                            "keywords": "bois camion copeaux débité distances forestiers fournir grume longues produits services transport"
                        },
                        {
                            "id": "484239",
                            "text": "Transport par camion d'autres marchandises spéciales sur de longues distances (sauf les biens usagés)",
                            "keywords": "biens camion camions distances figurent fourgons fournir l'aide longues marchandises matériel moteur notons principaux réfrigérants remorques services spéciales spécialisé transport types usagés utilisés véhicules"
                        }
                    ]
                },
                {
                    "id": "485",
                    "text": "Transport en commun et transport terrestre de voyageurs",
                    "keywords": "commun conçu d'horaires distinguent d'itinéraires diversité effet facteurs fixes fonction fournir l'aide l'établissement matériel services siège tarifs terrestre transport unes véhicule voyageurs",
                    "children": [
                        {
                            "id": "485110",
                            "text": "Services urbains de transport en commun",
                            "keywords": "acceptent cartes commun d'abonnement déplacement établis fournissent horaires importe l'autobus léger l'exploitation lignes locaux l'utilisation mensuelles métro modalités modes nécessiter paiement payer permettent peu peuvent plusieurs régulières services suburbains suivant tarif tramway transport urbains voyageurs"
                        },
                        {
                            "id": "485510",
                            "text": "Services d'autobus nolisés",
                            "keywords": "d'autobus entiers établis fournir fournissent horaires lignes louent nolisés plutôt régulières services sièges suivent transport véhicules"
                        },
                        {
                            "id": "485990",
                            "text": "Autres services de transport en commun et de transport terrestre de voyageurs",
                            "keywords": "adapté aéroports âgées aménagés atteintes autobus classiques commun desservant desservent d'incapacité donnés figurent fournir généralement handicapés hôtels installations lignes minibus moyens navette personnes rangés régulières services similaires spécialement suivent terrestre transport transporteurs utilisent véhicules voyageurs"
                        },
                        {
                            "id": "485310",
                            "text": "Services de taxi",
                            "keywords": "automobiles chauffeurs exception façon fournir fournissent horaires importe itinéraires limousines louent n'ayant parcs particuliers peu propriétaires propriétaires-chauffeurs réguliers rémunérés répartition salariés services sociétés soient suivre taxi taxis transport véhicule voyageurs"
                        },
                        {
                            "id": "485210",
                            "text": "Transport interurbain et rural par autocar",
                            "keywords": "autocar banlieue déplacement donnée essentiellement établis exigent fournir fournissent horaires interurbain l'extérieur lignes municipalité régulières rural services suivant tarif transport voyageurs"
                        },
                        {
                            "id": "485320",
                            "text": "Services de limousine",
                            "keywords": "fournir limousine services transport voyageurs"
                        },
                        {
                            "id": "485410",
                            "text": "Transport scolaire et transport d'employés par autobus",
                            "keywords": "autobus d'employés déplacement établis fournir fournissent horaires lignes moteur n'exigent régulières scolaire services suivant tarif transport véhicules"
                        }
                    ]
                },
                {
                    "id": "486",
                    "text": "Transport par pipeline",
                    "keywords": "accessoires auxiliaires brut collecte composés conçus d'emmagasinage d'infrastructures divers donné fournir gaz installations intégrés naturel pétrole pétroliers pipeline pipelines pompage postes produit produits raffinés requiert réseaux services spécialement systèmes transport transportés types",
                    "children": [
                        {
                            "id": "486110",
                            "text": "Transport du pétrole brut par oléoduc",
                            "keywords": "brut concerne oléoduc pétrole transport"
                        },
                        {
                            "id": "486210",
                            "text": "Transport du gaz naturel par gazoduc",
                            "keywords": "champs concerne distribution gaz gazoduc locaux naturel réseaux traitement transport usines"
                        },
                        {
                            "id": "486910",
                            "text": "Transport par pipeline de produits pétroliers raffinés",
                            "keywords": "concerne pétroliers pipeline produits raffinés transport"
                        },
                        {
                            "id": "486990",
                            "text": "Tous les autres services de transport par pipeline",
                            "keywords": "concerne exploitent figurent pipeline pipelines schlamms services transport"
                        }
                    ]
                },
                {
                    "id": "487",
                    "text": "Transport de tourisme et d'agrément",
                    "keywords": "bateaux courtes croisières croisières-restaurants d'affrètement d'agrément déroulent d'excursions distances excursions fournir généralement hippomobile hydroglisseur jour matériel montgolfière offertes offrent pêche plaisance randonnées s'agit services spécialisé suranné tourisme tours train transport utilisent vapeur véhicule",
                    "children": [
                        {
                            "id": "487110",
                            "text": "Transport terrestre de tourisme et d'agrément",
                            "keywords": "d'agrément excursions fournir hippomobile randonnées services terrestre tourisme train transport vapeur véhicule"
                        },
                        {
                            "id": "487210",
                            "text": "Transport par eau de tourisme et d'agrément",
                            "keywords": "bateaux courtes croisières croisières-restaurants d'affrètement d'agrément déroulent d'excursions distances eau fournir généralement hydroglisseur jour matériel offertes offrent pêche plaisance s'agit services spécialisé suranné tourisme tours transport utilisent"
                        },
                        {
                            "id": "487990",
                            "text": "Autres services de transport de tourisme et d'agrément",
                            "keywords": "d'agrément figurent fournir hélicoptère montgolfière notons plaisance services tourisme tours transport"
                        }
                    ]
                },
                {
                    "id": "488",
                    "text": "Activités de soutien au transport",
                    "keywords": "fournir mode multimodaux peuvent propres services soutien transport",
                    "children": [
                        {
                            "id": "488190",
                            "text": "Autres activités de soutien au transport aérien",
                            "keywords": "aérien aéronefs courant figurent fournir l'entretien l'essai l'inspection maintenance notons principales réparation services soutien spécialisés transport usine"
                        },
                        {
                            "id": "488119",
                            "text": "Autres opérations aéroportuaires",
                            "keywords": "aéroportuaires civils d'aéroports figurent l'exploitation opérations"
                        },
                        {
                            "id": "488111",
                            "text": "Contrôle de la circulation aérienne",
                            "keywords": "aérienne assurer circulation contrôle fournir ordonnée rapide services sûre visant"
                        },
                        {
                            "id": "488210",
                            "text": "Activités de soutien au transport ferroviaire",
                            "keywords": "assurent complexes emprises exploitent ferroviaire ferroviaires fournir gares l'entretien ouvrages services soutien spécialisés transport"
                        },
                        {
                            "id": "488310",
                            "text": "Opérations portuaires",
                            "keywords": "exploitent exploiter fournir installations opérations phares portuaires services"
                        },
                        {
                            "id": "488320",
                            "text": "Manutention du fret maritime",
                            "keywords": "d'arrimage fournir fret manutention maritime services"
                        },
                        {
                            "id": "488331",
                            "text": "Sauvetage maritime",
                            "keywords": "cargaisons cas concerne coulés d'échouement maritime navires notons procédures remorquage renflouement sauvetage secours types"
                        },
                        {
                            "id": "488519",
                            "text": "Autres intermédiaires en transport de marchandises",
                            "keywords": "agir courtiers désignés différents d'intermédiaire douane entre expéditeurs figurent fournir généralement intermédiaires marchandises modes peuvent services termes titre touchant transitaires transport transporteurs"
                        },
                        {
                            "id": "488511",
                            "text": "Agences de transport maritime",
                            "keywords": "affréteurs agences armateurs cargaisons charge concerne d'affaires maritime maritimes nom port prise représentation sociétés traitement transport"
                        },
                        {
                            "id": "488990",
                            "text": "Autres activités de soutien au transport",
                            "keywords": "caisses effectuent figurent fournir l'emballage marchandises mise services soutien spécialisés traitement transport vue"
                        },
                        {
                            "id": "488339",
                            "text": "Autres services de navigation pour le transport par eau",
                            "keywords": "eau figurent fournir navigation services transport"
                        },
                        {
                            "id": "488332",
                            "text": "Pilotage de navire",
                            "keywords": "désignée entrent essentiels fournir généralement laquelle l'exige loi lorsqu'ils navire navires pilotage pilote port quand quittent services terme zone"
                        },
                        {
                            "id": "488390",
                            "text": "Autres activités de soutien au transport par eau",
                            "keywords": "chantiers courants eau effectuent figurent fournir hors l'entretien navals navires réparation services soutien transport travaux"
                        },
                        {
                            "id": "488410",
                            "text": "Remorquage de véhicules automobiles",
                            "keywords": "accessoires automobiles commercial courtes dépannage-secours distances fournissent grand légers longues lourds offrir peuvent pneus public remorquage remorquer réparation routiers secours secteurs services transport véhicules"
                        },
                        {
                            "id": "488490",
                            "text": "Autres activités de soutien au transport routier",
                            "keywords": "camion camionnage d'autobus d'inspection exploitants exploitent figurent fournir gares marchandises offrent péage pesée ponts réseau routes routier routières services soutien transport tunnels utilisant"
                        }
                    ]
                },
                {
                    "id": "491",
                    "text": "Services postaux",
                    "keywords": "assument bureaux contractuelle courrier distribution entente exception fonctions fournir messageries plusieurs postaux poste services vertu vrac",
                    "children": [
                        {
                            "id": "491110",
                            "text": "Services postaux",
                            "keywords": "assument bureaux contractuelle courrier distribution entente exception fonctions fournir messageries plusieurs postaux poste services vertu vrac"
                        }
                    ]
                },
                {
                    "id": "492",
                    "text": "Messageries et services de messagers",
                    "keywords": "colis donnée fournir l'intérieur livraison messageries messagers petits services urbaine zone",
                    "children": [
                        {
                            "id": "492210",
                            "text": "Services locaux de messagers et de livraison",
                            "keywords": "alcoolisées boissons camion colis d'épicerie documents donnée effectuent emporter fourgonnette fournir généralement juridiques lettres l'intérieur livraison locaux messagers mets petit petits pied produits rémunération services urbaine vélo zone"
                        },
                        {
                            "id": "492110",
                            "text": "Messageries",
                            "keywords": "aérien bureaux fournir messageries mixte poste relevant services terrestre transport"
                        }
                    ]
                },
                {
                    "id": "493",
                    "text": "Entreposage",
                    "keywords": "accessoire activité appelés assument assurent biens charge clients collecte commandes conditionnement contrat contrôle courte crédit d'entreposage d'entrepôt détiennent d'installations disposition distribution diverses doit douane durée entreposage entreposés entrepôts essentiellement forfait fournir fournissent fourniture franche frigorifiques gamme généralement gestion implique installations jours l'emballage l'entrée l'entreposage l'étiquetage l'exécution l'exploitation liés l'octroi logistique logistiques long l'organisation manutentionnent marchandises marquage menus mettent montage notons offrent outre période peuvent prestation prix public responsabilité rupture sécurité service services situés spécialisées stocks terme titre toujours tout toutefois transport travaux trente types zone",
                    "children": [
                        {
                            "id": "493110",
                            "text": "Entreposage et emmagasinage général",
                            "keywords": "bâtis caisses chargement conteneurs d'appareils d'entreposage d'installations diverses entreposage forfait fûts général l'aide lève-palettes l'exploitation manutention manutentionnent marchandises palettes particulier produits public spécialisent tonneaux"
                        },
                        {
                            "id": "493120",
                            "text": "Entreposage frigorifique",
                            "keywords": "appel atmosphère commerce conçu congélation congelées conserver décongélation d'entreposage destinées d'installations entreposage forfait fournissent fourrures frigorifique généralement l'entreposage l'exploitation marchandises matériel modifiée notons offerts outre partielle public réfrigérées services soufflage"
                        },
                        {
                            "id": "493190",
                            "text": "Autres activités d'entreposage",
                            "keywords": "cavités conçus d'automobiles d'entreposage d'installations durée exploitent figurent installations l'entreposage l'exploitation longue manutention matériel particulier pétrole produit salines whisky"
                        },
                        {
                            "id": "493130",
                            "text": "Entreposage de produits agricoles",
                            "keywords": "agricoles d'entreposage d'installations élévateurs entreposage essentiellement frigorifiques grains installations l'entreposage l'exploitation produits servent"
                        }
                    ]
                }
            ]
        },
       
        {
            "id": "51",
            "text": "Industrie de l'information et industrie culturelle",
            "keywords": "accès accessibles achetés afin améliorations améliorer autorisés babillard biens câble c-à-d caractéristiques carte certains chaîne chez ci-dessous club commerce composantes consacrant consultés contenu coûts croissant culture culturel culturelle culturels d'accès d'acquisition d'auteur détail détenteurs d'exemple d'exploitation diffusés d'information disquaire distinguer distribuer distribués distribution diverses domaine données droit droits éducatif électronique élevés enregistrements exclusivement film films format formes fournisseurs gros illégale important industrie informatif intangible intégrés internet ip jouent journaux kiosque l'édition l'enregistrement lequel l'expertise ligne l'inclusion l'information local logiciels lois loués magasin matériel méthodes modifier moyens multimédias nature offrent partir permet permettent peuvent plupart portails présentés principales principaux procédés production produire produisent produits propres propriété protégés public radio radiodiffusion rangés recherche récréatif reflète rendre reproduction reproduire réside revente rôle salle satellite scian secteurs semblables services seuls soient sonore sonores technologies téléchargés télécommunicateurs télécommunications téléphonie télévision titre traitement traiter transforment transmettre uvres valeur vendus vidéo voix web",
            "children": [
                {
                    "id": "511",
                    "text": "Édition",
                    "keywords": "accès acheter bases caractérisent cartes cd-rom celles-ci compacts compiler contrat créativité créées créer d'assurer d'auteur d'édition demander direct disques distribuent distribution données droit dvd éditeurs édition électronique enfants fonctions format formes imprimé imprimer intellectuelle interactifs internet journaux l'édition ligne l'interne livres logiciels multimédias musicales nécessaire obtenir offrir organisent originalement ouvrages périodiques peuvent plusieurs production produits protégées publiées référence reproduire souhaits uvres vidéonumériques",
                    "children": [
                        {
                            "id": "511110",
                            "text": "Éditeurs de journaux",
                            "keywords": "annonces appelés articles chroniques collecte distribution éditeurs éditoriaux électronique exécuter fond forme imprimée journaux nécessaires nouvelles opérations peuvent préparation production publier rédaction vente"
                        },
                        {
                            "id": "511120",
                            "text": "Éditeurs de périodiques",
                            "keywords": "annonces appelés articles base collecte distribution éditeurs électronique exécuter forme généralement hebdomadaire imprimée intervalles mensuelle nécessaires opérations paraissent paraître périodiques peuvent préparation production recherche rédaction réguliers révision revues trimestrielle vente"
                        },
                        {
                            "id": "511130",
                            "text": "Éditeurs de livres",
                            "keywords": "appelés conception distribution diverses éditeurs électronique exécuter forme imprimée livres manuels marketing nécessaires opérations parlés peuvent poche production professionnels publiés rédaction scientifiques scolaires techniques"
                        },
                        {
                            "id": "511140",
                            "text": "Éditeurs d'annuaires et de répertoires",
                            "keywords": "choix clients compilations d'annuaires décision directement disposition éditeurs électronique électroniques etou faciliter façon faits formats forme fournisseurs généralement imprimée l'édition ligne logiquement l'utilisation mises offertes organisés peuvent plusieurs présentation produits protégés publiés recueils renseignements répertoires services tiers truchement versions"
                        },
                        {
                            "id": "511190",
                            "text": "Autres éditeurs",
                            "keywords": "affiches calendriers cartes colorer divers éditeurs figurent l'édition livres souhaits travaux"
                        },
                        {
                            "id": "511211",
                            "text": "Éditeurs de logiciels (sauf éditeurs de jeux vidéo)",
                            "keywords": "éditeurs logiciels édition série conception développement jeux progiciel ordinateur langage programmation compilation application publication progiciels préemballés reproduction installations intégrées utilitaire système exploitation"
                        },
                        {
                            "id": "511212",
                            "text": "Éditeurs de jeux vidéo",
                            "keywords": "conception développement jeux vidéo édition logiciels"
                        }
                    ]
                },
                {
                    "id": "512",
                    "text": "Industries du film et de l'enregistrement sonore",
                    "keywords": "audio cinématographiques connexes d'enregistrement d'enregistrements développement distribution film films l'enregistrement postproduction présentation prestation production services sonore studios traitement vidéo",
                    "children": [
                        {
                            "id": "512110",
                            "text": "Production de films et de vidéos",
                            "keywords": "d'émissions distribution films production publicités télévision vidéos"
                        },
                        {
                            "id": "512120",
                            "text": "Distribution de films et de vidéos",
                            "keywords": "cinémas cinématographiques distribution droits exploitants films l'acquisition productions réseaux stations télévision vidéo vidéos"
                        },
                        {
                            "id": "512130",
                            "text": "Présentation de films et de vidéos",
                            "keywords": "cadre festivals film films l'occasion offerts présentation prestation services vidéos"
                        },
                        {
                            "id": "512190",
                            "text": "Postproduction et autres industries du film et de la vidéo ",
                            "keywords": "cinématographiques codé conversion création d'animations d'effets développement d'images figurent film filmbande films génériques graphiques informatiques montage postproduction postsynchronisation prestation production services sous-titrage spécialisés spéciaux traitement vidéo vidéos"
                        },
                        {
                            "id": "512230",
                            "text": "Éditeurs de musique",
                            "keywords": "agir auteurs compositeurs compositions compte conformément contrat d'administrateurs d'auteur d'auteurs détenir droits éditeurs enregistrements films généralement imprimées intérêts interprétations l'acquisition l'autorisation l'enregistrement l'exploitation licence loi l'utilisation multimédias musicales musique oeuvres peuvent productions produire promotion propriétaires radio recettes représentent scène télévision titre titulaires vertu vue"
                        },
                        {
                            "id": "512240",
                            "text": "Studios d'enregistrement sonore",
                            "keywords": "audio cinématographiques création d'enregistrement d'enregistrements d'interprétations fournir installations l'enregistrement l'expertise maîtres musicales nécessaires peuvent postproduction production productions services sonore studios technique télévisuelles vidéo"
                        },
                        {
                            "id": "512250",
                            "text": "Production et distribution d’enregistrements",
                            "keywords": "détenir droits auteur enregistrement maître tirer revenus vente location octroi licences enregistrements maîtres compagnies production disques disque distribution combinées musicaux originaux sonores fabrication intégrée reproduction mise circulation intégrées promotion exclusive manière matériaux visuels installations sociétés"
                        },
                        {
                            "id": "512290",
                            "text": "Autres industries de l'enregistrement sonore",
                            "keywords": "d'enregistrement figurent fournir l'enregistrement services sonore"
                        }
                    ]
                },
                {
                    "id": "515",
                    "text": "Radiotélévision (sauf par Internet)",
                    "keywords": "d'installations internet l'exploitation radiodiffusion radiotélévision studios télédiffusion",
                    "children": [
                        {
                            "id": "515110",
                            "text": "Radiodiffusion",
                            "keywords": "affiliées comprendre d'émissions destinées d'information d'installations divertissement émissions émissions-débats l'exploitation peuvent production public radio radiodiffusion servant stations studios transmission"
                        },
                        {
                            "id": "515120",
                            "text": "Télédiffusion",
                            "keywords": "affiliées d'émissions destinées d'installations diversité émaner extérieures l'exploitation ondes production programmation propres public réseau servant sources stations studios télédiffusion télévision transmission"
                        },
                        {
                            "id": "515210",
                            "text": "Télévision payante et spécialisée",
                            "keywords": "abonnés acheter axées biais câblodistribution communication défini d'émissions destinées d'exploitants diffusion d'information éducatives émissions extérieures familiales format jeunes longs météo métrages musique payante peuvent produire propres religion restreint santé satellite sources spécialisée sports studios systèmes télédiffusion télévision transmises voyages"
                        }
                    ]
                },
                {
                    "id": "517",
                    "text": "Télécommunications",
                    "keywords": "acheminent classes client connexions débit d'exploitation divertissement etou fil fixes fournies fournir fournissent haut installations internet lequel louent mobiles modèle nature possèdent propriétaires réseau réseaux réunis revente selon services télécommunications vidéo voie vue",
                    "children": [
                        {
                            "id": "517310",
                            "text": "Télécommunications (sauf par satellite)",
                            "keywords": "compagnies téléphone entreprises services locaux titulaires ESLT fournisseurs concurrentiels propres installations éventail complet télécommunications clientèle résidences entreprises grossistes câblodistribution satellite sans fil réseaux distribution coaxiaux fixes marché résidentiel fournisseur services Internet FSI téléphoniques interurbains locaux exploitants télévision diffusion directe DTH téléphones cellulaires mobiles téléphonie porteur"
                        },
                        {
                            "id": "517410",
                            "text": "Télécommunications par satellite",
                            "keywords": "accès débit d'entreprise distribuer entreprises eux ex exploités fixes fournir fournisseurs haut internet mobiles normalement offrent p parfois particuliers radiodiffuseurs réseaux satellitaires satellite servent services télécommunication télécommunications terrestres voie"
                        },
                        {
                            "id": "517911",
                            "text": "Revendeurs de services de télécommunications",
                            "keywords": "fournisseur accès Internet FAI revendeurs services communications micro-ondes télécommunications interurbains revente fournisseurs commuté large bande téléphonie IP"
                        },
                        {
                            "id": "517919",
                            "text": "Tous les autres services de télécommunications",
                            "keywords": "exploitation postes radar stations terminal satellite observation missiles exploitées base contractuelle terriennes télécommunication exploitants installations système poursuite dispositif télémesure photographie forfait systèmes repérage satellites télémesure honoraires"
                        }
                    ]
                },
                {
                    "id": "518",
                    "text": "Traitement de données, hébergement de données et services connexes",
                    "keywords": "connexes d'hébergement données hébergement l'infrastructure nécessaire offrir services traitement",
                    "children": [
                        {
                            "id": "518210",
                            "text": "Traitement de données, hébergement de données et services connexes",
                            "keywords": "audio automatisée base client clients complets connexes continue d'application d'applications d'hébergement diffusion données encore fournies généraux gros hébergement horaire informatiques offrir ordinateurs partagé partir peuvent préparation rapports ressources saisie services sites spécialisées spécialisés temps traitement vidéo web"
                        }
                    ]
                },
                {
                    "id": "519",
                    "text": "Autres services d'information",
                    "keywords": "agences archives base bibliothèques composantes contractuelle d'édition diffusion d'information figurent fournir internet portails presse principales recherche services web",
                    "children": [
                        {
                            "id": "519122",
                            "text": "Archives",
                            "keywords": "acquérir archives audio audiovisuel cartes cinémathèques cinématographiques conserver d'archives disposition documents étudier historique historiques intérêt matériel mettre originaux photographies présentant préservation public vidéo vidéothèques"
                        },
                        {
                            "id": "519110",
                            "text": "Agences de presse",
                            "keywords": "agences d'articles d'illustrations d'information fond forme fournir l'information médias nouvelles presse"
                        },
                        {
                            "id": "519121",
                            "text": "Bibliothèques",
                            "keywords": "besoins bibliothèques caractéristiques collections d'éducation d'information divertissement documents faciliter façon indépendamment l'utilisation matérielle matière présentation recherche répondre tenir utilisateurs"
                        },
                        {
                            "id": "519130",
                            "text": "Radiodiffusion et télédiffusion par Internet et sites portails de recherche",
                            "keywords": "activité aisément appel appelés audio bases classique connexions contenu courriel d'adresses d'attache d'édition d'importantes d'intérêt d'internet données éditent édition entretenir établissement etou forme fréquemment général générer hors internet l'édition l'encan l'exploitation l'information moteur n'offrent offrent particulier port portails prête radiodiffusent radiodiffusion recherche recherches restreints servent services seule signaux sites supplémentaires textes utilisateurs ventes version vidéo web"
                        },
                        {
                            "id": "519190",
                            "text": "Tous les autres services d'information",
                            "keywords": "base contractuelle d'information figurent fournir fournisseurs recherche services téléphoniques"
                        }
                    ]
                }
            ]
        },
        {
            "id": "52",
            "text": "Finance et assurances",
            "keywords": "acheminent achetant assurances assurés autorités capital cession commun complètent constituent constitutif contractent contractuels contrats contrôle création d'actifs d'assurance d'avantages dépôts dettes d'intermédiation droits échéances effectuent effectuer émettant emploient emprunteurs escompté etou facilitent faciliter faisant finance financière financières financiers fonction fonds formes fournir fréquence l'acquisition l'exécution l'intermédiation liquidation mettre mobilières mobilisent monétaire monétaires octroyant opérations paiements perçoivent placent placés portant prélevés prenant prêteurs prêts prévue primes programmes rangés réaménagent recevant rendement rente réserves risques selon services sociaux souscrire spécialisés titres transforment valeurs varient volumes",
            "children": [
                {
                    "id": "521",
                    "text": "Autorités monétaires - banque centrale",
                    "keywords": "- accomplir agir assumées autorités banque banques canada centrale chargées compensation conserver dépôts devises différer émettre états-unis fédéral fédérale financier fonctions gérer gouvernement institutions internationales l'autre liquidation masse mexique monétaire monétaires monnaie papier-monnaie pays peuvent politique qu'agent règlement représentant réserve réserves succursales superviser systèmes tant",
                    "children": [
                        {
                            "id": "521110",
                            "text": "Autorités monétaires - banque centrale",
                            "keywords": "- accomplir agir autorités banque banques centrale compensation conserver dépôts devises émettre fédéral financier fonctions gérer gouvernement institutions internationales liquidation masse monétaire monétaires monnaie papier-monnaie pays qu'agent règlement représentant réserves superviser systèmes tant"
                        }
                    ]
                },
                {
                    "id": "522",
                    "text": "Intermédiation financière et activités connexes",
                    "keywords": "assurant chèques compensation connexes courtage crédit d'emprunt dépôts d'hypothèques émission facilitent faisant financière fonds forme fournissant intermédiation l'emprunt l'encaissement prêter prêts recueillis réserve services titres",
                    "children": [
                        {
                            "id": "522210",
                            "text": "Émission de cartes de crédit",
                            "keywords": "avançant cartes commerciales consommateurs crédit détaillants doit échelonnements émission entreprises fournir l'argent remboursé services totalité ultérieurement vente"
                        },
                        {
                            "id": "522390",
                            "text": "Autres activités liées à l'intermédiation financière",
                            "keywords": "chèques contractés émission encaissement faciliter figurent financière l'intermédiation mandats prêts remboursement voyage"
                        },
                        {
                            "id": "522299",
                            "text": "Toutes les autres activités d'intermédiation financière non faite par le biais de dépôts",
                            "keywords": "agriculteurs biais court crédit crédits d'affacturage dépôts d'intermédiation directement échanges figurent financement financière gage gouvernementaux hypothécaires immobilier internationaux notons octroyer organismes prêt prêtent prêts recevoir roulement sociétés stocks terme"
                        },
                        {
                            "id": "522329",
                            "text": "Autres traitements des transactions financières et activités liées à la chambre de compensation",
                            "keywords": "automatisées cartes chambre chambres chèques compensation crédit électronique électroniques financières financiers fournir instruments notons paiement services traitements traiter transactions"
                        },
                        {
                            "id": "522220",
                            "text": "Financement de ventes à crédit",
                            "keywords": "automobiles baux biens carte conclu condition consommateurs contrat créances crédit d'achats d'exploitation directement effectués entreprises fabricants fasse financement financer financiers fonctions l'achat l'argent lourd marchand matériel notons octroyer particuliers partie prêtent remboursement reprennent résultant services sociétés tempérament termes véhicules ventes"
                        },
                        {
                            "id": "522291",
                            "text": "Crédit à la consommation",
                            "keywords": "autorise bien cas certains consommateurs consommation crédit défaut garanti garantie hypothéqué hypothèque l'argent mobilière notons paiement personnels petites possession prendre prêt prêté prêter prêteur prêts sociétés toutefois"
                        },
                        {
                            "id": "522190",
                            "text": "Autres activités d'intermédiation financière par le biais de dépôts",
                            "keywords": "acheminent biais caisses clients d'épargne dépôts d'intermédiation figurent financière gouvernements lieu octroyer prêter prêts provinciaux recevoir reçus"
                        },
                        {
                            "id": "522321",
                            "text": "Caisses centrales d'épargne et de crédit",
                            "keywords": "avances caisses cartes centrales chèques compensation crédit d'épargne dépôts électronique fédérations financières financiers fournir instruments jour ligues octroyer paiement particuliers prêts recevoir régionales réserve services traiter transactions unions"
                        },
                        {
                            "id": "522310",
                            "text": "Courtiers en prêts hypothécaires et non-hypothécaires",
                            "keywords": "commission continues courtiers frais hypothécaire hypothécaires l'emprunteur moyennant n'entretiennent non-hypothécaires obtenir ordinairement prêt prêteur prêts relations versement"
                        },
                        {
                            "id": "522130",
                            "text": "Coopératives de crédit et caisses populaires locales",
                            "keywords": "acceptent actions caisses capitaux coopératives crédit dépôts locales membres obtenir octroyer populaires prêts recevoir vendent"
                        },
                        {
                            "id": "522111",
                            "text": "Activités bancaires aux particuliers et aux entreprises",
                            "keywords": "bancaires banques charte d'activité dépôts effectuent entreprises fiducie genre hypothécaires moyennes octroyer particuliers petites prêts principalement recevoir sociétés"
                        },
                        {
                            "id": "522112",
                            "text": "Services bancaires aux grandes entreprises et aux institutions",
                            "keywords": "auprès bancaires banques charte clients connexes dépôt d'établissements entre entreprises fonds gouvernements grandes importants institutionnels institutions moyennes obtenus octroyer offrent particuliers petites prêts principalement services susmentionnés utilisant"
                        }
                    ]
                },
                {
                    "id": "523",
                    "text": "Valeurs mobilières, contrats de marchandises et autres activités d'investissement financier connexes",
                    "keywords": "acheteurs actions afférents assurant bons bourses c-à-d capitaux caractère cherchant commercialisation compte connexes conseillant contrats d'actions différentes d'intermédiaires d'investissement d'obligations émissions entre facilitant façon façons ferme fiducie financier fonds fournissant garde gérant installations investisseurs l'achat l'actif locaux marchandises marchés mobilières nécessaires placer portefeuilles prenant risquer servant services souscription titres valeurs vendeurs vente",
                    "children": [
                        {
                            "id": "523210",
                            "text": "Bourses de valeurs mobilières et de marchandises",
                            "keywords": "actions activité bons bourses contrats d'acheter d'actions d'obligations etou faciliter fixer fournir l'achat marchandises marchés mécanismes mobilières négociés posséder prix souscription titres valeurs vendre vente"
                        },
                        {
                            "id": "523990",
                            "text": "Toutes les autres activités d'investissement financier",
                            "keywords": "commission contrat d'investissement divers figurent financier fournir services termes"
                        },
                        {
                            "id": "523930",
                            "text": "Services de conseils en placement",
                            "keywords": "cadre clients condition conseiller conseils d'abonnement d'achat d'exécuter directement domaine droit électronique financière forme fournir frais imprimée investisseurs moyennant ordres peuvent placement planification recherche service services vente versement"
                        },
                        {
                            "id": "523920",
                            "text": "Gestion de portefeuille",
                            "keywords": "caisses commission décisions etou fonction fonds frais gérer gestion global habilités l'importance matière moyennant mutuels notons placements portefeuille portefeuilles prendre rendement retraite sociétés tiers versement versés"
                        },
                        {
                            "id": "523910",
                            "text": "Activités diverses d'intermédiation",
                            "keywords": "assumer caractère contrats différentiels d'intermédiation diverses financier l'achat marchandises mobilières première prix responsabilité spéculant valeurs vente"
                        },
                        {
                            "id": "523140",
                            "text": "Courtage de contrats de marchandises",
                            "keywords": "acheter commission compte contrats courtage marchandises moyennant terme tiers vendre"
                        },
                        {
                            "id": "523130",
                            "text": "Négociation de contrats de marchandises",
                            "keywords": "acheter comptant contrats devises marchandises négociation terme vendre"
                        },
                        {
                            "id": "523120",
                            "text": "Courtage de valeurs mobilières",
                            "keywords": "acheter commission compte courtage mobilières moyennant tiers titres valeurs vendre"
                        },
                        {
                            "id": "523110",
                            "text": "Services bancaires d'investissement et commerce des valeurs mobilières",
                            "keywords": "achètent assumer bancaires commerce compte courtage d'entreprises d'établissements différentiels d'investissement distribution etou gouvernements institutionnels investisseurs l'émission mobilières opérations placer première prix propre responsabilité services souscription spéculant titres valeurs vendent"
                        }
                    ]
                },
                {
                    "id": "524",
                    "text": "Sociétés d'assurance et activités connexes",
                    "keywords": "actuarielle assuré attend base classes commun connexes constituer contrats cotisations d'actifs d'après d'assurance décès définies d'emploi détenteurs dommages due évaluation financiers fixées fonction formes fournir indemnités invalidité l'âge l'assurance matériels mettent passé perte placées police portefeuille prélèvent prévisibles prévision primes réassurance rendement rente réserves risque risques services sinistres sociétés souscrire subis tableaux ultérieurs vendre",
                    "children": [
                        {
                            "id": "524122",
                            "text": "Sociétés privées d'assurance directe : automobile",
                            "keywords": "automobile commerciaux comprenant contrats couvre d'assurance d'assurance-automobile détérioration directe directement égale encaissées ensemble indemnités l'assurance l'assurance-automobile l'assurance-responsabilité l'émission particulières partie perte placement police primes privées privés production provient revenus sociétés titulaires valeur véhicule véhicules versées voitures"
                        },
                        {
                            "id": "524111",
                            "text": "Sociétés d'assurance directe individuelle : vie, maladie et soins médicaux",
                            "keywords": "accidentelle cas contrats couvrant d'assurance d'assurance-invalidité d'assurance-vie dentaires directe directement hospitaliers individuelle individuels maladie médicaux mort mutilation ophtalmologiques police santé services sociétés soins souscrire titulaires vente vie"
                        },
                        {
                            "id": "524112",
                            "text": "Sociétés d'assurance directe collective : vie, maladie et soins médicaux",
                            "keywords": "accidentelle cas collective contrats couvrant d'assurance d'assurance-invalidité d'assurance-vie dentaires directe directement groupes hospitaliers maladie médicaux mort mutilation ophtalmologiques police rente santé services sociétés soins souscrire titulaires vie"
                        },
                        {
                            "id": "524210",
                            "text": "Agences et courtiers d'assurance",
                            "keywords": "agences assureurs courtiers d'assurance employé l'assurance n'est personnel produits représentent retraite vendre"
                        },
                        {
                            "id": "524135",
                            "text": "Sociétés de réassurance - responsabilité",
                            "keywords": "- accidents administrateurs apporte associé assumant assureurs autrui blessures cadre compte concernant d'assurance-responsabilité dommages égale émises encaissées fautes indemnités l'assurance l'assurance-responsabilité légale matériels mentionnons mortels partie personnelles placement polices primes production produits professionnelles protection provient réassurance reprennent responsabilité revenus risque sociétés subir totalité valeur versées"
                        },
                        {
                            "id": "524139",
                            "text": "Sociétés de réassurance IARD et autres sociétés de réassurance",
                            "keywords": "associé assureurs compte d'assurance émises figurent iard partie polices prendre réassurance risque sociétés totalité"
                        },
                        {
                            "id": "524134",
                            "text": "Sociétés de réassurance - biens",
                            "keywords": "- associé assumant assurés assureurs bâtiments biens compte contenu d'assurance égale émises encaissées indemnités partie placement polices primes production provient réassurance reprennent revenus risque sociétés totalité valeur versées"
                        },
                        {
                            "id": "524132",
                            "text": "Sociétés de réassurance - accidents et maladie",
                            "keywords": "- accidents associé assumant assureurs compte d'assurance dentaire égale émises encaissées hospitalière indemnités maladie médicale ophtalmologiques partie placement polices primes production provient réassurance reprennent revenus risque sociétés soins totalité valeur versées"
                        },
                        {
                            "id": "524133",
                            "text": "Sociétés de réassurance - automobile",
                            "keywords": "- associé assumant assureurs automobile compte d'assurance-automobile égale émises encaissées indemnités partie placement polices primes production provient réassurance reprennent revenus risque sociétés totalité valeur versées"
                        },
                        {
                            "id": "524131",
                            "text": "Sociétés de réassurance - vie",
                            "keywords": "- accidentelle associé assumant assureurs cas collectives compte d'assurance d'assurance-invalidité d'assurance-vie égale émises encaissées indemnités individuelles mort mutilation partie placement polices primes production provient réassurance rente reprennent revenus risque sociétés totalité valeur versées vie"
                        },
                        {
                            "id": "524129",
                            "text": "Autres sociétés d'assurance directe (sauf vie, maladie et soins médicaux)",
                            "keywords": "accidents actes aéronefs apporte assurance assurance-caution assuré assurer avions bâtiments certitude chaudières confiés contrats d'assurance défaut dépôt dépôts détournements directe directement dommages effectuer embarcations émettre employés engagé entreprise entreprises environnants fabrication figurent fonctionnement frauduleux garantir individu l'assurance l'assurance-caution l'assurance-maladie l'assurance-vie machine machines maladie malhonnêteté marchandises matériel médicaux navires participation passagers pertes police prêts produits protection protège qu'il qu'un résultant s'est sociétés soins souscrire subies subis terminera titres titulaires transportés travail vie vol"
                        },
                        {
                            "id": "524125",
                            "text": "Sociétés d'assurance directe : responsabilité",
                            "keywords": "accidents administrateurs apporte autrui blessures cadre concernant contrats d'assurance d'assurance-responsabilité directe directement dommages égale émis fautes l'assurance l'assurance-responsabilité légale matériels mentionnons mortels perçues personnelles placement police primes production produits professionnelles protection provient remboursés responsabilité revenus sinistres sociétés subir titulaires valeur"
                        },
                        {
                            "id": "524124",
                            "text": "Sociétés d'assurance directe : biens",
                            "keywords": "assurance assurance-responsabilité bâtiments biens civile commerciaux consommateurs contenu contrat contrats d'assurance d'exploitation d'hébergement d'immeuble directe directement égale elle émis formes frais indemnités l'assurance locataires perçues personnels pertes placement police primes production propriétaires protection protège provient revenus sociétés temporaires titulaires touchant valeur vendue versées vise"
                        },
                        {
                            "id": "524123",
                            "text": "Sociétés publiques d'assurance directe : automobile",
                            "keywords": "automobile contrats d'assurance d'assurance-automobile d'état directe directement police publiques sociétés souscrire titulaires"
                        },
                        {
                            "id": "524121",
                            "text": "Sociétés d'assurance directe : biens, incendie, accidents et risques divers (IARD)",
                            "keywords": "accidents biens contrats d'assurance d'assurance-automobile d'assurance-responsabilité dernière devant directe directement divers égale encaissées iard incendie indemnités placement police primes production représenter revenus risques sociétés souscrire titulaires types uniquement valeur versées"
                        },
                        {
                            "id": "524291",
                            "text": "Experts en sinistres",
                            "keywords": "cadre certains contrat demandes d'indemnisation enquêtes évaluations experts frais mener moyennant régler sinistres"
                        },
                        {
                            "id": "524299",
                            "text": "Toutes les autres activités liées à l'assurance",
                            "keywords": "administratifs assureurs cadre caisses contrat d'assurance d'autoassurance demandes d'indemnisation employés études figurent fournir frais l'assurance l'utilisation moyennant règlement services traitements versement"
                        }
                    ]
                },
                {
                    "id": "526",
                    "text": "Fonds et autres instruments financiers",
                    "keywords": "actifs administrer bénéficiaires biens caisses compte d'employés détenteurs dividendes d'unités elles entités fiducies financiers fonds instruments intérêts investisseurs n'en organisés perçoivent peu portefeuille retraite revenu revenus services tiers tirent très vente",
                    "children": [
                        {
                            "id": "526981",
                            "text": "Instruments de titrisation",
                            "keywords": "actifs automobiles cartes commerciaux crédit entreprises équipements etou faits financiers fixe garanties généralement groupements hypothécaires instruments l'acquisition l'émission locations mobilières négociables organisés personnes prêts recevoir référence résidentiels revenu sommes spéciale titrisation valeurs vocation"
                        },
                        {
                            "id": "526989",
                            "text": "Tous les autres fonds et instruments financiers divers",
                            "keywords": "capital divers fiducies figurent financiers fixe fonds instruments placement spéciales"
                        },
                        {
                            "id": "526911",
                            "text": "Fonds d'actions canadiennes ",
                            "keywords": "- actions canadiennes canadiens compagnies croissance d'actions fonds investir l'objectif ordinaires placements visé"
                        },
                        {
                            "id": "526112",
                            "text": "Caisses de retraite non fiduciaires",
                            "keywords": "administrée agréée biais caisse caisses canada capitalisées conclu constituée contrat cotisations d'assurance d'assurance-vie entente fiduciaires fonds gouvernement lesquels paiement prestations provincial retraite société versées vertu vue"
                        },
                        {
                            "id": "526111",
                            "text": "Caisses de retraite en fiducie ",
                            "keywords": "accord actifs caisses chargé confiées conformément cotisations débours détiennent écrit encaissements fiduciaire fiduciaires fiducie fonds investissements lequel lesquels l'intérêt paiement participants personnes prestations rapport régime retraite société titres versées vue"
                        },
                        {
                            "id": "526915",
                            "text": "Fonds d'obligations et fonds à revenu / fonds de dividendes - canadiens",
                            "keywords": "- canadiennes canadiens compagnies créance d'obligations d'actions dividendes etou fonds intérêts investir l'objectif ordinaires portefeuille privilégiées provenant revenu titres visé"
                        },
                        {
                            "id": "526912",
                            "text": "Fonds d'actions étrangères ",
                            "keywords": "- actions compagnies croissance d'actions étrangères étrangers fonds investir l'objectif ordinaires placements visé"
                        },
                        {
                            "id": "526914",
                            "text": "Fonds du marché monétaire",
                            "keywords": "bons canadiens changement commercial court dette d'intérêt encore étrangers fonds garantie investir l'état l'objectif marché monétaire papier placements produits provenant publique revenu s'agir taux terme trésor visé"
                        },
                        {
                            "id": "526913",
                            "text": "Fonds hypothécaires",
                            "keywords": "fonds hypothécaires hypothèques immobilières intérêts investir l'objectif provenant revenu visé"
                        },
                        {
                            "id": "526919",
                            "text": "Autres fonds de placement à capital variable",
                            "keywords": "capital contrats couverture figurent fonds investir métaux placement précieux terme variable"
                        },
                        {
                            "id": "526916",
                            "text": "Fonds d'obligations et fonds à revenu / fonds de dividendes - étrangers",
                            "keywords": "- compagnies créance d'obligations d'actions dividendes etou étrangères étrangers fonds intérêts investir l'objectif ordinaires portefeuille privilégiées provenant revenu titres visé"
                        },
                        {
                            "id": "526930",
                            "text": "Fonds distincts (sauf les caisses de retraite)",
                            "keywords": "articles assujettis assurances assureurs assureurs-vie britanniques caisses canadiennes compagnies comptes conformément constitution correspondants d'assurance d'investir dispositions distincts établis étrangères fonds forme imposées loi lois matière permet placement polices portefeuilles prennent provinciales restrictions retraite titulaires vertu"
                        },
                        {
                            "id": "526917",
                            "text": "Fonds équilibrés / fonds de répartition d'actifs",
                            "keywords": "actions bien composition d'actifs dépendra englobera équilibrée équilibrés fixe fonds investir l'évolution l'objectif marché monétaire obligations participation placements plus-value portefeuille prise répartition revenu titres visé"
                        }
                    ]
                }
            ]
        },
        {
            "id": "53",
            "text": "Services immobiliers et services de location et de location à bail",
            "keywords": "acheter autrement bail biens compte conférer corporels droit d'usage etou évaluer gérer immobiliers incorporels location louer services tiers vendre",
            "children": [
                {
                    "id": "531",
                    "text": "Services immobiliers",
                    "keywords": "bail biens compte d'intermédiaires donner etou évaluer gérer immobiliers location louer office services tiers vente",
                    "children": [
                        {
                            "id": "531320",
                            "text": "Bureaux d'évaluateurs de biens immobiliers",
                            "keywords": "acheteurs biens bureaux commissaires-priseurs compagnies créanciers d'assurance d'évaluateurs d'évaluation évaluer immobiliers rapports rédiger tribunaux vendeurs"
                        },
                        {
                            "id": "531111",
                            "text": "Bailleurs d'immeubles résidentiels et de logements (sauf les logements sociaux) ",
                            "keywords": "administrer bail bailleurs biens complémentaires compte confier déneigement d'entretien d'immeubles donner ensembles entretenir exploiter fournir immeubles logements louer nettoyage peuvent propre résidentiels sécurité services sociaux stationnement tâche tiers"
                        },
                        {
                            "id": "531390",
                            "text": "Autres activités liées à l'immobilier",
                            "keywords": "figurent fournir liés l'immobilier services"
                        },
                        {
                            "id": "531310",
                            "text": "Gestionnaires de biens immobiliers",
                            "keywords": "administrant approuvant bail biens cadre comptables compte contrat contrats conventions coordination d'administration dressant entretien états etc frais gérer gestionnaires immobiliers loyers moyennant négociant nettoyage percevant propriétaires sécurité services travail versement"
                        },
                        {
                            "id": "531211",
                            "text": "Agents immobiliers",
                            "keywords": "acheteurs agents agissent aident associés bail biens catégorie choix clients commission compte contrat courtiers derniers désignés détiennent diverses donner façons faisant frais immobiliers indépendants l'achat libres louer moyennant offre organisant outre participer permis peuvent potentiels présenter propriétés publicité répertoriant représentants représenter tenus tiers vendeurs vente ventes versement visiter visites"
                        },
                        {
                            "id": "531212",
                            "text": "Bureaux de courtiers en immeubles",
                            "keywords": "accrédités acheter acheteurs aident aider biens bureaux choix commission compte courtiers derniers détiennent faisant frais immeubles immobiliers libres louer moyennant offre organisant permis peuvent potentiels présenter propriétés publicité répertoriant tiers vendeurs vendre versement visiter visites"
                        },
                        {
                            "id": "531190",
                            "text": "Bailleurs d'autres biens immobiliers",
                            "keywords": "bail bailleurs biens donner figurent immeubles immobiliers louer"
                        },
                        {
                            "id": "531130",
                            "text": "Mini-entrepôts libre-service",
                            "keywords": "bail biens clients coffres compartiments conteneurs disposition donner endroits espaces extérieurs l'espace libre-service louer mettent mini-entrepôts peuvent pièces rangement retirer stocker sûrs"
                        },
                        {
                            "id": "531112",
                            "text": "Bailleurs de logements sociaux ",
                            "keywords": "bail bailleurs d'ensembles donner exploités faible financés gouvernementaux immeubles logement logements louer lucratif organismes personnes peuvent privées réservés résidentiels revenu sociaux sociétés"
                        },
                        {
                            "id": "531120",
                            "text": "Bailleurs d'immeubles non résidentiels (sauf les mini-entrepôts)",
                            "keywords": "administrer bail bailleurs biens complémentaires compte confier déneigement d'entretien détenir d'immeubles donner entretenir exploiter fournir immeubles mini-entrepôts nettoyage peuvent propre résidentiels sécurité services stationnement tâche tiers"
                        }
                    ]
                },
                {
                    "id": "532",
                    "text": "Services de location et de location à bail",
                    "keywords": "adaptés afin antérieurement apparentés automobiles avoir bail baux besoins bien biens clients commerce consommation contact contrat contrats contrepartie corporels courte crédit-bail d'établissements détail d'exploitation direct donnent donner durée d'usage entreprise établissent expérience faciliter façon financement fonctionnent fournissent fournisseurs industriel l'approvisionnement l'exploitation location locaux longue loué louées louent louer loueurs loyer l'usage machines magasin marchandises marchands matériel mettent moyennant nécessaire obtenir ordinateurs paiements particuliers partir périodiques preneurs principaux profit proposent puissent regroupe remarketing services spécialisés stock termes tiennent travaillent trouver types utilisés",
                    "children": [
                        {
                            "id": "532111",
                            "text": "Location d'automobiles",
                            "keywords": "chauffeur courtes durées généralement location louer particulières voitures"
                        },
                        {
                            "id": "532112",
                            "text": "Location à bail d'automobiles",
                            "keywords": "bail chauffeur donner durées généralement location longues particulières voitures"
                        },
                        {
                            "id": "532120",
                            "text": "Location et location à bail de camions, de remorques utilitaires et de véhicules de plaisance",
                            "keywords": "autobus bail camions chauffeur donner location louer plaisance remorques routiers semi-remorques tracteurs utilitaires véhicules"
                        },
                        {
                            "id": "532210",
                            "text": "Location d'appareils électroniques domestiques et d'appareils ménagers",
                            "keywords": "appareils d'appareils domestiques électroniques location louer ménagers"
                        },
                        {
                            "id": "532280",
                            "text": "Location de tous les autres biens de consommation",
                            "keywords": "location costumes vêtements théâtre banquets équipement bateaux plaisance canots chaloupes voiliers équipement santé domiciles exercices activités physiques golf chariots récréatif sportif instruments musique piano guitare violons violoncelle meubles résidentiels"
                        },
                        {
                            "id": "532310",
                            "text": "Centres de location d'articles divers",
                            "keywords": "banquets bien bricolage centres commercial constructeurs courtes d'articles déménagements divers domestique durées entre entrepreneurs éventail fonctionnent fournitures industriel jardinage lesquels location locaux louent louer l'outillage marchandises matériel partir réceptions situés stocks tiennent tout trouve"
                        },
                        {
                            "id": "532410",
                            "text": "Location et location à bail de machines et matériel pour la construction, le transport, l'extraction minière et la foresterie",
                            "keywords": "bail conducteur construction donner foresterie l'extraction location louer lourdes machines matériel minière opérateur transport"
                        },
                        {
                            "id": "532420",
                            "text": "Location et location à bail de machines et matériel de bureau",
                            "keywords": "bail bureau donner location louer machines matériel"
                        },
                        {
                            "id": "532490",
                            "text": "Location et location à bail d'autres machines et matériel d'usage commercial et industriel",
                            "keywords": "bail commercial donner d'usage figurent industriel location louer machines matériel"
                        }
                    ]
                },
                {
                    "id": "533",
                    "text": "Bailleurs de biens incorporels non financiers (sauf les oeuvres protégées par le droit d'auteur)",
                    "keywords": "actifs autoriser bailleurs biens brevets commerce commerciaux contrats d'auteur détenir droit etou financiers frais franchise incorporels marques moyennant noms oeuvres protégées reproduire tiers utiliser",
                    "children": [
                        {
                            "id": "533110",
                            "text": "Bailleurs de biens incorporels non financiers (sauf les oeuvres protégées par le droit d'auteur)",
                            "keywords": "actifs autoriser bailleurs biens brevets commerce commerciaux contrats d'auteur détenir droit etou financiers frais franchise incorporels marques moyennant noms oeuvres protégées reproduire tiers utiliser"
                        }
                    ]
                }
            ]
        },
        {
            "id": "54",
            "text": "Services professionnels, scientifiques et techniques",
            "keywords": "assurant cadre capital cartographie classes collégiales compétences composantes comptabilité connaissances connexes conseils constitue d'affectations d'arpentage définies dépendent design développement diagnostiques différentes dispenser distingue donc employés enseignement entièrement études exige expertise facteur figurant fonction formation fournir fournisseur génie gestion grande humain importance juridiques l'architecture levé l'expertise majorité matériel matières n'a offrent partie plupart presque principal principales processus production professionnels prospection publicité recherche repose santé scientifiques services soins techniques temps thérapeutiques toujours universitaires variété vendent",
            "children": [
                {
                    "id": "5411",
                    "text": "Services juridiques",
                    "keywords": "bureaux d'avocats études fournir juridiques notaires notons parajuridiques services spécialistes",
                    "children": [
                        {
                            "id": "541190",
                            "text": "Autres services juridiques",
                            "keywords": "figurent juridiques parajuridiques prestation services"
                        },
                        {
                            "id": "541120",
                            "text": "Études de notaires",
                            "keywords": "conservation contrats d'avocats documents études immobilières juridiques l'approbation notaires réception rédaction répertoriage testaments transactions"
                        },
                        {
                            "id": "541110",
                            "text": "Études d'avocats",
                            "keywords": "branches criminel d'avocats droit études famille immobilier intellectuelle plusieurs pratique propriété sociétés spécialisent successions"
                        }
                    ]
                },
                {
                    "id": "5412",
                    "text": "Services de comptabilité, de préparation de déclarations de revenus, de tenue de livres et de paye ",
                    "keywords": "budgets comptabilité comptables comptes concevoir déclarations établir états factures financiers livres paye préparation préparer remplir revenus services systèmes tenir tenue vérifier",
                    "children": [
                        {
                            "id": "541212",
                            "text": "Cabinets de comptables",
                            "keywords": "assurer budgets cabinets comptabilité comptables comptes conception connexes conseils consultatifs déclarations d'états entreprises financiers fournir gamme gestion insolvables l'établissement l'examen livres paye peuvent préparation prestation rapports revenus services systèmes tenue vérification"
                        },
                        {
                            "id": "541213",
                            "text": "Services de préparation des déclarations de revenus",
                            "keywords": "assurer comptabilité déclarations facturation fournir livres paye peuvent préparation revenus services seulement tenue traitement"
                        },
                        {
                            "id": "541215",
                            "text": "Services de tenue de livres et de paye et services connexes",
                            "keywords": "assurer comptabilité comptables comptes connexes d'états facturation financiers fournir gestion l'examen livres paye peuvent préparation rapports services tenue traitement vérification"
                        }
                    ]
                },
                {
                    "id": "5413",
                    "text": "Architecture, génie et services connexes",
                    "keywords": "architecture bâtiments cartographie conception connexes d'aménagement d'architecture d'arpentage design d'essai dessin d'inspection d'intérieur fournir génie graphique industriel laboratoire levé paysager prospection services spécialisés structures technique terrain",
                    "children": [
                        {
                            "id": "541350",
                            "text": "Services d'inspection des bâtiments",
                            "keywords": "aspects bâtiment bâtiments compte d'acheteurs d'inspection équipements évaluent immobilières l'état l'inspection normalement participant personnes propriété rapport rédigent services structure techniques transactions"
                        },
                        {
                            "id": "541340",
                            "text": "Services de dessin technique",
                            "keywords": "composants d'architecte dessin dessiner détaillés devis d'immeubles d'ingénieur d'ouvrages illustrations partir plans schémas services systèmes technique"
                        },
                        {
                            "id": "541330",
                            "text": "Services de génie",
                            "keywords": "appliquer conception connexes conseils construction d'avant-projets détaillés d'études développement d'ingénierie d'instruments d'ouvrages entreprises faisabilité génie intervenir l'autre l'étape l'évaluation l'inspection l'installation l'une l'utilisation machines matériaux peuvent plans préparation prestation principes procédés projets services sommaires suivantes systèmes tâches techniques"
                        },
                        {
                            "id": "541310",
                            "text": "Services d'architecture",
                            "keywords": "bâtiment bâtiments code commerciaux concevoir connaissance construction d'architecture design industriels institutionnels matériaux méthodes ouvrages planifier récréatifs règlements résidentiels s'appuyant services zonage"
                        },
                        {
                            "id": "541320",
                            "text": "Services d'architecture paysagère",
                            "keywords": "administrer aéroports aires bâtiments caractéristiques commerciales concevoir connaissance d'aménagement d'architecture écoles hôpitaux industrielles l'aménagement l'emplacement lieux loisirs lotissements l'utilisation ouvrages parcs paysager paysagère planifier plans projets résidentielles routes s'appuyant services terrains zones"
                        },
                        {
                            "id": "541370",
                            "text": "Services d'arpentage et de cartographie (sauf les levés géophysiques)",
                            "keywords": "cadastraux cartes cartographie cartographiques comprendre contrôle création d'arpentage d'information directeurs droits d'utilité effectués fond fournir géodésiques géographique géophysiques géospatiale global l'aide l'arpentage levés l'océan notons partage peuvent photogrammétrique positionnement production publique qualité services servitudes sig souterraines surface système systèmes terrains terrestre topographiques vue zones"
                        },
                        {
                            "id": "541360",
                            "text": "Services de prospection et de levé géophysiques",
                            "keywords": "besoins diverses données électriques électromagnétiques forme gaz génie géophysiques gravimétriques interpréter levé levés localisation magnétiques mesure minéraux pétrole peuvent présenter prévision prospection radiométriques rassembler ressources selon services sismiques sous-sol spécialisent techniques travaux utilisées"
                        },
                        {
                            "id": "541380",
                            "text": "Laboratoires d'essai",
                            "keywords": "analyses analytiques chimiques d'essai effectuer essais laboratoire laboratoires peuvent physiques terrain tests"
                        }
                    ]
                },
                {
                    "id": "5414",
                    "text": "Services spécialisés de design",
                    "keywords": "architecturale conception design fournir informatiques services spécialisés systèmes technique",
                    "children": [
                        {
                            "id": "541410",
                            "text": "Services de design d'intérieur",
                            "keywords": "administrer appliqué architectes bâtiment code commerciaux compte concevoir consultants d'accueil d'agencement décoration d'embellissement design d'étage d'intérieur domaines d'organisation électriques espaces esthétiques exercent exigences gens immeubles infrastructures institutionnels intérieur intérieure intérieurs l'achalandage l'espace matériel matérielles mécaniques meubles offrant planifier plans profession projets règlements répondre résidentiels santé sécurité services sociétés soins tenant uniquement"
                        },
                        {
                            "id": "541490",
                            "text": "Autres services spécialisés de design",
                            "keywords": "design figurent fournir professionnels services spécialisés"
                        },
                        {
                            "id": "541430",
                            "text": "Services de design graphique",
                            "keywords": "afin communication complexe comprendre conception concevoir d'écran d'écriteaux d'emballages design d'images documents éclaircir gérer graphique identités imprimés l'information marque messages moyens notions pages peuvent planifier production projeter publicités services systèmes véhiculer visuelle visuelles"
                        },
                        {
                            "id": "541420",
                            "text": "Services de design industriel",
                            "keywords": "avant-projets choix commercial comprendre compte couleur créer d'entretien design distribution d'utilisation élaborer facilité facteurs fini fonction forme humains industriel l'apparence l'attrait matériaux mécanismes optimisent peuvent production produit produits sécurité services spécifications structure surface tenu valeur"
                        }
                    ]
                },
                {
                    "id": "5415",
                    "text": "Conception de systèmes informatiques et services connexes",
                    "keywords": "besoins celle charge client clients communications conception concevoir connexes conseils créer d'accueil d'informatique domaine données donner expertise exploiter fournir gérer informatique informatiques installations intégrant internet l'information logiciels matériel modifier nature pages peuvent place planifier prendre professionnels répondre services systèmes techniques technologie technologies tester traitement",
                    "children": [
                        {
                            "id": "541514",
                            "text": "Conception de systèmes informatiques et services connexes (sauf la conception et le développement de jeux vidéo)",
                            "keywords": "analyse application assistée besoins bureautique CAO celle charge client clients communications conception concepts concevoir connexes conseils consultants consultation consultant créer d'accueil d'informatique demande désastre développement développeur domaine données donner effectués élaboration entretien exigences expertise exploiter exploitation fabrication fabriquée fabriqués FAO fournir gérer gestion IAO information informatique informatiques ingénierie installation installations intégrant intégrateurs intégration Internet internet l'information local logiciel logiciels matériel modifier multiples nature ordinateur ordinateurs page pages personnalisé peuvent place planifier prendre professionnels progiciels programmation programmes récupération répondre réseau RL service services soutien spéciale système systèmes techniques technologie technologies tester TI traitement usagers web"
                        },
                        {
                            "id": "541515",
                            "text": "Services de conception et de développement de jeux vidéo",
                            "keywords": "conception demande développement jeux vidéo"
                        }
                    ]
                },
                {
                    "id": "5416",
                    "text": "Services de conseils en gestion et de conseils scientifiques et techniques",
                    "keywords": "conseils environnementales fournir gestion l'assistance questions relativement scientifiques services techniques",
                    "children": [
                        {
                            "id": "541690",
                            "text": "Autres services de conseils scientifiques et techniques",
                            "keywords": "conseils figurent fournir l'assistance questions relativement scientifiques services techniques"
                        },
                        {
                            "id": "541620",
                            "text": "Services de conseils en environnement",
                            "keywords": "assainissement composé conseils consultants contamination contrôle dangereuses dépollution déterminent d'ingénieurs domaines droit emploient environnement environnementales évaluent expertise fournir l'air l'amiante l'assainissement l'assistance l'eau l'environnement matières mesurent multidisciplinaire notons personnel polluants problèmes qualité questions recommandent relativement risques scientifiques services solutions substances techniciens toxiques"
                        },
                        {
                            "id": "541612",
                            "text": "Services de conseils en ressources humaines",
                            "keywords": "avantages cadres communication conseils fournir gestion humaines l'administration l'assistance matière personnel planification politiques pratiques procédures questions recherche recrutement relativement rémunération ressources salaires services sociaux systèmes traitements"
                        },
                        {
                            "id": "541611",
                            "text": "Services de conseils en gestion administrative et générale",
                            "keywords": "administratifs administrative budgétisation choix clients complète conseils consultants démarrage d'entreprises distribution documents financières fournir gamme gestion humaines l'actif l'aide l'amélioration l'assistance l'avoir logistique marketing offrant organisationnelle planification processus questions relativement ressources services site stratégique"
                        },
                        {
                            "id": "541619",
                            "text": "Autres services de conseils en gestion",
                            "keywords": "conseils figurent fournir gestion l'assistance questions relativement services"
                        }
                    ]
                },
                {
                    "id": "5417",
                    "text": "Services de recherche et de développement scientifiques",
                    "keywords": "améliorés appliquer champ classes connaissances création définies développement domaine élargir expérimental fonction investigations l'établissement l'expertise nettement nouveaux originales procédés produits réaliser recherche résultats scientifique scientifiques selon services systématiques",
                    "children": [
                        {
                            "id": "541710",
                            "text": "Recherche et développement en sciences physiques, en génie et en sciences de la vie",
                            "keywords": "agriculture biologie biotechnologie botanie chimie connexes développement disciplines électronique environnement expérimental foresterie génie géologie mathématiques médecine océanographie ordinatique pêcheries pharmacie physique physiques recherche santé sciences vétérinaire vie"
                        },
                        {
                            "id": "541720",
                            "text": "Recherche et développement, en sciences humaines et en sciences sociales",
                            "keywords": "développement droit économique éducation effectuer humaines l'analyse langues psychologie recherche sciences sociales sociologie"
                        }
                    ]
                },
                {
                    "id": "5418",
                    "text": "Publicité, relations publiques et services connexes",
                    "keywords": "affichage agences annonces annonceurs cadeaux campagnes compte connexes créer d'accueil d'agences d'annonceurs d'enseignes échantillons fournir l'espace lettrage l'extérieur l'intérieur livrer matériel médias mettre oeuvre peinture placer poste propriétaires publicitaires publicité publipostage publiques réalisation relations services temps vendre vitrines",
                    "children": [
                        {
                            "id": "541870",
                            "text": "Services de distribution de matériel publicitaire",
                            "keywords": "d'échantillons distribution électronique livraison manière matériel poste publicitaire publicitaires services"
                        },
                        {
                            "id": "541899",
                            "text": "Tous les autres services liés à la publicité",
                            "keywords": "figurent fournir liés publicité services"
                        },
                        {
                            "id": "541860",
                            "text": "Publipostage",
                            "keywords": "campagnes concevoir créer d'adresses directe distribution dresser envoyer jour listes louer matériel peuvent poste préparer publicitaire publipostage tenir vendre"
                        },
                        {
                            "id": "541850",
                            "text": "Publicité par affichage",
                            "keywords": "affichage affiches centres commerciaux commun créer électroniques imprimées installations l'extérieur l'intérieur matériel panneaux-réclames peintes placer publicitaire publicité réseaux transport véhicules"
                        },
                        {
                            "id": "541840",
                            "text": "Représentants de médias",
                            "keywords": "compte d'espace médias propriétaires représentants temps vente"
                        },
                        {
                            "id": "541830",
                            "text": "Agences d'achat de médias",
                            "keywords": "acheter agences annonceurs d'achat directement l'espace médias propriétaires publicitaire publicité revendre temps"
                        },
                        {
                            "id": "541820",
                            "text": "Services de relations publiques",
                            "keywords": "campagnes clients conçues création intérêts l'image mise oeuvre promouvoir publiques relations services"
                        },
                        {
                            "id": "541810",
                            "text": "Agences de publicité",
                            "keywords": "agences assurer campagnes comptes consultation création créée créer diffuser directement gamme gestion journaux l'achat manière matériel médias périodiques plans pouvoir préparation production publicitaire publicitaires publicité radio services sous-traitant structurés télévision"
                        },
                        {
                            "id": "541891",
                            "text": "Distributeurs de publicité par l'objet",
                            "keywords": "accessoires agissent appuyés autocollants bureau cadeaux calendriers clients crayons créer distribuent distributeurs entre fournisseurs gratuitement insignes intermédiaires l'objet macarons messages objets organiser plumes portables production produits publicitaires publicité"
                        }
                    ]
                },
                {
                    "id": "5419",
                    "text": "Autres services professionnels, scientifiques et techniques",
                    "keywords": "cabinets d'études d'interprètes figurent fournir maisons marché notons photographie professionnels scientifiques services sociétés sondage studios techniques traducteurs vétérinaires",
                    "children": [
                        {
                            "id": "541940",
                            "text": "Services vétérinaires",
                            "keywords": "autorisés chirurgie dentaire exercer laboratoires médecine services vétérinaire vétérinaires"
                        },
                        {
                            "id": "541920",
                            "text": "Services photographiques",
                            "keywords": "aérienne bande-vidéo commerciale d'événements domaine enregistrer événements fournir images industrielle informatiques obtenir particulier peuvent photographie photographiques photos portrait prendre procédés services spécialiser spéciaux tourner vidéos"
                        },
                        {
                            "id": "541910",
                            "text": "Études de marché et sondages d'opinion",
                            "keywords": "collecte d'études données d'opinion études l'enregistrement marché présentation sondages totalisation"
                        },
                        {
                            "id": "541930",
                            "text": "Services de traduction et d'interprétation",
                            "keywords": "d'interprétation documents écrits énoncés gestuelle interpréter langue l'autre l'interprétation oraux services traduction traduire"
                        },
                        {
                            "id": "541990",
                            "text": "Tous les autres services professionnels, scientifiques et techniques",
                            "keywords": "figurent fournir professionnels scientifiques services techniques"
                        }
                    ]
                }
            ]
        },
        {
            "id": "55",
            "text": "Gestion de sociétés et d'entreprises",
            "keywords": "actifs afin celles-ci confier d'avoir décisions d'entreprises détenir d'influer dirigeants entreprises etou exercer financière financiers fonction gérer gestion gestionnaires majoritaire participation peuvent portefeuille sociétés titres",
            "children": [
                {
                    "id": "551113",
                    "text": "Sociétés de portefeuille",
                    "keywords": "afin contrôle décisions détenir d'exercer d'influer directement dirigeants elles entreprises etou filiales intérêts l'intermédiaire portefeuille sociétés titres"
                },
                {
                    "id": "551114",
                    "text": "Sièges sociaux",
                    "keywords": "administratif affiliés etou fournir gestion services sièges sociaux soutien"
                }
            ]
        },
        {
            "id": "56",
            "text": "Services administratifs, services de soutien, services de gestion des déchets et services d'assainissement",
            "keywords": "administratifs appartenant appartiennent assainir bâtiments cas certains classes classés clients collecter commandes consistent créances d'assainissement déchets d'établissements distincts diverses documents donc éliminer emballer entreprises étiqueter exploiter fosses fournir gérer gestion installations l'économie l'interne matériaux ménages nettoyer nombreux opérations organisations organiser personnel peuvent placer plusieurs pollués prendre préparer présent produits quotidiennes recouvrer recruter récupération secteurs sécurité septiques services sites soutien spécialisent spécialisés surveillance traiter types voyages",
            "children": [
                {
                    "id": "561",
                    "text": "Services administratifs et services de soutien",
                    "keywords": "administratifs appartenant bâtiments cas certains classes clients commandes créances d'après définies diverses documents donc elles entreprises fournir fournissent fourniture gestion laquelle l'économie l'emballage l'étiquetage l'interne l'organisation ménages nettoyage nombreux opérations organisations particulière particulières particuliers personnel peuvent placement plusieurs préparation présent prise produits quotidiennes recouvrement recrutement secteurs sécurité services soutien spécialisent surveillance voyages",
                    "children": [
                        {
                            "id": "561910",
                            "text": "Services d'emballage et d'étiquetage",
                            "keywords": "appartiennent clients d'emballage d'étiquetage emballer inclure l'emballage l'étiquetage l'impression produits service services"
                        },
                        {
                            "id": "561920",
                            "text": "Organisateurs de congrès, de salons et de foires commerciales",
                            "keywords": "appuyer commerciales congrès événements exploitent foires installations lieu organisateurs organiser promouvoir salons"
                        },
                        {
                            "id": "561621",
                            "text": "Services de systèmes de sécurité (sauf les serruriers)",
                            "keywords": "anti-vol d'alarme d'installation distance électroniques incendie réparation sécurité serruriers services surveillance surveiller systèmes vendre"
                        },
                        {
                            "id": "561622",
                            "text": "Serruriers",
                            "keywords": "adapter chambres coffres-forts d'adaptation d'installation dispositifs électroniques fortes installer mécaniques neuf réfection remettre réparation réparer serruriers services vendre verrouillage"
                        },
                        {
                            "id": "561710",
                            "text": "Services d'extermination et de lutte antiparasitaire",
                            "keywords": "alentours animaux antiparasitaire bâtiments contrôler d'extermination exterminer insectes lutte nuisibles rongeurs services structures"
                        },
                        {
                            "id": "561990",
                            "text": "Tous les autres services de soutien",
                            "keywords": "figurent fournir services soutien"
                        },
                        {
                            "id": "561590",
                            "text": "Autres services de préparation de voyages et de réservation",
                            "keywords": "agences fournir préparation réservation services voyages voyagistes"
                        },
                        {
                            "id": "561520",
                            "text": "Voyagistes",
                            "keywords": "commercialiser d'agences généralement l'entremise mettre organisés pied planifier voyages voyagistes"
                        },
                        {
                            "id": "561510",
                            "text": "Agences de voyage",
                            "keywords": "agences clients d'agent détail d'hébergement grand jouer organisés préparation privé public rôle services sociétés transport vendre voyage voyages voyagistes vue"
                        },
                        {
                            "id": "561613",
                            "text": "Services de voitures blindées",
                            "keywords": "biens blindées d'argent durant équipé livraison objets personnel protéger ramassage reçus services transport utilisant valeur voitures"
                        },
                        {
                            "id": "561611",
                            "text": "Services d'enquêtes",
                            "keywords": "d'enquêtes détectives fournir services"
                        },
                        {
                            "id": "561612",
                            "text": "Services de garde et de patrouille",
                            "keywords": "fournir garde patrouille services"
                        },
                        {
                            "id": "561410",
                            "text": "Services de préparation de documents",
                            "keywords": "corriger d'éditique délibérations documents fournir préparation rédiger réviser secrétariat services sténographie sténographique texte traitement transcription tribunaux"
                        },
                        {
                            "id": "561490",
                            "text": "Autres services de soutien aux entreprises",
                            "keywords": "entreprises figurent fournir services soutien"
                        },
                        {
                            "id": "561440",
                            "text": "Agences de recouvrement",
                            "keywords": "agences clients créances paiements perçus recouvrement versement"
                        },
                        {
                            "id": "561430",
                            "text": "Centres de services aux entreprises",
                            "keywords": "boîtes bureau centres connus copie détail d'expédition d'ordinateurs entreprises fournir fournissent gamme lettres location magasins nom personnels postaux produits publipostage reprographie services soutien télécopie texte traitement vente"
                        },
                        {
                            "id": "561420",
                            "text": "Centres d'appels téléphoniques",
                            "keywords": "appels boîte centres clients collecter commandes consistent d'appels derniers destinés etou fonds fournir messages prendre produits promotion recevoir renseignements répondre services solliciter téléphoniques tiers transmettre vocale"
                        },
                        {
                            "id": "561110",
                            "text": "Services administratifs de bureau",
                            "keywords": "administratifs administrer bureau client clients commerciales coordonner d'administration d'exploitation diriger distribution d'opérations ensemble exécuter facturation financement fournir fournissent gestion l'entreprise livres nécessaire opérations personnel personnelles physique quotidiennes services tenue"
                        },
                        {
                            "id": "561450",
                            "text": "Agences d'évaluation du crédit",
                            "keywords": "agences antécédents concernant crédit d'emploi d'enquêtes d'entreprises détaillants d'évaluation doivent entreprises évaluer financières fournir fournissent institutions l'information particuliers parties personnes rassembler renseignements services solvabilité"
                        },
                        {
                            "id": "561330",
                            "text": "Location de personnel permanent",
                            "keywords": "avantages certains client clientes clients co-employeur comptabilité concerne connexes cotisations décisionnaire déclarations degré d'employeurs embauchent employés entreprises établissent exercent fournir gamme gestion gestionnaire humaines jouent l'administration l'exécution location louent opérationnelles organisations paye permanent personnel planification pouvoir préparation productivité quant rapport recrutement relation relations rentabilité responsabilité ressources retour rôle salaire services sociales sociaux spécialisent spécialisés stratégique tâches travail typiquement variable vaste versement voire"
                        },
                        {
                            "id": "561320",
                            "text": "Location de personnel suppléant",
                            "keywords": "client compléter directe employées employés fournir lieux limitées location main-d'oeuvre n'assurent offrent périodes personnel personnes placées services supervision suppléant travail travailleurs vue"
                        },
                        {
                            "id": "561310",
                            "text": "Agences de placement et services de recherche de cadres",
                            "keywords": "agences cadres candidats choisir employées façon l'emploi lister orienter permanente personnes placées placement placer postes recherche services temporaire vacants"
                        },
                        {
                            "id": "561210",
                            "text": "Services de soutien d'installations",
                            "keywords": "base client conciergerie connexes courrier d'acheminement d'autre d'élimination d'entretien d'exploitation d'installations exécuter fournir fournissent garde installations lessive l'établissement lieu logistique nécessaire n'en opérations ordures participent personnel réception responsabilité sécurité sein services soutenir soutien typiquement vue"
                        },
                        {
                            "id": "561721",
                            "text": "Services de nettoyage de vitres",
                            "keywords": "nettoyage services vitres"
                        },
                        {
                            "id": "561722",
                            "text": "Services de conciergerie (sauf le nettoyage de vitres)",
                            "keywords": "aéronefs bâtiments chemins conciergerie etou fer intérieur matériel navires nettoyage services transport vitres voitures"
                        },
                        {
                            "id": "561730",
                            "text": "Services d'aménagement paysager",
                            "keywords": "activité bois clôtures construction d'allées d'aménagement d'arbres d'arbustes d'entretien d'étangs etou jardins murs offrir paysager pelouses piétonnières plantation plantes services similaires soutènement structures susmentionnées terrasses"
                        },
                        {
                            "id": "561740",
                            "text": "Services de nettoyage de tapis et de meubles rembourrés",
                            "keywords": "carpettes meubles nettoyage nettoyer rembourrés services tapis teindre"
                        },
                        {
                            "id": "561791",
                            "text": "Services de nettoyage de conduits et de cheminées",
                            "keywords": "chaudières cheminées conduits fournir nettoyage services"
                        },
                        {
                            "id": "561799",
                            "text": "Tous les autres services relatifs aux bâtiments et aux logements",
                            "keywords": "bâtiments extérieur figurent fournir logements nettoyage piscines sablage services"
                        }
                    ]
                },
                {
                    "id": "562",
                    "text": "Services de gestion des déchets et d'assainissement",
                    "keywords": "collecte d'assainissement déchets d'élimination fosses fournir gestion installations matériaux pompage récupération septiques services traitement",
                    "children": [
                        {
                            "id": "562990",
                            "text": "Tous les autres services de gestion des déchets",
                            "keywords": "déchets figurent gestion services"
                        },
                        {
                            "id": "562110",
                            "text": "Collecte de déchets ",
                            "keywords": "avoir collecte collecter dangereux déchets d'emballer limites locale peuvent région responsabilité stations traiter transfert transport transporter"
                        },
                        {
                            "id": "562210",
                            "text": "Traitement et élimination des déchets",
                            "keywords": "collecte dangereux décharge déchets d'élimination d'incinérateurs élimination installations intègrent l'exploitation sites traitement"
                        },
                        {
                            "id": "562910",
                            "text": "Services d'assainissement",
                            "keywords": "bâtiments contaminés courbes dangereuses d'assainissement eaux intégrée l'assainissement l'élimination matières miniers nettoyage niveau régénération remise services sites sols souterraines tracé traitement usées végétation"
                        },
                        {
                            "id": "562920",
                            "text": "Installations de récupération de matériaux",
                            "keywords": "catégories déchets d'installations distinctes installations l'expédition l'exploitation matériaux mélangés préparés récupération recyclables séparés triés"
                        }
                    ]
                }
            ]
        },
        {
            "id": "61",
            "text": "Services d'enseignement",
            "keywords": "adaptés appel appelés approfondies aptitude besoins biais cadres caractéristique celle centres classes collèges commun connaissances correspondance cours d'alimentation démonstrations d'enseignement d'établissements d'exemple d'hébergement diriger dispenser dispensés divers domicile donne écoles élèves enseignants enseignement enseigner exige expliquer formation grande informer langage l'autoapprentissage l'élève l'enseignement lucratif malentendants matière matières milieu moyens offrir oral particuliers peuvent place privés publics qu'une s'agit services signes spécialisés superviser télévision titre travail universités utilisé variété",
            "children": [
                {
                    "id": "611690",
                    "text": "Tous les autres établissements d'enseignement et de formation",
                    "keywords": "d'enseignement dispenser figurent formation services"
                },
                {
                    "id": "611630",
                    "text": "Écoles de langues",
                    "keywords": "carrière conversation cours d'enrichissement dispensés écoles enseigner étrangères études fins formation intensive langues personnel poursuivre suivis vont"
                },
                {
                    "id": "611620",
                    "text": "Formation athlétique",
                    "keywords": "athlétique athlétiques diverses écoles formation hébergement jour offrant offrir sportive"
                },
                {
                    "id": "611110",
                    "text": "Écoles primaires et secondaires",
                    "keywords": "année base cours dispenser douzième écoles forment l'éducation maternelle préparatoire primaires secondaires théoriques va"
                },
                {
                    "id": "611710",
                    "text": "Services de soutien à l'enseignement",
                    "keywords": "appuyer d'enseignement destinés didactiques l'enseignement méthodes offrir services soutien systèmes"
                },
                {
                    "id": "611210",
                    "text": "Collèges communautaires et cégeps",
                    "keywords": "admis cégeps certificats collèges communautaires cours d'associé décerner d'études diplôme diplômes doit équivalente formation grade grades l'élève l'équivalent l'obtention menant niveau offrir posséder pré-universitaire programme scolaire secondaires techniques théoriques"
                },
                {
                    "id": "611310",
                    "text": "Universités",
                    "keywords": "admis baccalauréat cours cycles décerner d'enseignement d'études diplôme diplômes dispenser doit équivalente exigé formation l'admission l'élève niveau posséder professionnel programme programmes scolaire secondaires supérieures supérieurs théoriques universités"
                },
                {
                    "id": "611410",
                    "text": "Écoles de commerce et de secrétariat",
                    "keywords": "base bureau carrière commerce communications cours d'éditique destinent d'informatique dispenser domaine écoles électroniques fonctionnement formation judiciaire machines matières offrir personnes peuvent réception secrétariat sténographie tableurs texte traitement travail utiles"
                },
                {
                    "id": "611420",
                    "text": "Formation en informatique",
                    "keywords": "administratifs aspects chez client cours d'enseignement dispenser dispensés formation gestion informatique informatiques informatisés l'établissement l'informatique locaux opérations peuvent progiciels programmation réseaux systèmes technologie"
                },
                {
                    "id": "611430",
                    "text": "Formation professionnelle et perfectionnement en gestion",
                    "keywords": "abrégés adaptés besoins biais clients cours d'enseignement directement dispensée employeurs éventail fonction formation gestion l'établissement lieux modifiés offerts offrir particuliers perfectionnement personnes peuvent professionnelle professionnels programmes séminaires travail"
                },
                {
                    "id": "611510",
                    "text": "Écoles techniques et écoles de métiers",
                    "keywords": "certificat correspondance d'enseignement écoles formation l'obtention matières mène métiers offrir professionnelle professionnelles technique techniques universitaire variété"
                },
                {
                    "id": "611610",
                    "text": "Écoles des beaux-arts",
                    "keywords": "arts beaux-arts danse donner dramatique écoles formation graphiques incluant l'art l'exception musique photographie professionnelle publicitaire"
                }
            ]
        },
        {
            "id": "62",
            "text": "Soins de santé et assistance sociale",
            "keywords": "aide assistance assurant bénéficiaires besoin communautaires counselling d'alimentation d'assistance d'hébergement diagnostiques dispenser garderie internes l'enfance médicales offrir professionnelle protection raisons réadaptation santé services sociale sociales soigner soins telle thérapeutiques",
            "children": [
                {
                    "id": "621",
                    "text": "Services de soins de santé ambulatoires ",
                    "keywords": "ambulatoires consultation directement dispenser externe forment indirectement installations lesquels malades matériel partie praticiens procédé procurent production services soins",
                    "children": [
                        {
                            "id": "621320",
                            "text": "Cabinets d'optométristes",
                            "keywords": "ajuster cabinets collectif cornéennes déceler déterminer dispenser d'opticien d'optométristes d'ordonnance examen exercer exercices individuel l'acuité lentilles l'optométrie lunettes peuvent praticiens prescrivent problèmes procèdent services titre vendre vision visuelle vue yeux"
                        },
                        {
                            "id": "621310",
                            "text": "Cabinets de chiropraticiens",
                            "keywords": "affections cabinets chiropraticiens chiropratique collectif colonne connexes diagnostiques exercer individuel l'égard manipulation membres neuromusculaires praticiens procurent redressement services thérapeutiques titre troubles vertébrale"
                        },
                        {
                            "id": "621210",
                            "text": "Cabinets de dentistes",
                            "keywords": "autorisés bureau cabinets centre chirurgie clinique collectif dentaire dentistes exercer heures individuel médecine nom parfois portent prolongées rendez-vous soigner spécialité surtout s'y titre"
                        },
                        {
                            "id": "621110",
                            "text": "Cabinets de médecins",
                            "keywords": "autorisés bureau cabinets centre centres chirurgie clinique cliniques collectif confondus consultations désigne doivent exercer externes heures individuel médecine médecins médical médicale nom parfois portent prolongées rendez-vous soigner spécialité surtout s'y terme titre"
                        },
                        {
                            "id": "621990",
                            "text": "Tous les autres services de soins de santé ambulatoires ",
                            "keywords": "ambulatoires dispenser figurent services soins"
                        },
                        {
                            "id": "621912",
                            "text": "Services d'ambulance aérienne",
                            "keywords": "aérienne compétent d'ambulance d'appareils dispenser dotés malades personnel premiers qu'utilise sauver servant services soins transporter véhicules vies voie"
                        },
                        {
                            "id": "621911",
                            "text": "Services d'ambulance (sauf les services d'ambulance aérienne)",
                            "keywords": "aérienne compétent d'ambulance d'appareils dispenser dotés malades personnel premiers qu'utilise route sauver servant services soins transporter véhicules vies"
                        },
                        {
                            "id": "621610",
                            "text": "Services de soins de santé à domicile",
                            "keywords": "ci-dessus compagnie compétent consultation d'audiologie d'ergothérapie d'hygiène diététique d'intravénothérapie dispenser domestiques domicile d'orthophonie énumérés fournitures infirmier infirmiers matériel médicaments médicaux nutrition personnel personnelle physiothérapie procurent santé services seuls sociomédicaux soins thérapie travail travaux"
                        },
                        {
                            "id": "621510",
                            "text": "Laboratoires médicaux et d'analyses diagnostiques",
                            "keywords": "d'analyse d'analyses diagnostic diagnostiques dispensés laboratoires malades médicale médicaux offrir ordre praticien profession services"
                        },
                        {
                            "id": "621499",
                            "text": "Tous les autres centres de soins ambulatoires",
                            "keywords": "ambulatoires appelés assurer cabinets centre centres classes clinique confondus consultation dialyse doivent dotés externe façon figurent genre médical nom personnel portent praticiens services soins spéciaux"
                        },
                        {
                            "id": "621494",
                            "text": "Centres communautaires de soins de santé",
                            "keywords": "appelés cabinets centre centres classes clinique communautaires confondus consultation dispenser divers doivent dotés établissement externe façon figurent généraux genre l'entremise médical nom personnel portent praticiens santé soins"
                        },
                        {
                            "id": "621410",
                            "text": "Centres de planification familiale",
                            "keywords": "centres consultation contraception d'avortement dotés externe familiale gamme génétique médecin médical naissances ordre personnel planification prénataux procurer régulation services soins stérilisation thérapeutique volontaire"
                        },
                        {
                            "id": "621420",
                            "text": "Centres de soins ambulatoires pour personnes atteintes de troubles mentaux, d'alcoolisme et de toxicomanie",
                            "keywords": "ambulatoires atteintes centres consultation d'alcoolisme diagnostiques dispenser dotés externe l'alcoolisme l'information médical mentale mentaux offrir personnel personnes peuvent rapportant santé services soins sujets thérapeutiques toxicomanie très troubles variés"
                        },
                        {
                            "id": "621390",
                            "text": "Cabinets de tous les autres praticiens de la santé ",
                            "keywords": "cabinets dispenser figurent praticiens santé services"
                        },
                        {
                            "id": "621340",
                            "text": "Cabinets de physiothérapeutes, d'ergothérapeutes, d'orthophonistes et d'audiologistes",
                            "keywords": "administrer appel atteintes cabinets d'aider d'audiologistes d'ergothérapeutes diagnostiquer divertissement d'orthophonistes entreprendre faisant incapacité langue l'audition l'élocution l'enseignement médecin mentale ordre personnes physiothérapeutes physique planifier rétablir s'adapter socialisation soigner thérapie troubles vue"
                        },
                        {
                            "id": "621330",
                            "text": "Cabinets de praticiens en santé mentale (sauf les médecins)",
                            "keywords": "cabinets cliniques diplôme dispenser médecine médecins mentale possèdent praticiens psychiatrie psychologues rangés santé services sociaux travailleurs"
                        }
                    ]
                },
                {
                    "id": "622",
                    "text": "Hôpitaux",
                    "keywords": "activité agréés bénéficiaires complément composé conditions consultation derniers diagnostiques d'infirmiers d'installations dotés externe fournir gamme grande héberger hôpitaux infirmières intégrante internes matériel médecins médical médicaux occupent particulières partie personnel peuvent place possèdent procédé procurer production professionnels reconnus santé services spécialisés structuré techniciens technologues thérapeutiques",
                    "children": [
                        {
                            "id": "622210",
                            "text": "Hôpitaux psychiatriques et hôpitaux pour alcooliques et toxicomanes",
                            "keywords": "agréés alcooliques assurer consultation d'électroencéphalographie diagnostiques dispenser état exige externe hôpitaux l'hôpital malades mentaux peuvent prolongé psychiatriques reconnus séjour services suivre thérapeutiques toxicomanes traitement"
                        },
                        {
                            "id": "622112",
                            "text": "Hôpitaux pédiatriques",
                            "keywords": "agréés assurer clinique consultation diagnostiques dispensent diverses enfants externe hôpitaux hospitalisés laboratoire maladies pédiatriques pharmacie problèmes radiographie reconnus santé services souffrant thérapeutiques très variés"
                        },
                        {
                            "id": "622111",
                            "text": "Hôpitaux généraux (sauf pédiatriques)",
                            "keywords": "agréés assurer bénéficiaires clinique consultation diagnostiques dispensent diverses externe généraux hôpitaux internes laboratoire maladies pédiatriques pharmacie problèmes radiographie reconnus santé services souffrant thérapeutiques très variés"
                        },
                        {
                            "id": "622310",
                            "text": "Hôpitaux spécialisés (sauf psychiatriques et pour alcooliques et toxicomanes)",
                            "keywords": "agréés alcooliques assurer bénéficiaires chroniques clinique consultation d'adaptation d'éducation diagnostiques difficultés dispensent dispenser externe hôpitaux incapacité internes laboratoire l'alcoolisme l'exception long malades maladie personnes peuvent physiothérapie physiques prises problème procurent psychiatrique psychiatriques psychologiques quelconque radiographie rangés réadaptation reconnus rétablissement santé services social soins souffrent spécialisés terme thérapeutiques thérapie toxicomanes toxicomanie travail trouble"
                        }
                    ]
                },
                {
                    "id": "623",
                    "text": "Établissements de soins infirmiers et de soins pour bénéficiaires internes",
                    "keywords": "bénéficiaires combinent composant dispenser dispensés divers importante infirmiers installations internes large malades médical médicaux mesure procédé production représentent services sociaux soins surveillance volet",
                    "children": [
                        {
                            "id": "623310",
                            "text": "Établissements communautaires de soins pour personnes âgées",
                            "keywords": "âgées autonome bénéficiaires cas certains communautaires comprennent d'elles-mêmes désirent dispenser distinctes domestiques incapables infirmiers installations institutionnels internes l'aide l'hébergement lieux logeant manière nourriture personnels personnes procurent professionnels quotidiennes services s'occuper soins surveillance travaux typiquement vie vivre"
                        },
                        {
                            "id": "623222",
                            "text": "Maisons pour personnes souffrant de troubles psychiques",
                            "keywords": "assurent bénéficiaires compléter conseils consultation dispenser divers grande hébergement institutionnels maisons maladie médicaux mentale nourriture offre outre personnes procurent prodigués psychiques qu'on réadaptation règle services sociaux soins souffrant soutien surveillance troubles variété"
                        },
                        {
                            "id": "623210",
                            "text": "Établissements résidentiels pour handicaps liés au développement",
                            "keywords": "aider atteintes avant certains cherche développement d'hôpital dispenser dispensés établissement foyer handicap handicaps institutionnels lié liés loger malades nom nourrir personnes peuvent porter protéger résidentiels santé soins surveiller tout"
                        },
                        {
                            "id": "623221",
                            "text": "Établissements résidentiels pour alcoolisme et toxicomanie ",
                            "keywords": "alcoolisme assurent bénéficiaires compléter conseils consultation d'alcoolisme dispenser divers grande hébergement institutionnels médicaux nourriture offre outre personnes procurent prodigués qu'on réadaptation règle résidentiels services sociaux soins souffrant soutien surveillance toxicomanie variété"
                        },
                        {
                            "id": "623110",
                            "text": "Établissements de soins infirmiers",
                            "keywords": "assurer bénéficiaires besoin dispenser infirmiers internes l'établissement manière passent personnels personnes prolongé réadaptation séjour services soins soutenue"
                        },
                        {
                            "id": "623992",
                            "text": "Maisons pour enfants perturbés affectivement",
                            "keywords": "affectivement assurent couvert dispenser enfants gîte institutionnels maisons offrent parental perturbés procurent qu'une services soins spécialisée supervision surveillance"
                        },
                        {
                            "id": "623993",
                            "text": "Maisons pour les handicapés physiques ou les personnes ayant une incapacité",
                            "keywords": "ambulatoires appropriés déficience dispenser fournir handicap handicapés incapacité institutionnels maisons malades personnes physique physiques services soins surveiller visuelle"
                        },
                        {
                            "id": "623991",
                            "text": "Maisons de transition pour femmes",
                            "keywords": "bénéficiaires conseils dispenser femmes hébergent institutionnels maisons nourrissent prodiguent prolongés protègent services sociaux soins transition victimes violence"
                        },
                        {
                            "id": "623999",
                            "text": "Tous les autres établissements de soins pour bénéficiaires internes",
                            "keywords": "bénéficiaires dispenser figurent institutionnels internes soins"
                        }
                    ]
                },
                {
                    "id": "624",
                    "text": "Assistance sociale",
                    "keywords": "assistance clientèle comprennent courte d'aide directement dispenser durée l'hébergement l'institutionnalisation nombreux services sociale",
                    "children": [
                        {
                            "id": "624230",
                            "text": "Services d'urgence et autres secours",
                            "keywords": "catastrophes conflits conseils d'urgence fournir hébergement l'étranger médicaux nourriture pays réinstallation secours services soins vêtements victimes"
                        },
                        {
                            "id": "624220",
                            "text": "Services communautaires d'hébergement",
                            "keywords": "âgées bénévoles collaboration communautaires construction court crise d'agression d'hébergement enfants faible familiale familles fugueurs habitations hébergement héberger incapacité lieu loyer malades médicale modéré offrir organisations personnes procurent procurer propriétaire qu'aux rangées réfection rénovent réparent résidence revenu sans-abri s'assurant services sexuelle temporaire temporairement terme traversent victimes violence"
                        },
                        {
                            "id": "624210",
                            "text": "Services communautaires d'alimentation",
                            "keywords": "âge communautaires couvertures d'alimentation démunis distribuer dons elles-mêmes fixe incapacité lieu maladie mobile nécessiteux nourriture offrir personnes peuvent préparer raison recueillir repas services servir vêtements"
                        },
                        {
                            "id": "624110",
                            "text": "Services à l'enfance et à la jeunesse",
                            "keywords": "assurer d'aide enfants institutionnels jeunes jeunesse l'enfance services sociale"
                        },
                        {
                            "id": "624190",
                            "text": "Autres services individuels et familiaux",
                            "keywords": "d'aide dispenser familiaux familles figurent individuels institutionnels personnes services sociale"
                        },
                        {
                            "id": "624120",
                            "text": "Services aux personnes âgées et aux personnes ayant une incapacité",
                            "keywords": "âgées assurer atteintes bien-être compagnie concerne d'aide d'améliorer développement divers domicile handicaps incapacité institutionnels intéressés jour liés médicaux personnes plans qualité services sociale sociales soins soutien veillent vie vue"
                        },
                        {
                            "id": "624410",
                            "text": "Services de garderie",
                            "keywords": "âgés d'éducation d'enfants dispenser enfants garderie genre l'école lorsqu'ils nourrissons offrir peuvent préscolaire programmes services s'occuper vont"
                        },
                        {
                            "id": "624310",
                            "text": "Services de réadaptation professionnelle",
                            "keywords": "atelier chômeurs compétence défavorisées d'emploi d'expérience d'orientation formation handicap incapacité insuffisante manque marché mental offrir personnes physique professionnelle professionnelles raison réadaptation scolarité services souffrant sous-employées supervisé tas travail"
                        }
                    ]
                }
            ]
        },
        {
            "id": "71",
            "text": "Arts, spectacles et loisirs",
            "keywords": "artistiques arts assurent certains ci-dessous classés clientèle clients compétences créatrices culture culturel d'activités destinés d'expositions divertissement domaine éducatif énumérés exploitent exploiter exposent fournir fournissent grand historique importants installations intérêt intérêts loisirs matière nécessaires objets oeuvrant participer passe-temps permettent présentant préservent production produits promotion public récréatives répondant s'adonner scian secteurs services sites spectacles sportives techniques",
            "children": [
                {
                    "id": "7111",
                    "text": "Compagnies d'arts d'interprétation",
                    "keywords": "acteurs artistes chanteurs cirques compagnies danse danseurs d'arts d'interprétation faisant formations glace intervenir musicales musiciens notons organisateurs produire scène spectacles théâtrales",
                    "children": [
                        {
                            "id": "711190",
                            "text": "Autres compagnies d'arts d'interprétation",
                            "keywords": "compagnies d'arts d'interprétation figurent produire scène spectacles"
                        },
                        {
                            "id": "711120",
                            "text": "Compagnies de danse",
                            "keywords": "compagnies danse danseurs exploitent faisant installations intervenir présenter principalement production produire propre propres spectacles"
                        },
                        {
                            "id": "711112",
                            "text": "Compagnies de comédie musicale et d'opéra",
                            "keywords": "acteurs appelés boissons cafés-théâtres chant chanteurs comédie compagnies d'opéra faisant intervenir locaux musicale produire produisent professionnels repas servant spectacles théâtraux tout"
                        },
                        {
                            "id": "711130",
                            "text": "Formations musicales et musiciens",
                            "keywords": "chambre chanteurs country d'artistes etou faisant formations groupes indépendants individuels intervenir jazz mentionnons musicales musiciens musique orchestres populaire produire rock s'agir spectacles symphoniques"
                        },
                        {
                            "id": "711111",
                            "text": "Compagnies de théâtre (sauf de comédie musicale)",
                            "keywords": "acteurs comédie compagnies exploitent faisant installations intervenir musicale présenter principalement productions produire propres spectacles théâtrales théâtre"
                        }
                    ]
                },
                {
                    "id": "7112",
                    "text": "Sports-spectacles",
                    "keywords": "amateurs athlètes clubs courses d'athlète devant exploitants exploiter installations manifestations peuvent pistes présentent présenter professionnels public rôle semi-professionnels sportives sports sports-spectacles",
                    "children": [
                        {
                            "id": "711213",
                            "text": "Hippodromes",
                            "keywords": "chevaux courses exploiter hippodromes présenter"
                        },
                        {
                            "id": "711214",
                            "text": "Autres installations de course et activités connexes",
                            "keywords": "chenils chiens course cours entraînement équipes automobile motocyclette motoneige équipes motoneige exploitation pistes accélération voitures propulsion vitesse autodrome"
                        },
                        {
                            "id": "711215",
                            "text": "Athlètes indépendants s’exécutant devant un public payant",
                            "keywords": "boxeurs professionnels coureurs automobile golfeurs joueurs tennis athlètes arts martiaux mixtes piste indépendants cyclistes montagne hors piste billard quilles squash lutteurs patineurs artistiques vitesse planchistes skieurs"
                        },
                        {
                            "id": "711217",
                            "text": "Équipes et clubs sportifs jouant devant un public payant",
                            "keywords": "arbitres chronométreurs sportifs entraîneurs sportifs indépendants équipes clubs professionnels semi-professionnels amateurs baseball basket-ball football hockey soccer recruteurs"
                        }
                    ]
                },
                {
                    "id": "7113",
                    "text": "Promoteurs (diffuseurs) d'événements artistiques et sportifs et d'événements similaires",
                    "keywords": "arénas artistiques assurer comparables d'événements diffuseurs exploitées exploiter festivals installations l'organisation manifestations peuvent présenter productions promoteurs promotion semblables similaires spectacles sportifs sportives stades théâtres",
                    "children": [
                        {
                            "id": "711322",
                            "text": "Festivals, sans installations",
                            "keywords": "assurer exploitées festivals installations l'organisation promotion"
                        },
                        {
                            "id": "711329",
                            "text": "Diffuseurs d'événements sportifs et autres présentateurs, sans installations",
                            "keywords": "assurer d'événements diffuseurs etou exploitées figurent installations l'organisation manifestations présentateurs promotion sportifs sportives"
                        },
                        {
                            "id": "711321",
                            "text": "Promoteurs (diffuseurs) d'événements artistiques, sans installations",
                            "keywords": "artistiques assurer d'événements diffuseurs exploitées installations l'organisation manifestations promoteurs promotion"
                        },
                        {
                            "id": "711319",
                            "text": "Exploitants de stades et autres diffuseurs avec installations",
                            "keywords": "assurer diffuseurs etou exploitants exploiter installations l'organisation manifestations présentation promotion propres semblables sportifs sportives stades tenues tournois"
                        },
                        {
                            "id": "711311",
                            "text": "Exploitants de théâtres et autres diffuseurs d'événements artistiques avec installations",
                            "keywords": "artistiques assurer d'événements diffuseurs d'installations d'interprétation dotés exploitants exploiter festivals installations l'organisation organisateurs promotion spectacles tenus théâtre théâtres"
                        }
                    ]
                },
                {
                    "id": "7114",
                    "text": "Agents et représentants d'artistes, d'athlètes et d'autres personnalités publiques",
                    "keywords": "affaires agents artistes carrière célébrités clients contrat créateurs d'artistes d'athlètes doivent finances gèrent gérer interprètes lorsqu'ils négocier organisent personnalités promouvoir publiques représentants représentent représenter s'occupent sportives",
                    "children": [
                        {
                            "id": "711411",
                            "text": "Agents et représentants d’artistes, de professionnels de la scène et d’autres personnalités publiques",
                            "keywords": "agents artistiques théâtre gérants acteurs actrices artistes auteurs bureaux conférenciers orateurs célébrités mannequins musiciens professionnels scène agents modèles personnalités publiques"
                        },
                        {
                            "id": "711412",
                            "text": "Agents et gérants en sports",
                            "keywords": "agents gérants athlètes professionnels entraîneurs entraîneuses personnalités sportives"
                        }
                    ]
                },
                {
                    "id": "7115",
                    "text": "Artistes, auteurs et interprètes indépendants",
                    "keywords": "artistes artistiques athlètes auteurs conférences créer culturelles d'événements donnent fournir indépendantes indépendants individus interprètes jouer nécessaire notons oeuvres productions promotion rendent semblables services soutien spectacles technique vedettes",
                    "children": [
                        {
                            "id": "711512",
                            "text": "Acteurs, comédiens et interprètes indépendants",
                            "keywords": "acteurs artistiques athlètes comédiens conférences culturelles d'événements donnent fournir indépendantes indépendants individus interprètes jouer journalistes nécessaire productions promotion radio rendent semblables services soutien technique télévision vedettes"
                        },
                        {
                            "id": "711513",
                            "text": "Écrivains et auteurs indépendants",
                            "keywords": "artistiques auteurs création créer culturelles écrite écrivains fournir indépendants individus journalistes littéraires nécessaire presse soutien technique uvres"
                        },
                        {
                            "id": "711511",
                            "text": "Artistes visuels et artisans indépendants",
                            "keywords": "art artistes artistiques création créer culturelles fournir indépendants individus nécessaire soutien technique uvres visuelles visuels"
                        }
                    ]
                },
                {
                    "id": "7121",
                    "text": "Établissements du patrimoine",
                    "keywords": "culturel curiosités d'intérêt éducatif exposer historique lieux naturelles objets patrimoine préserver",
                    "children": [
                        {
                            "id": "712190",
                            "text": "Parcs naturels et autres institutions similaires",
                            "keywords": "aires biens conservation entretenir exploiter figurent institutions naturelles naturels parcs patrimoine protéger réserves similaires"
                        },
                        {
                            "id": "712130",
                            "text": "Jardins zoologiques et botaniques",
                            "keywords": "animaux botaniques construire entretenir jardins lieux plantes présente public vivants zoologiques"
                        },
                        {
                            "id": "712119",
                            "text": "Autres musées",
                            "keywords": "d'art d'histoire expositions musées produire publics sciences"
                        },
                        {
                            "id": "712120",
                            "text": "Lieux historiques et d'intérêt patrimonial",
                            "keywords": "bâtiments bâtis d'événements d'intérêt disposition ensembles entretenir forts historique historiques intérêt lieux mettre particulier patrimonial personnages présentant protéger public témoignent"
                        },
                        {
                            "id": "712111",
                            "text": "Musées d'art publics",
                            "keywords": "acquérir chercher collections conserver d'art expliquer exposer galeries musées objets permanentes présentent public publics"
                        },
                        {
                            "id": "712115",
                            "text": "Musées d'histoire et de sciences",
                            "keywords": "acquérir conserver culturel d'histoire d'intérêt disposition expliquer exposer historique mettre musées objets public sciences"
                        }
                    ]
                },
                {
                    "id": "7131",
                    "text": "Parcs d'attractions et salles de jeux électroniques",
                    "keywords": "d'attractions électroniques exploiter jeux parcs salles",
                    "children": [
                        {
                            "id": "713110",
                            "text": "Parcs d'attractions et jardins thématiques",
                            "keywords": "appelés attractions concession d'attractions d'eau diverses donner espaces expositions glissoires jardins jeux manèges parcs peuvent proposer spectacles thématiques"
                        },
                        {
                            "id": "713120",
                            "text": "Salles de jeux électroniques",
                            "keywords": "électroniques exploiter jeux salles"
                        }
                    ]
                },
                {
                    "id": "7132",
                    "text": "Jeux de hasard et loteries",
                    "keywords": "bingo casinos exploiter hasard hippodrome hors installations jeux loteries mutuels offrir paris salles services terminaux vidéo",
                    "children": [
                        {
                            "id": "713291",
                            "text": "Loteries",
                            "keywords": "appartenant auprès billets canaux consommateurs détail directement distribution eux exploités gouvernements loterie loteries organiser vendre"
                        },
                        {
                            "id": "713299",
                            "text": "Tous les autres jeux de hasard et loteries",
                            "keywords": "figurent hasard jeux loteries proposer"
                        },
                        {
                            "id": "713210",
                            "text": "Casinos (sauf hôtels-casinos)",
                            "keywords": "boissons casinos exploiter hasard hôtels-casinos installations jeu jeux machines repas servent tables trouve"
                        }
                    ]
                },
                {
                    "id": "7139",
                    "text": "Autres services de divertissement et de loisirs",
                    "keywords": "air centres clients conditionnement divertissement exploiter fermées figurent golf installations loisirs marinas notons offrir permettent physique plein quilles récréatives s'adonner salles services ski sport sports terrains",
                    "children": [
                        {
                            "id": "713910",
                            "text": "Terrains de golf et country clubs",
                            "keywords": "boissons clubs country cours donnent exploitent exploiter golf installations louent matériel parallèlement récréatives repas restaurants servent terrains"
                        },
                        {
                            "id": "713920",
                            "text": "Centres de ski",
                            "keywords": "alpin boissons centres cours donnent exploiter fond l'équipement louent matériel nécessaire remonte-pentes repas servent ski"
                        },
                        {
                            "id": "713930",
                            "text": "Marinas",
                            "keywords": "appelés bateaux carburant clubs connexes d'accastillage d'amarrage entretien éventuellement exploitent exploiter fournir gardiennage installations locations marinas nautiques plaisance propriétaires réparation services vente voile"
                        },
                        {
                            "id": "713940",
                            "text": "Centres de sports récréatifs et de conditionnement physique",
                            "keywords": "centres conditionnement culture exploiter forme installations l'exercice mettre natation patin physique pratiquer raquette récréatifs semblables sert sports"
                        },
                        {
                            "id": "713950",
                            "text": "Salles de quilles",
                            "keywords": "boissons exploiter quilles repas salles servent"
                        },
                        {
                            "id": "713991",
                            "text": "Équipes, ligues et clubs sportifs jouant devant un public non payant",
                            "keywords": "clubs boxe crosse football hockey motoneige natation patinage artistique soccer tennis squash tir carabine équitation escrime nautiques aviron voile canoë kayak"
                        },
                        {
                            "id": "713992",
                            "text": "Autres installations sportives",
                            "keywords": "champs tir entraînement pratique golf complexe escalade courts jeu boules aventures plein air exploitation installations descente rivière radeau pneumatique loisirs trampoline poursuite laser jeux balles peinture saut élastique volée fosse tyrolienne parcours normale trois pistes curling kart quais pêche salles bal danse billard ping-pong stands arc terrain miniature minigolf"
                        },
                        {
                            "id": "713999",
                            "text": "Toutes les autres industries du divertissement et du loisir",
                            "keywords": "entretenir appareils actionnés pièces autres jeux hasard locaux exploités divertissement exploitants stands aventures plein air rafting descente eau vive exploitation boîtes nuit discothèques camps jour été nudistes manèges guide touristique services jukebox installations tiers machines boules manèges fêtes foraines feux artifice location chevaux loisirs guide chasse tours observation"
                        }
                    ]
                }
            ]
        },
        {
            "id": "72",
            "text": "Services d'hébergement et de restauration",
            "keywords": "auberges boissons cabines campings camps centres chalets chasse clients commandés complémentaires consommation courte d'aventure différents durée fournir gîtes hébergement hôtels hôtels-casinos immédiate installations légers l'établissement l'extérieur l'hébergement loisirs motels parcs pêche personnes place plaisance préparer repas restauration routières services touristiques types vacanciers véhicules villégiature voyageurs",
            "children": [
                {
                    "id": "721",
                    "text": "Services d'hébergement",
                    "keywords": "air alors amateurs bon classés clients complémentaires comptent contractuelle courte d'activités définis destinées d'établissements d'exploitation d'hébergement d'installations dotés durée entente exploitent gamme génère gérées gestion hôtels importantes installations l'hébergement loisirs motels nature nombre offertes offrir outre personnel personnes peuvent plein prestation principalement rangés recettes restaurants selon services s'ils vacanciers vertu voyageurs",
                    "children": [
                        {
                            "id": "7211",
                            "text": "Hébergement des voyageurs",
                            "keywords": "auberges blanchisserie cabines centres chalets conférence congrès courte d'installations divers durée fournir gîtes hébergement hôtels hôtels-casinos l'hébergement motels offrir peuvent récréatifs restauration routières salles services stationnements touristiques types villégiature voyageurs",
                            "children": [
                                {
                                    "id": "721192",
                                    "text": "Chalets et cabines sans service",
                                    "keywords": "accès cabines chalets convenu courte d'appeler destinés donner durée héberger installations l'hébergement offrir pêche peuvent plages privées qu'il services vacanciers"
                                },
                                {
                                    "id": "721198",
                                    "text": "Tous les autres services d'hébergement des voyageurs",
                                    "keywords": "courte d'hébergement durée figurent l'hébergement offrir services voyageurs"
                                },
                                {
                                    "id": "721191",
                                    "text": "Gîtes touristiques",
                                    "keywords": "cachet caractérisent chambre chambres complet convenu courte d'appeler déjeuner d'hôtes direction durée fin fournissent gîtes historique immeubles installations l'hébergement l'inclusion maisons offrir personnalisé personnel petit petits privées prix propriétaire qu'il servi service touristiques transformés très unique"
                                },
                                {
                                    "id": "721120",
                                    "text": "Hôtels-casinos",
                                    "keywords": "caractérisent casino casinos commodités conférences congrès courte dotés durée fournissent gamme généralement hôtels hôtels-casinos installations jeu l'exploitation l'hébergement machines offrir paris peuvent piscines place restauration service services spectacles sportifs tables voiturier"
                                },
                                {
                                    "id": "721114",
                                    "text": "Motels",
                                    "keywords": "accès adjacents automobiles bâtiments caractérisent chambres clients commodités complémentaires convenu courte courts d'appeler destinés durée espaces étages extérieur gamme grands héberger installations l'entrée l'hébergement motels offrent offrir peuvent qu'il restreinte séjours services stationnement suites véhicules voyagent"
                                },
                                {
                                    "id": "721112",
                                    "text": "Auberges routières",
                                    "keywords": "accès auberges automobiles bâtiments caractérisent chambres clients commodités complémentaires convenu courte courts d'appeler destinés durée espaces faible gamme grandes grands hauteur héberger installations intérieur l'hébergement localisation offrent offrir peuvent pratiques qu'il restreinte routes routières séjours services stationnement suites véhicules voyagent"
                                },
                                {
                                    "id": "721113",
                                    "text": "Centres de villégiature",
                                    "keywords": "accès air centres chambres complet conférences convenu courte d'appeler destinés donnent durée généralement héberger installations lacs l'année l'hébergement l'intérieur loisirs milieu montagnes nature nombreuses offrent offrir place plein proximité qu'il rivières servant service suites tenue urbain vacanciers villégiature"
                                },
                                {
                                    "id": "721111",
                                    "text": "Hôtels",
                                    "keywords": "accessibles bâtiments blanchisserie chambres clients commodités complémentaires conférences congrès convenu courte culture d'appeler durée gamme généralement grande hauteur hôtels immeubles installations l'hébergement l'intérieur multiples niveaux offrent offrir physique piscines qu'il restauration salles services stationnement suites uniquement"
                                }
                            ]
                        },
                        {
                            "id": "7212",
                            "text": "Parcs pour véhicules récréatifs (VR) et camps de loisirs",
                            "keywords": "air amateurs camping camps chasse clients d'activités d'aventure définis d'hébergement d'installations divers gamme l'exploitation loisirs nature offertes parcs pêche plaisance plein s'adressent selon terrains types vacances véhicules",
                            "children": [
                                {
                                    "id": "721212",
                                    "text": "Camps de chasse et de pêche",
                                    "keywords": "boissons cabines camps chasse éloignés fournir fournitures gamme guides installations jusqu'aux l'accès l'exploitation nourriture offrent pêche peuvent repas services transport vendre"
                                },
                                {
                                    "id": "721213",
                                    "text": "Camps récréatifs et de vacances (sauf de chasse et de pêche)",
                                    "keywords": "air cabines camping camps chasse commodités d'aventure descentes d'hébergement eau enfants équestres excursions familiaux fixes fournissent installations l'équipement l'exploitation loisirs offrent organisées pêche pédestres plein randonnées récréatifs restauration services similaires terrains vacances vive"
                                },
                                {
                                    "id": "721211",
                                    "text": "Parcs pour véhicules récréatifs (VR) et campings",
                                    "keywords": "accès buanderies campeurs campings casse-croûte centres destinés diverses donner équipement équipements héberger installations l'exploitation magasins parcs peuvent plaisance récréatifs remorques roulottes services tentes terrains toilettes véhicules"
                                }
                            ]
                        },
                        {
                            "id": "7213",
                            "text": "Maisons de chambres et pensions de famille",
                            "keywords": "blanchisserie chambres complémentaires d'entretien d'installations durée famille fournir l'exploitation l'occupation logements longue maisons ménager offrent pensions peuvent repas résidence services servir similaires temporaires",
                            "children": [
                                {
                                    "id": "721310",
                                    "text": "Maisons de chambres et pensions de famille",
                                    "keywords": "blanchisserie chambres complémentaires d'entretien d'installations durée famille fournir l'exploitation l'occupation logements longue maisons ménager offrent pensions peuvent repas résidence services servir similaires temporaires"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "722",
                    "text": "Services de restauration et débits de boissons",
                    "keywords": "aéroports associations boissons centres citoyens clients commandés commerciaux consommation couvre d'attractions débits définis divers diverses faisant fonction fournis grands groupes hôtels immédiate installations légers l'établissement l'extérieur locaux loisirs loués magasins menées niveau offerts parcs partie place préparer repas restauration salles services sociales spectacles toutefois",
                    "children": [
                        {
                            "id": "7223",
                            "text": "Services de restauration spéciaux",
                            "keywords": "chariots chez client désigné fournir lieu moteur motorisés partir restauration services spéciaux véhicules",
                            "children": [
                                {
                                    "id": "722310",
                                    "text": "Services de restauration contractuels",
                                    "keywords": "aériennes chemin compagnies comptoirs contrat d'aliments déterminée durée entrepreneurs exploitent fer fournir installations institutions offrent restauration services similaires sportives vente vertu"
                                },
                                {
                                    "id": "722320",
                                    "text": "Traiteurs",
                                    "keywords": "administrent aliments cadre commerciales d'événements disposent fêtes finissants foires fournir généralement installations légers l'événement lieux mariages matériel offrent permanentes possèdent préparer repas restauration servant services traiteurs transporter véhicules"
                                },
                                {
                                    "id": "722330",
                                    "text": "Cantines et comptoirs mobiles",
                                    "keywords": "cantines chariots comptoirs consommation destinés immédiate légers mobiles moteur motorisés partir préparer repas servir véhicules"
                                }
                            ]
                        },
                        {
                            "id": "7224",
                            "text": "Débits de boissons alcoolisées",
                            "keywords": "alcoolisées bars boissons consommation convenu d'appeler débits destinées immédiate offrir peuvent préparer qu'il restauration restreints services servir tavernes",
                            "children": [
                                {
                                    "id": "722410",
                                    "text": "Débits de boissons alcoolisées",
                                    "keywords": "alcoolisées bars boissons consommation convenu d'appeler débits destinées immédiate offrir peuvent préparer qu'il restauration restreints services servir tavernes"
                                }
                            ]
                        },
                        {
                            "id": "7225",
                            "text": "Restaurants à service complet et établissements de restauration à service restreint",
                            "keywords": "addition alcoolisées alimentaires aliments bar boissons cafétéria client clients collations commandent complet comptoir consommés diversité établissement emporter exploiter extérieur livrés mangé manger mets offrir paient place préparer présenter produits règlent repas restaurants restauration restreint scène service services servir servis spéciales spectacles tables téléphone vendre vue",
                            "children": [
                                {
                                    "id": "722511",
                                    "text": "Restaurants à service complet",
                                    "keywords": "addition alcool alcoolisées bar bistro boissons buffet café chinois clients commandent complet cuisine débits dîner emporter exploiter familial fournir haute Internet mangé mets permis pizzerias préparer présenter règlent repas restaurant restaurants restauration salle salon-bar scène service services servir servis spectacles tables taverne vendre"
                                },
                                {
                                    "id": "722512",
                                    "text": "Établissements de restauration à service restreint",
                                    "keywords": "aéroports aire alcool alcoolisées alimentaire alimentaires aliments arénas bagels bar bars beigneries boissons boulangerie bretzels breuvage buffet café café-restaurant cafétéria cafétérias casse-croûte chien-chaud chinois client clients collations commandent comptoir comptoirs concédée concédées concession consommation consommés crème détail diversité douces emporter établissement établissements extérieur frit frites glace glacée hamburgers hot-dog immédiate installation installations jus kiosques laitiers liqueurs livrés magasin manger mets muffins nourriture oeufs offrir orange ouvertes paient panier-repas paniers-repas pâtisserie permis pizza pizzerias place poisson poulet poulets préparation production produits public rafraîchissements rapide restauration restaurant restauvolants restreint sandwich service services soupe sous-marins spéciales stand stands station-restaurant téléphone vente volant vue"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "id": "81",
            "text": "Autres services (sauf les administrations publiques)",
            "keywords": "administrations animaux appuyer automobiles blanchissage bon causes défendre développement diverses effectuer favoriser figurent fonctionnement fournir funéraires garantir intérêts l'entretien machines maison matériel membres ménages organiser particuliers personnels photos politiques préventif privés produits promouvoir publiques religieuses réparation services sociales soins subventions tirage véhicules",
            "children": [
                {
                    "id": "811",
                    "text": "Réparation et entretien",
                    "keywords": "automobiles correctement d'entretien effectuent effectuer entretien fonctionnent l'entretien machines matériel opérations préventif produits réparation réparations s'assurer véhicules",
                    "children": [
                        {
                            "id": "8111",
                            "text": "Réparation et entretien de véhicules automobiles",
                            "keywords": "automobiles camionnettes camions commerciales entretenir entretien remorques réparation réparer véhicules voitures",
                            "children": [
                                {
                                    "id": "811119",
                                    "text": "Autres services de réparation et d'entretien mécaniques et électriques de véhicules automobiles",
                                    "keywords": "automobiles d'entretien électriques figurent fournir mécaniques réparation services spécialisés véhicules"
                                },
                                {
                                    "id": "811121",
                                    "text": "Réparation et entretien de la carrosserie, de la peinture et de l'intérieur de véhicules automobiles",
                                    "keywords": "automobiles carrosserie entretien l'intérieur modifier peindre peinture réparation réparer véhicules"
                                },
                                {
                                    "id": "811111",
                                    "text": "Réparations générales de véhicules automobiles",
                                    "keywords": "automobiles d'échappement d'entretien électrique électriques éventail fournir générales l'entretien mécaniques moteur moteurs remplacement réparation réparations services spécialisent système tout transmission véhicules"
                                },
                                {
                                    "id": "811112",
                                    "text": "Réparation de systèmes d'échappement de véhicules automobiles",
                                    "keywords": "automobiles d'échappement remplacer réparation réparer systèmes véhicules"
                                },
                                {
                                    "id": "811122",
                                    "text": "Ateliers de remplacement de vitres de véhicules automobiles ",
                                    "keywords": "ateliers automobiles glaces pare-brise remplacement remplacer réparer véhicules"
                                },
                                {
                                    "id": "811192",
                                    "text": "Lave-autos",
                                    "keywords": "automobiles lave-autos laver nettoyer véhicules"
                                },
                                {
                                    "id": "811199",
                                    "text": "Tous les autres services de réparation et d'entretien de véhicules automobiles",
                                    "keywords": "automobiles d'entretien figurent fournir réparation services véhicules"
                                }
                            ]
                        },
                        {
                            "id": "8112",
                            "text": "Réparation et entretien de matériel électronique et de matériel de précision",
                            "keywords": "électronique entretenir entretien instruments matériel précision réparation réparer",
                            "children": [
                                {
                                    "id": "811210",
                                    "text": "Réparation et entretien de matériel électronique et de matériel de précision",
                                    "keywords": "électronique entretenir entretien instruments matériel précision réparation réparer"
                                }
                            ]
                        },
                        {
                            "id": "8113",
                            "text": "Réparation et entretien de machines et de matériel d'usage commercial et industriel (sauf les véhicules automobiles et le matériel électronique)",
                            "keywords": "automobile automobiles commercial d'usage électronique entretenir entretien industriel l'exception machines matériel réparation réparer usage véhicules",
                            "children": [
                                {
                                    "id": "811310",
                                    "text": "Réparation et entretien de machines et de matériel d'usage commercial et industriel (sauf les véhicules automobiles et le matériel électronique)",
                                    "keywords": "automobile automobiles commercial d'usage électronique entretenir entretien industriel l'exception machines matériel réparation réparer usage véhicules"
                                }
                            ]
                        },
                        {
                            "id": "8114",
                            "text": "Réparation et entretien d'articles personnels et ménagers",
                            "keywords": "appareils articles bateaux bicyclettes bijoux chaussures cuir d'articles entretenir entretien instruments jardin maison matériel ménagers meubles montres musique personnels plaisance réparation réparer vêtements",
                            "children": [
                                {
                                    "id": "811490",
                                    "text": "Autres services de réparation et d'entretien d'articles personnels et ménagers",
                                    "keywords": "articles d'articles d'entretien détail entretenir figurent matériel ménagers personnels réparation réparer services vente"
                                },
                                {
                                    "id": "811420",
                                    "text": "Rembourrage et réparation de meubles",
                                    "keywords": "détail matériel meubles rembourrage rembourrer rénover réparation réparer restaurer vente"
                                },
                                {
                                    "id": "811430",
                                    "text": "Réparation de chaussures et de maroquinerie",
                                    "keywords": "articles chaussures cuir main mallettes maroquinerie réparation réparer sacs simili-cuir"
                                },
                                {
                                    "id": "811412",
                                    "text": "Réparation et entretien d'appareils ménagers",
                                    "keywords": "appareils d'appareils détail entretenir entretien matériel ménagers réparation réparer vente"
                                },
                                {
                                    "id": "811411",
                                    "text": "Réparation et entretien de matériel de maison et de jardin",
                                    "keywords": "détail entretenir entretien jardin maison matériel réparation réparer vente"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "812",
                    "text": "Services personnels et services de blanchissage",
                    "keywords": "animaux blanchissage blanchisserie compagnie développement exploitants fournir funéraires parcs personnels photos services soins stationnement tirage",
                    "children": [
                        {
                            "id": "8121",
                            "text": "Services de soins personnels",
                            "keywords": "capillaire chevelu coiffure conseil cuir d'esthétique diététique fournir massage oreilles perçage personnels remplacement services soins traitement",
                            "children": [
                                {
                                    "id": "812190",
                                    "text": "Autres services de soins personnels",
                                    "keywords": "figurent fournir personnels services soins"
                                },
                                {
                                    "id": "812114",
                                    "text": "Salons de coiffure pour hommes",
                                    "keywords": "barbe capillaires cheveux coiffage coiffure coupe fournir hommes moustaches rasage salons services soins taille"
                                },
                                {
                                    "id": "812115",
                                    "text": "Salons de beauté",
                                    "keywords": "beauté capillaires d'esthétique femmes fournir manucures pédicures salons services soins"
                                },
                                {
                                    "id": "812116",
                                    "text": "Salons de coiffure unisexes ",
                                    "keywords": "capillaires cheveux coiffer coiffure couper d'esthétique femmes fournissent hommes mixtes salons services soins"
                                }
                            ]
                        },
                        {
                            "id": "8122",
                            "text": "Services funéraires",
                            "keywords": "animales cimetières crémation crématoriums défuntes dépouilles exploiter fournir funérailles funéraires humaines inhumation installations lieux l'inhumation notons organiser personnes préparer réserve salons services",
                            "children": [
                                {
                                    "id": "812210",
                                    "text": "Salons funéraires",
                                    "keywords": "défuntes funérailles funéraires inhumation organiser personnes préparer salons"
                                },
                                {
                                    "id": "812220",
                                    "text": "Cimetières et crématoriums",
                                    "keywords": "animales cimetières crémation crématoriums défunts dépouilles exploiter humaines installations lieux l'inhumation réserve"
                                }
                            ]
                        },
                        {
                            "id": "8123",
                            "text": "Services de nettoyage à sec et de blanchissage",
                            "keywords": "articles blanchissage disposition fournir installations libre-service linge louer maison mettre nettoyage nettoyer public sec services tissu uniformes",
                            "children": [
                                {
                                    "id": "812330",
                                    "text": "Fourniture de linge et d'uniformes",
                                    "keywords": "commerciaux contrat couches d'entreprise d'intérieur draps d'uniformes fourniture gants ignifugés industriels laboratoire linge louent louer nappes nettoient nettoyer peignoirs pièces protection serviettes table tabliers termes toilette uniformes vêtements"
                                },
                                {
                                    "id": "812320",
                                    "text": "Services de nettoyage à sec et de blanchissage (sauf le libre-service)",
                                    "keywords": "articles blanchissage cuir entreposer fourrures genre indépendants installations laver laveries libre-service linge livraison maison mécanisées nettoyage nettoyer peuvent ramassage réparer repasser retoucher sec services tout uniformes vêtements"
                                },
                                {
                                    "id": "812310",
                                    "text": "Blanchisseries et nettoyeurs à sec libre-service",
                                    "keywords": "blanchissage blanchisseries disposition installations laver libre-service machines mettre nettoyage nettoyeurs payantes public sec"
                                }
                            ]
                        },
                        {
                            "id": "8129",
                            "text": "Autres services personnels",
                            "keywords": "animaux compagnie développement figurent fournir personnels photos services soins stationnement tirage",
                            "children": [
                                {
                                    "id": "812990",
                                    "text": "Tous les autres services personnels",
                                    "keywords": "figurent fournir personnels services"
                                },
                                {
                                    "id": "812930",
                                    "text": "Stationnements et garages",
                                    "keywords": "automobiles base exploiter fournissent garages généralement horaire journalière mensuelle parcs services stationnement stationnements temporaire véhicules"
                                },
                                {
                                    "id": "812921",
                                    "text": "Laboratoires de développement et de tirage de photos (sauf le service en une heure)",
                                    "keywords": "agrandissements appelés commerciaux développement développer diapositives entreprises épreuves fournir grande heure laboratoires minute normalement photographies photos professionnels quantité service services spécialisés tirage trouve"
                                },
                                {
                                    "id": "812922",
                                    "text": "Développement et tirage de photos en une heure",
                                    "keywords": "appelés automatisés centres commerciaux d'appareils développement développer endroits grand heure laboratoires matériel minute moyen photographies photographique photos pratiques public tirage tirer trouve vendent"
                                },
                                {
                                    "id": "812910",
                                    "text": "Soins pour animaux de maison (sauf vétérinaires)",
                                    "keywords": "animaux compagnie dressage fournir garde maison services soins toilettage vétérinaires"
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": "813",
                    "text": "Organismes religieux, fondations, groupes de citoyens et organisations professionnelles et similaires",
                    "keywords": "biais causes citoyens défendre diverses favoriser fondations groupes intérêts membres organisations organiser organismes politiques professionnelles promouvoir religieuses religieux similaires sociales soutenir subventions",
                    "children": [
                        {
                            "id": "813990",
                            "text": "Autres associations",
                            "keywords": "associations figurent intérêts membres promouvoir"
                        },
                        {
                            "id": "813930",
                            "text": "Organisations syndicales",
                            "keywords": "améliorer conditions employés employeurs entre membres mènent négociations organisations régir relations revenu syndicales travail"
                        },
                        {
                            "id": "813940",
                            "text": "Organisations politiques",
                            "keywords": "candidat candidats fonds groupes intérêts l'échelle l'intérêt locale nationale organisations organisés parti partis politique politiques promouvoir provinciale recueillir"
                        },
                        {
                            "id": "813910",
                            "text": "Associations de gens d'affaires",
                            "keywords": "associations bulletins commerciaux d'affaires d'agrément effectuer favoriser gens intérêts l'établissement marché membres normes nouveaux peuvent produits promouvoir publier qualité recherches recueillir services statistiques"
                        },
                        {
                            "id": "813410",
                            "text": "Organisations civiques et sociales ",
                            "keywords": "amicales bars buts civils civiques exploiter fournir intérêts membres organisations peuvent promouvoir récréatifs restaurants services sociaux"
                        },
                        {
                            "id": "813310",
                            "text": "Organismes d'action sociale",
                            "keywords": "adhérents cause contributions d'action défendre l'intérêt organismes particulière peuvent politique population précis recruter sociale solliciter soutenir"
                        },
                        {
                            "id": "813210",
                            "text": "Fondations et organismes de charité",
                            "keywords": "afin aides aspects charité compte contributions culture d'activités d'autrui éventail fiducie financières fondations fonds large l'éducation octroyer organismes partir santé science sociaux solliciter soutenir trait"
                        },
                        {
                            "id": "813110",
                            "text": "Organismes religieux",
                            "keywords": "consacrent diffuser études exploiter forme l'enseignement organisée organismes promouvoir religieuses religieux religion"
                        },
                        {
                            "id": "813920",
                            "text": "Organisations professionnelles",
                            "keywords": "défendre entière intérêts membres organisations profession professionnelles professionnels tout"
                        }
                    ]
                },
                {
                    "id": "814",
                    "text": "Ménages privés",
                    "keywords": "bonnes chambre chargées conduite cuisiniers d'enfants effectuer emploient femmes gardiennes gardiens jardiniers l'entretien l'extérieur l'intérieur maison majordomes ménages personnel personnes principalement privés services trait travailler",
                    "children": [
                        {
                            "id": "814110",
                            "text": "Ménages privés",
                            "keywords": "bonnes chambre chargées conduite cuisiniers d'enfants effectuer emploient femmes gardiennes gardiens jardiniers l'entretien l'extérieur l'intérieur maison majordomes ménages personnel personnes principalement privés services trait travailler"
                        }
                    ]
                }
            ]
        },
        {
            "id": "91",
            "text": "Administrations publiques",
            "keywords": "administration administrations affaires classés classification critère d'activités d'application défense d'immigration disponibles données établis étrangères exercent exercer gouvernementale gouvernementales ici identifier internationale interprétation judiciaire l'administration l'aide législatifs lois l'ordre maintien nationale nature n'est peuvent privés programmes promulgation propriété publics publiques purement régime règlements sécurité séparées services similaires taxation",
            "children": [
                {
                    "id": "911",
                    "text": "Administration publique fédérale",
                    "keywords": "administration affaires défense d'immigration étrangères fédérale gouvernementaux internationale judiciaires l'administration l'aide législatifs l'ordre nationale nature notons principales programmes publics publique sécurité services taxation",
                    "children": [
                        {
                            "id": "911320",
                            "text": "Services d'immigration",
                            "keywords": "aider contrôler d'immigration fédérale immigrants l'administration l'entrée l'immigration pays personnes promouvoir services"
                        },
                        {
                            "id": "911240",
                            "text": "Services de réglementation fédéraux",
                            "keywords": "abus assurer collectif fédérale fédéraux individuel l'administration l'exploitation négligence personnes protection réglementation services titre"
                        },
                        {
                            "id": "911290",
                            "text": "Autres services de protection fédéraux",
                            "keywords": "animaux catastrophes d'urgence fédérale fédéraux figurent intervenir l'administration lors lutte majeures nuisibles prestation protection ravageurs services situations"
                        },
                        {
                            "id": "911230",
                            "text": "Services de police fédéraux",
                            "keywords": "assurer fédérale fédéraux forces l'administration l'entremise loi l'ordre maintien police public respect services"
                        },
                        {
                            "id": "911410",
                            "text": "Affaires étrangères",
                            "keywords": "affaires canada entre étrangères étrangers fédérale gouvernement l'administration l'établissement officielles pays promouvoir relations"
                        },
                        {
                            "id": "911420",
                            "text": "Aide internationale",
                            "keywords": "aide conditions développement économique étrangers favoriser fédérale internationale l'administration l'amélioration pays sociales"
                        },
                        {
                            "id": "911390",
                            "text": "Autres services fédéraux relatifs à la main-d'oeuvre, à l'emploi et à l'immigration",
                            "keywords": "axées chargés citoyens englobe fédéraux l'emploi l'enregistrement l'immigration main-d'oeuvre ministères organismes prestation promotion services travail"
                        },
                        {
                            "id": "911310",
                            "text": "Services fédéraux relatifs à la main-d'oeuvre et à l'emploi",
                            "keywords": "améliorées collectives conciliation conditions d'arbitrage employeur-employé études fédérale fédéraux l'administration l'emploi lors main-d'oeuvre marché mener négociations prestation promotion questions relations services touchant traiter travail"
                        },
                        {
                            "id": "911110",
                            "text": "Services de défense",
                            "keywords": "armées canadiennes civils défense forces fournir organismes services"
                        },
                        {
                            "id": "911210",
                            "text": "Tribunaux fédéraux",
                            "keywords": "civiles commissions compétence d'appel d'arbitrage fédérale fédéraux fournir interpréter jugements l'administration loi lors poursuites rendre services tribunaux"
                        },
                        {
                            "id": "911220",
                            "text": "Services correctionnels fédéraux",
                            "keywords": "correctionnels détention d'incarcération fédérale fédéraux fournir l'administration prisons réadaptation services"
                        },
                        {
                            "id": "911910",
                            "text": "Autres services de l'administration publique fédérale",
                            "keywords": "administration administrations connexes dette domaines établissement exécutif fédérale figurent financières gouvernements impôts l'administration législatif levée l'un maintien politiques pouvoir programmes publique recouvrement relations services suivants taxes touche"
                        }
                    ]
                },
                {
                    "id": "912",
                    "text": "Administrations publiques provinciales et territoriales",
                    "keywords": "administrations gouvernementale gouvernementaux judiciaires l'administration législatifs l'ordre maintien mener nature notons programmes provinces provinciales publics publiques sécurité services taxation territoires territoriales",
                    "children": [
                        {
                            "id": "912150",
                            "text": "Services de réglementation provinciaux",
                            "keywords": "abus administrations assurer collectif individuel l'exploitation négligence personnes protection provinciales provinciaux réglementation services territoriales titre"
                        },
                        {
                            "id": "912210",
                            "text": "Services provinciaux relatifs à la main-d'oeuvre et à l'emploi",
                            "keywords": "administrations améliorées collectives conciliation conditions d'arbitrage employeur-employé études incluant l'emploi lors main-d'oeuvre marché mener négociations prestation promotion provinciales provinciaux questions relations services territoriales touchant traiter travail"
                        },
                        {
                            "id": "912110",
                            "text": "Tribunaux provinciaux",
                            "keywords": "administrations civiles commissions compétence d'appel d'arbitrage fournir interpréter jugements loi lors poursuites provinciale provinciales provinciaux rendre services territoriales tribunaux"
                        },
                        {
                            "id": "912120",
                            "text": "Services correctionnels provinciaux",
                            "keywords": "administrations correctionnels détention d'incarcération exploiter fournir prisons provinciales provinciaux réadaptation services territoriales"
                        },
                        {
                            "id": "912130",
                            "text": "Services de police provinciaux",
                            "keywords": "administrations assurer forces l'entremise loi l'ordre maintien police provinciales provinciaux public respect services territoriales"
                        },
                        {
                            "id": "912140",
                            "text": "Services provinciaux de lutte contre les incendies",
                            "keywords": "administrations enquêtes éteindre incendies lutte mener prévenir provinciales provinciaux services s'imposent territoriales"
                        },
                        {
                            "id": "912190",
                            "text": "Autres services de protection provinciaux",
                            "keywords": "administrations animaux catastrophes d'urgence figurent intervenir lors lutte majeures nuisibles prestation protection provinciales provinciaux ravageurs services situations territoriales"
                        },
                        {
                            "id": "912910",
                            "text": "Autres services des administrations publiques provinciales et territoriales",
                            "keywords": "administration administrations connexes dette domaines établissement exécutif figurent financières gouvernements impôts l'administration législatif levée l'un maintien politiques pouvoir programmes provinciales publique publiques recouvrement relations services suivants taxes territoriales touche"
                        }
                    ]
                },
                {
                    "id": "913",
                    "text": "Administrations publiques locales, municipales et régionales",
                    "keywords": "administration administrations gouvernementale législatives locales l'ordre maintien municipales nature programmes publics publiques régionales sécurité taxation",
                    "children": [
                        {
                            "id": "913110",
                            "text": "Cours municipales",
                            "keywords": "administrations civiles cours d'arbitrage interpréter jugements locales loi lors municipales offrir poursuites rendre services"
                        },
                        {
                            "id": "913120",
                            "text": "Services correctionnels municipaux",
                            "keywords": "administrations correctionnels détention d'incarcération fournir locales municipaux prisons réadaptation services"
                        },
                        {
                            "id": "913130",
                            "text": "Services de police municipaux",
                            "keywords": "administrations assurer forces l'entremise locales loi l'ordre maintien municipaux police public respect services"
                        },
                        {
                            "id": "913140",
                            "text": "Services municipaux de lutte contre les incendies",
                            "keywords": "administrations enquêtes éteindre incendies locales lutte mener municipaux prévenir services s'imposent"
                        },
                        {
                            "id": "913150",
                            "text": "Services de réglementation municipaux",
                            "keywords": "abus administrations assurer collectif individuel l'exploitation locales municipaux négligence personnes protection réglementation services titre"
                        },
                        {
                            "id": "913190",
                            "text": "Autres services de protection municipaux",
                            "keywords": "administrations animaux catastrophes d'urgence figurent intervenir locales lors lutte majeures municipaux nuisibles prestation protection ravageurs services situations"
                        },
                        {
                            "id": "913910",
                            "text": "Autres services des administrations publiques locales, municipales et régionales",
                            "keywords": "administration administrations connexes dette domaines établissement exécutif figurent financières gouvernements impôts l'administration législatif levée locales l'un maintien municipales planification politiques pouvoir programmes publique publiques recouvrement régionales relations services suivants taxes touche"
                        }
                    ]
                },
                {
                    "id": "914",
                    "text": "Administrations publiques autochtones",
                    "keywords": "administrations assurés autochtones autrement commettants éventail fédérale gouvernementaux municipales offrir provinciales publiques seraient services vaste",
                    "children": [
                        {
                            "id": "914110",
                            "text": "Administrations publiques autochtones",
                            "keywords": "administrations assurés autochtones autrement commettants éventail fédérale gouvernementaux municipales offrir provinciales publiques seraient services vaste"
                        }
                    ]
                },
                {
                    "id": "919",
                    "text": "Organismes publics internationaux et autres organismes publics extra-territoriaux",
                    "keywords": "consulaires diplomatiques étrangers extra-territoriaux gouvernementale gouvernements internationaux légation missions nature offrir organismes publics services situés sol",
                    "children": [
                        {
                            "id": "919110",
                            "text": "Organismes publics internationaux et autres organismes publics extra-territoriaux",
                            "keywords": "consulaires diplomatiques étrangers extra-territoriaux gouvernementale gouvernements internationaux légation missions nature offrir organismes publics services situés sol"
                        }
                    ]
                }
            ]
        }
    ]
